import i18n from "@/plugins/i18n";
import router from "@/router";
import moment from "moment";
import vuetify from "@/plugins/vuetify";
import Highcharts from "highcharts";
import logoBoson from "@/assets/LogoBosonWhite.png";
import avatar from "@/assets/avatar-btn.png";
import axios from "axios";
import "moment/locale/es";
import MarkerClusterer from "@googlemaps/markerclustererplus";

var formatNumber = {
  separador: ",", // separador para los miles
  sepDecimal: ".", // separador para los decimales
  formatear: function(num) {
    num += "";
    var splitStr = num.split(".");
    var splitLeft = splitStr[0];
    var splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : "";
    var regx = /(\d+)(\d{3})/;
    while (regx.test(splitLeft)) {
      splitLeft = splitLeft.replace(regx, "$1" + this.separador + "$2");
    }
    return splitLeft + splitRight + " " + this.simbol;
  },
  new: function(num, simbol) {
    this.simbol = simbol || "";
    return this.formatear(num);
  },
};

//converts seconds to 0D,00:00:00
var splitTimeInMutations = {
  splitSeconds: function (seconds) {
    //default response
    let secondsFormatted = "0D, 00:00:00";

    try {
      if (seconds > 0) {
        let days = Math.floor(seconds / (3600 * 24));
        let hours = Math.floor((seconds % (3600 * 24)) / 3600);
        let minutes = Math.floor((seconds % 3600) / 60);
        let remainingSeconds = Math.round(seconds % 60);

        if (hours < 10) hours = "0" + hours.toString();
        if (minutes < 10) minutes = "0" + minutes.toString();
        if (remainingSeconds < 10) remainingSeconds = "0" + remainingSeconds.toString();

        secondsFormatted = `${days}D, ${hours}:${minutes}:${remainingSeconds}`;
      }

      return secondsFormatted;

    } catch {
      return secondsFormatted;
    }
  },
};

let formatDate = {
  //formatea las fechas a DD/MMM/YYYY HH:mm, ej. 21/may/2024 10:00 (español) y MMM/DD/YYYY HH:mm, ej. may/21/2024 10:00 (inglés)
  dateCustom: function (value) {
    let formattedDate = "";

    //formato en que llega value (fecha de ws)
    let originalDateFormat = "YYYY-MM-DD HH:mm";

    if (value.includes("T")) {
      originalDateFormat = "YYYY-MM-DDTHH:mm";
    }

    let lang = localStorage.getItem("language");

    //formato que se le dará a la fecha dependiendo del idioma
    let dateFormat = lang == "en" ? "MMM/DD/YYYY HH:mm" : "DD/MMM/YYYY HH:mm";

    //se crea un moment con la fecha recibida y el formato que se le dará a la fecha dependiendo del idioma
    let dateAsMoment = moment(value, originalDateFormat).format();

    if (dateAsMoment === "Invalid date") {
      return value;
    } else {
      formattedDate = moment(dateAsMoment, originalDateFormat).format(dateFormat);
      formattedDate = formattedDate.replace(".", "");
      return formattedDate;
    }
  },
};

let validate = {
  //Función donde se establecen las reglas para validar el valor de DB del campo Reference
  isValidReferenceValue: function (reference) {
    try {
      if (reference.length >= 5 && reference != "- o -") return true;
        else return false;

    } catch (e) {
      return false;
    }
  }
};

export default {
  //When window is resized style in some elements will be changed
  onResize: (state) => {
    state.windowSize = { width: window.innerWidth, height: window.innerHeight };
    //style for principal view
    if (state.windowSize.width < 530) {
      state.globalStyle =
        "margin-top: 10px; will-change: padding !important; padding: 80px 0px 0px 0px !important;";
      state.appDrawerStyle = state.mini
        ? "z-index: 9; position: fixed;transform: translateX(-80px);"
        : "z-index: 9; position: fixed;transform: translateX(0px);";
      state.periodDatesTitleAF = "";

      state.styleFV = "inherit";
      state.trackingTable = 3;
      state.footerProps = {
        "items-per-page-options": [3, 5],
        "items-per-page-text": i18n.t("rows"),
      };
      state.backButton =
        "position: absolute;z-index: 8; margin-top: 20%;margin-left: 12px;";
      state.commandAndRepButton =
        "position: absolute;z-index: 8; top: 35%;right: 3%;display:grid;";
      // state.showVehTable =
      //   "bottom: 7% !important;position: absolute;z-index: 8;margin-left: 0px;min-width: 28px !important;width: 48px;";
      state.styleText =
        "flex-grow: 1; padding: 20px; overflow: auto; padding-top: 10px; overflow-y: scroll; max-height: calc(100vh - 750px);min-height: calc(100vh - 684px);font-size: 13px;text-align: initial;";
      state.styleTextReports =
        "color: black;flex-grow: 1;padding: 10px 20px 20px;overflow: auto scroll;max-height: calc(100vh - 533px);";
      state.cardTitleIF = "font-size: 1.3rem!important;";
      state.paddingLeftSecondaryT = "padding-left: 0!important";
      state.navIconSecondaryT = "margin-left: -12px !important";
    } else {
      state.styleFV = "absolute";
      state.trackingTable = 5;
      state.footerProps = {
        "items-per-page-options": [3, 5, 10],
        "items-per-page-text": i18n.t("rows"),
      };
      state.cardTitleIF = "font-size: 1.5rem!important;";
      state.paddingLeftSecondaryT = "padding-left: 20px!important";
      state.navIconSecondaryT = "margin-left: 0px !important";
      state.backButton =
        "position: absolute;z-index: 8; margin-top: 80px;margin-left: 15px;";
      state.commandAndRepButton =
        "position: absolute;z-index: 8; top: 148px;right: 6px;display:grid;";
      //  state.showVehTable =
      //   "bottom: 0% !important;position: absolute;z-index: 8;margin-left: 0px;min-width: 28px !important;width: 48px;";
      state.styleText =
        "flex-grow: 1; padding: 20px; overflow: auto; padding-top: 10px; overflow-y: scroll; max-height: calc(100vh - 750px);min-height: calc(100vh - 751px);font-size: 13px;text-align: initial;";
      state.styleTextReports =
        "color: black;flex-grow: 1;padding: 10px 20px 20px;overflow: auto scroll;max-height: calc(100vh - 605px);";
      state.globalStyle =
        "margin-top: 10px; will-change: padding !important; padding: 80px 0px 0px 80px !important;";
      state.appDrawerStyle =
        "z-index: 9; position: fixed;transform: translateX(0px);";


      //Uso de calendario en alertfuel
      var dateCalendar1AF = localStorage.getItem("startDateAF");
      var dateCalendar2AF = localStorage.getItem("endDateAF");
      if (dateCalendar1AF == undefined && dateCalendar2AF == undefined) {
        state.periodDatesTitleAF = i18n.t("today").toUpperCase();
      } else {
        if (dateCalendar2AF == null) {
          var today = moment().format("YYYY-MM-DD");
          if (dateCalendar1AF == today) {
            state.periodDatesTitleAF = i18n.t("today").toUpperCase();
          } else {
            state.periodDatesTitleAF = moment(dateCalendar1AF)
              .locale(i18n.locale)
              .format("ll");
          }
        } else {
          state.periodDatesTitleAF =
            moment(dateCalendar1AF)
              .locale(i18n.locale)
              .format("ll") +
            " " +
            i18n.t("to") +
            " " +
            moment(dateCalendar2AF)
              .locale(i18n.locale)
              .format("ll");
        }
      }
    }

    //Style for stepper in reports
    if (state.windowSize.width >= 1264) {
      state.styleComponent = "height: 7px;width: 30%;position: absolute;";
    }

    if (state.windowSize.width < 1264) {
      state.styleComponent = "height: 7px;width: 50%;position: absolute;";
    }
    
    if (state.windowSize.width < 530) {
      state.styleComponent = "height: 7px;width: 60%;position: absolute;";
      //Style for personalization component
      state.styleTab = "min-width: 50px; max-width: 50px;";
      state.styleColorPicker = "padding: 0; margin-left: 0px!important";
    } else {
      state.styleTab = "";
    }

    if (state.windowSize.width < 400 && state.windowSize.height > 412) {
      state.colorPickerWidth = "max-width: 238px";
    } else if (
      state.windowSize.width <= 824 &&
      state.windowSize.height <= 411
    ) {
      state.colorPickerWidth = "max-width: 500px";
    } else {
      state.colorPickerWidth = "";
    }

    if (state.windowSize.width > 529 && state.windowSize.width < 650) {
      state.styleComponent = "height: 7px;width: 55%;position: absolute;";
    }

    if (state.windowSize.width >= 600 && state.windowSize.width < 650) {
      state.styleComponent = "height: 7px;width: 50%;position: absolute;";
    }

    if (state.windowSize.width < 824) {
      state.visible = false;
      state.dealerAttach = ".dealer";
      state.clientAttach = ".client";
      state.accountAttach = ".account";
      state.groupAttach = ".group";
    } else {
      state.visible = true;
      state.dealerAttach = false;
      state.clientAttach = false;
      state.accountAttach = false;
      state.groupAttach = false;
    }

    if (state.windowSize.width < 320) {
      state.showTxtOp = false;
    } else {
      state.showTxtOp = true;
    }

    if (state.windowSize.width < 400) {
      state.fontSize = "10.5px";
      state.fontsizeTxtt = "10.5px";
    } else {
      state.fontSize = "12px";
      state.fontsizeTxtt = "14px";
    }

    if (state.windowSize.width <= 320) {
      state.alignchart = "left";
      state.xchart = -15;
      state.itemDistanceFuelRange = 10;
      state.itemDistanceExceptions = 0;
    } else {
      state.alignchart = "center";
      state.xchart = 0;
      state.itemDistanceFuelRange = 20;
      state.itemDistanceExceptions = 20;
    }

    // if (state.windowSize.width >= 1260 && state.windowSize.width <= 1410) {
    //   state.fontsizecard = "font-size: 13px !important;";
    // } else {
    //   state.fontsizecard = "font-size: 16px !important;";
    // }

    // if (state.windowSize.width >= 1260 && state.windowSize.width <= 1580) {
    //   state.fontsizesub = "font-size: 28px;";
    // } else {
    //   state.fontsizesub = "font-size: 28px;";
    // }

    if (state.windowSize.width < 500) {
      state.styleLogo = "margin: 0px; width: 25rem; max-width: 70%;";
    }

    if (state.windowSize.width > 499 && state.windowSize.height < 774) {
      state.styleMargin = "margin: 0;";
      state.styleListOfAccess =
        "max-height: 67%;overflow-y: scroll;height: 307px;max-width: 100%;display: inline-block;";
      state.worldVisible = false;
    } else {
      state.worldVisible = true;
    }
  },
  setPermissions: (state, payload) => {
    state.permissions = payload;
  },
  dialogstate: (state, payload) => {
    state.dialog = !state.dialog;
    state.pestañas = [];
  },
  showMessage: (state, payload) => {
    state.finish = payload[0];
    state.showMessage = payload[1];
  },

  //Función para mostrar el texto del periodo seleccionado en botón de secondaryToolbar
  setPeriodTitleDates: (state, payload) => {
    let dateFormat = i18n.locale == "en" ? "MMM/DD/YYYY" : "DD/MMM/YYYY";

    if (payload.length == 2) {
      //existen 2 fechas
      if (moment(payload[0]).isBefore(payload[1])) {
        state.periodDatesTitle = `
            ${moment(payload[0], "YYYY-MM-DD").format(dateFormat)} ${state.startClock}
            ${i18n.t("to")}
            ${moment(payload[1], "YYYY-MM-DD").format(dateFormat)} ${state.endClock}
          `;

        state.datesCalendar = [payload[0], payload[1]];
        
      } else {
        state.periodDatesTitle = `
            ${moment(payload[1], "YYYY-MM-DD").format(dateFormat)} ${state.startClock}
            ${i18n.t("to")}
            ${moment(payload[0], "YYYY-MM-DD").format(dateFormat)} ${state.endClock}
          `;

        state.datesCalendar = [payload[1], payload[0]];
      }

      localStorage.setItem("datesCalendar1", state.datesCalendar[0]);
      localStorage.setItem("datesCalendar2", state.datesCalendar[1]);
      if (i18n.locale != "en") state.periodDatesTitle = state.periodDatesTitle.replaceAll(".", "");

    } else {
      //solo hay 1 fecha
      var today = moment().format("YYYY-MM-DD");
        if (payload[0] == today) {
          state.periodDatesTitle = i18n.t("today").toUpperCase();
        } else {
          state.periodDatesTitle = `
            ${moment(payload[0], "YYYY-MM-DD").format(dateFormat)} ${state.startClock}
            ${i18n.t("to")}
            ${moment(payload[0], "YYYY-MM-DD").format(dateFormat)} ${state.endClock}
          `;
        }

      state.datesCalendar = payload;
      localStorage.setItem("datesCalendar1", state.datesCalendar[0]);
      localStorage.removeItem("datesCalendar2");
      if (i18n.locale != "en") state.periodDatesTitle = state.periodDatesTitle.replace(".", "");
    }
  },

  setDatesBetween: (state, payload) => {
    state.datesBetween = payload;
  },
  userEntry: (state, user) => {
    state.username = user;
  },
  passEntry: (state, pass) => {
    state.password = pass;
  },
  progresslogin: (state, payload) => {
    state.progresslogin = payload;
  },
  loginBtn: (state, payload) => {
    state.loginBtn = payload;
  },
  selectedAccessEntry: (state, access) => {
    var AccessSelect = access;
    state.multipleUserData.forEach((element) => {
      if (element.AccessId == AccessSelect.AccessId) {
        state.SelectedAccess = element;
        localStorage.setItem(
          "SelectedAccess",
          JSON.stringify(state.SelectedAccess)
        );

        localStorage.setItem(
          "UserDataAccessList",
          JSON.stringify(state.SelectedAccess)
        );
      }
    });
  },
  selectedAccessValue: (state, value) => {
    state.selectedVal = value;
  },
  responseLogin: (state, userData) => {
    state.userData = userData;
    localStorage.setItem("userData", JSON.stringify(state.userData));
    if (userData.UserAccessList.length > 1) {
      state.multipleUserData = userData.UserAccessList;
      state.multipleAccess = true;
    } else {
      state.multipleAccess = false;
    }
  },
  getToken: (state, payload) => {
    localStorage.setItem("auth", true);
    state.authenticated = true;
    state.tokenInfo = payload[0];
    state.SelectedAccess = payload[1];
    localStorage.setItem(
      "SelectedAccess",
      JSON.stringify(state.SelectedAccess)
    );
    state.token = payload[0].access_token;
    state.refreshToken = payload[0].refresh_token;
  },
  auth: (state, payload) => {
    localStorage.setItem("auth", payload);
    state.authenticated = payload;
    if (!payload) {
      state.dealerSelected = {};
      state.clientSelected = {};
      state.accountSelected = {};
      state.groupSelected = {};
      router.replace({ name: "login" });
      localStorage.setItem("start", false);
    }
  },
  cancelMultipleAccess: (state) => {
    state.multipleAccess = false;
  },
  setLastUser: (state, LastUser) => {
    state.LastUserDate = LastUser.date;
  },
  sessionexp: (state, sessionexp) => {
    state.sessionexp = sessionexp;
  },
  errorMessage: (state, payload) => {
    state.errorMessageText = payload[0];
    state.errorMessage = payload[1];
  },
  setAccount: (state, payload) => {
    if (state.SelectedAccess.Level != "Master") {
      state.DealerId = state.SelectedAccess.DealerId;
    } else {
      if (
        state.dealerSelected.DealerId != undefined &&
        state.dealerSelected.DealerId != i18n.t("all")
      ) {
        state.DealerId = state.dealerSelected.DealerId;
      }
    }

    //Save all access selected
    localStorage.setItem("DealerId", state.DealerId);
    if (Object.keys(state.dealerSelected).length > 0) {
      localStorage.setItem(
        "DealerSelectedId",
        JSON.stringify(state.dealerSelected)
      );
      localStorage.setItem("Dealer_Id", state.DealerId);
    }
    if (Object.keys(state.clientSelected).length > 0) {
      localStorage.setItem(
        "ClientSelectedId",
        JSON.stringify(state.clientSelected)
      );
      localStorage.setItem("Client_Id", state.clientSelected.ClientId);
    }
    if (Object.keys(state.accountSelected).length > 0) {
      localStorage.setItem(
        "AccountSelectedId",
        JSON.stringify(state.accountSelected)
      );
      var account =
        state.accountSelected == i18n.t("all")
          ? "NA"
          : state.accountSelected.AccountId;
      localStorage.setItem("Account_Id", account);
    }
    if (Object.keys(state.groupSelected).length > 0) {
      localStorage.setItem(
        "GroupSelectedId",
        JSON.stringify(state.groupSelected)
      );
      var group =
        state.groupSelected == i18n.t("all")
          ? "NA"
          : state.groupSelected.GroupId;
      localStorage.setItem("Group_Id", group);
    }

    if (router.app.$route.path == "/dashboard") {
      state.ItemsDashboard[0].value = state.vehicles.length;
      localStorage.setItem("v_list", JSON.stringify(state.vehicles));
    }
    // else if (router.app.$route.path == "/individualFuel") {
    //   localStorage.setItem("v_list_AF", JSON.stringify(state.vehicles));
    // } else if (router.app.$route.path == "/tracking") {
    //   localStorage.setItem("v_list_AT", JSON.stringify(state.vehicles));
    // }

    if (payload) state.bottomSheet = !state.bottomSheet;
  },
  setDealer: (state, payload) => {
    state.dealerSelected.DealerId = payload;
  },
  setClient: (state, payload) => {
    state.dealerSelected.ClientId = payload;
  },
  snackbar: (state, payload) => {
    state.snackbar = payload.snackbar;
    state.text = payload.text;
    if (payload.x != undefined || payload.x != null) {
      state.x = payload.x;
    } else {
      state.x = null;
    }
  },
  selectedReport: (state, value) => {
    state.selectedReport = value;
  },
  readListOfReports: (state, payload) => {
    state.Reports = [];
    if (payload.length > 0) {
      payload.forEach((report, index) => {
        var period =
          moment(report.StartDate).format("DD/MM/YYYY") +
          " - " +
          moment(report.EndDate).format("DD/MM/YYYY");
        var stillUtc = moment.utc(report.CreationDate).toDate();
        var localDate = moment(stillUtc)
          .local()
          .format("DD/MM/YYYY HH:mm");

        if (i18n.locale == "en") {
          period =
            moment(report.StartDate).format("MM/DD/YYYY") +
            " - " +
            moment(report.EndDate).format("MM/DD/YYYY");
          localDate = moment(stillUtc)
            .local()
            .format("MM/DD/YYYY HH:mm");
        }

        if (report.ReportType == 0)
          var ReportType = i18n.t("PerformanceReport");
        else var ReportType = i18n.t("ExceptionReport");

        var Columns = report.Metrics.length;
        var Vehicles = report.Vehicles.length;

        var item = {
          Id: report.Id,
          value: false,
          num: index + 1,
          name: report.ReportName,
          date: localDate,
          columns: Columns,
          vehicles: Vehicles,
          type: ReportType,
          period: period,
          createdBy: report.CreationEmail,
          IsComplete: report.IsComplete,
          urlBlob: report.Uri,
          loading4: false,
        };
        state.Reports.push(item);
      });
    }
  },
  loading: (state) => {
    state.loading3 = !state.loading3;
  },
  toContinueStepper: (state) => {
    if (state.hiddeFilterV == false) {
      state.hiddeFilterV = true;
      state.hiddeDetails = false;
      state.toContinue = state.NameOfReport.length > 0 ? true : false;
      state.colorStep2 = state.colorTheme;
    } else if (state.hiddeFilterV == true && state.hiddeDetails == false) {
      state.hiddeDetails = true;
      state.hiddeSummary = false;
      state.colorStep3 = state.colorTheme;
      state.PeriodOfReportTitle =
        state.startDateReport + " - " + state.endDateReport;
      state.ItemsColums = [];
      state.Columns.forEach((col) => {
        if (col.active) state.ItemsColums.push(col);
      });
      state.Columns2.forEach((col) => {
        if (col.active) state.ItemsColums.push(col);
      });
    } else if (state.hiddeDetails == true && state.hiddeSummary == false) {
      //end create report
      //state.finish = true
    }
  },
  toBackStepper: (state) => {
    if (state.hiddeFilterV == false) {
      router.push({ name: "reportsPage" });
      state.finish = false;
    } else if (state.hiddeFilterV == true && state.hiddeDetails == false) {
      //back to filter vehicles
      state.hiddeFilterV = false;
      state.hiddeDetails = true;
      state.toContinue = true;
      state.colorStep2 = "#c6c6c6";
    } else if (state.hiddeDetails == true && state.hiddeSummary == false) {
      //back to details
      state.hiddeDetails = false;
      state.hiddeSummary = true;
      state.toContinue = true;
      state.colorStep3 = "#c6c6c6";
    }
  },
  setDatesReport: (state, payload) => {
    if (payload[0] == "start") {
      state.startDate = payload[1];
      state.startTimeH =
        state.startTime.selectHour +
        ":" +
        state.startTime.selectMin +
        " " +
        state.startTime.selectMode;
      state.startDateReport =
        moment(payload[1]).format("DD/MM/YYYY") + " " + state.startTimeH;
    } else {
      state.endDate = payload[1];
      state.endTimeH =
        state.endTime.selectHour +
        ":" +
        state.endTime.selectMin +
        " " +
        state.endTime.selectMode;
      state.endDateReport =
        moment(payload[1]).format("DD/MM/YYYY") + " " + state.endTimeH;
    }
  },
  selectedTime: (state, payload) => {
    if (payload[0] == "start") {
      state.startTime = payload[1];
      state.startTimeH =
        state.startTime.selectHour +
        ":" +
        state.startTime.selectMin +
        " " +
        state.startTime.selectMode;
      state.startDateReport =
        moment(state.startDate).format("DD/MM/YYYY") + " " + state.startTimeH;
    } else {
      state.endTime = payload[1];
      state.endTimeH =
        state.endTime.selectHour +
        ":" +
        state.endTime.selectMin +
        " " +
        state.endTime.selectMode;
      state.endDateReport =
        moment(state.endDate).format("DD/MM/YYYY") + " " + state.endTimeH;
    }
  },
  setDataReport: (state, payload) => {
    if (payload != null && payload.length > 0) {
      state.NameOfReport = payload;
      state.toContinue = true;
    } else {
      state.toContinue = false;
      state.NameOfReport = "";
    }
  },
  addEmails: (state, payload) => {
    state.Emails = payload;
  },
  checkAllColumns: (state) => {
    state.all = !state.all;
    state.Columns.forEach((element) => {
      element.active = state.all;
    });

    state.Columns2.forEach((element2) => {
      element2.active = state.all;
    });

    if (state.all == false) {
      state.ItemsColums = [];
      state.toContinue = false;
    } else {
      state.toContinue = true;
    }
  },
  addColumns: (state) => {
    state.ItemsColums = [];

    state.Columns.forEach((col) => {
      if (col.active) state.ItemsColums.push(col);
    });
    state.Columns2.forEach((col) => {
      if (col.active) state.ItemsColums.push(col);
    });

    if (state.ItemsColums.length == 0) {
      state.toContinue = false;
    } else {
      state.toContinue = true;
    }
  },
  appDrawer: (state) => {
    state.mini = !state.mini;
    if (state.mini == true) state.itemsMenu[0].active = false;
  },
  manageNotiDrawer: (state) => {
    state.notiDrawer = !state.notiDrawer;
  },

  bottomSheet: (state) => {
    state.bottomSheet = !state.bottomSheet;
  },
  progressTable: (state, payload) => {
    state.progress = payload ? state.colorTheme : false;
  },
  progressTableFilter: (state, payload) => {
    state.progressFilter = payload;
  },
  disableFV: (state, payload) => {
    state.disableFV = payload;
    state.toContinue = !payload;
  },
  setTitle: (state, payload) => {
    state.titleToolbar = payload;
  },
  setPageHeader: (state, payload) => {
    state.PageHeader = payload[0].toUpperCase();
    state.PageHeaderSub = payload[1].toUpperCase();
    state.PageHeaderSub1 = payload[2].toUpperCase();
    state.PageHeaderSub2 = payload[3].toUpperCase();
    state.refreshOnHeader = payload[4];
  },
  filterSelected: (state, payload) => {
    if (state.SelectedAccess.Level != "Master") {
      var dealerFV = {
        DealerId: state.SelectedAccess.DealerId,
        Name: state.SelectedAccess.DealerName,
      };

      var clientFV = {
        ClientId: state.SelectedAccess.ClientId,
        Name: state.SelectedAccess.ClientName,
      };

      var accountFV = {
        AccountId: state.SelectedAccess.AccountId,
        Name: state.SelectedAccess.AccountName,
      };

      state.dealerSelected =
        state.SelectedAccess.Level == "Dealer" ||
        state.SelectedAccess.Level == "Client" ||
        state.SelectedAccess.Level == "Account"
          ? dealerFV
          : payload[0];
      state.clientSelected =
        state.SelectedAccess.Level == "Client" ||
        state.SelectedAccess.Level == "Account"
          ? clientFV
          : payload[1];
      state.accountSelected =
        state.SelectedAccess.Level == "Account" ? accountFV : payload[2];
      state.groupSelected = payload[3];
    } else {
      state.dealerSelected = payload[0];
      state.clientSelected = payload[1];
      state.accountSelected = payload[2];
      state.groupSelected = payload[3];
    }
  },
  filtersEnabled: (state, payload) => {
    if (state.SelectedAccess.Level != "Master") {
      state.dealersDisabled =
        state.SelectedAccess.Level == "Dealer" ||
        state.SelectedAccess.Level == "Client" ||
        state.SelectedAccess.Level == "Account"
          ? true
          : payload[0];
      state.clientsDisabled =
        state.SelectedAccess.Level == "Client" ||
        state.SelectedAccess.Level == "Account"
          ? true
          : payload[1];
      state.accountsDisabled =
        state.SelectedAccess.Level == "Account" ? true : payload[2];
      state.groupsDisabled = payload[3];
    } else {
      state.dealersDisabled = payload[0];
      state.clientsDisabled = payload[1];
      state.accountsDisabled = payload[2];
      state.groupsDisabled = payload[3];
    }
  },
  setVehicles: (state, payload) => {
    state.vehicles = payload;
  },
  manageFilterAccount: (state, payload) => {
    var initial = payload.length == 3 ? payload[2] : false;
    var responseList = payload[0];

    var dealerFV = {
      DealerId: state.SelectedAccess.DealerId,
      Name: state.SelectedAccess.DealerName,
    };

    var clientFV = {
      ClientId: state.SelectedAccess.ClientId,
      Name: state.SelectedAccess.ClientName,
    };

    var accountFV = {
      AccountId: state.SelectedAccess.AccountId,
      Name: state.SelectedAccess.AccountName,
    };

    if (payload[1] == "Vehicles") {
      state.vehicles = responseList;
      if (state.clientSelected != i18n.t("all")) {
        state.toContinue = true;
      }
    }

    if (responseList.length > 0) {
      if (payload[1] == "Master") {
        state.dealers = responseList;
        var dealerId = JSON.parse(localStorage.getItem("DealerSelectedId"));
        state.dealerSelected =
          dealerId != null && dealerId.DealerId != undefined
            ? dealerId
            : responseList[0];
      } else if (payload[1] == "Dealer") {
        state.clients = [];
        state.clients = responseList;

        var lastDealer = JSON.parse(localStorage.getItem("DealerSelectedId"));

        if (
          state.SelectedAccess.Level == "Dealer" ||
          state.SelectedAccess.Level == "Client" ||
          state.SelectedAccess.Level == "Account"
        ) {
          state.dealers = dealerFV;

          state.dealerSelected = dealerFV;
        } else {
          state.clients.splice(0, 0, i18n.t("all"));
        }

        if (
          initial &&
          lastDealer != null &&
          state.dealerSelected.DealerId == lastDealer.DealerId
        ) {
          var client = JSON.parse(localStorage.getItem("ClientSelectedId"));
          state.clientSelected =
            client != null && client.ClientId != undefined
              ? client
              : responseList[0];
        } else {
          state.clientSelected = responseList[0];
        }
      } else if (payload[1] == "Client") {
        state.accounts = [];
        state.accounts = responseList;

        if (
          state.SelectedAccess.Level == "Client" ||
          state.SelectedAccess.Level == "Account"
        ) {
          state.dealers = dealerFV;
          state.clients = clientFV;

          state.dealerSelected = dealerFV;

          state.clientSelected = clientFV;
        }

        state.accounts.splice(0, 0, i18n.t("all"));

        var lastDealer = JSON.parse(localStorage.getItem("DealerSelectedId"));
        if (
          initial &&
          lastDealer != null &&
          state.dealerSelected.DealerId == lastDealer.DealerId
        ) {
          var account = JSON.parse(localStorage.getItem("AccountSelectedId"));
          state.accountSelected =
            account != null && account.AccountId != undefined
              ? account
              : responseList[0];
        } else {
          state.accountSelected = responseList[0];
        }

        //state.accountSelected = responseList[0];
      } else if (payload[1] == "Account") {
        state.groups = [];
        state.groups = responseList;

        if (state.SelectedAccess.Level == "Account") {
          state.dealers = dealerFV;
          state.clients = clientFV;
          state.accounts = accountFV;

          state.dealerSelected = dealerFV;

          state.clientSelected = clientFV;

          state.accountSelected = accountFV;
        }
        state.groups.splice(0, 0, i18n.t("all"));
        var lastDealer = JSON.parse(localStorage.getItem("DealerSelectedId"));
        if (
          initial &&
          lastDealer != null &&
          state.dealerSelected.DealerId == lastDealer.DealerId
        ) {
          var group = JSON.parse(localStorage.getItem("GroupSelectedId"));
          state.groupSelected =
            group != null && group.GroupId != undefined
              ? group
              : responseList[0];
        } else {
          state.groupSelected = responseList[0];
        }
        // state.groupSelected = responseList[0];
      }
    } else {
      if (payload[1] == "Dealer") {
        state.clients = [];
        state.clients.splice(0, 0, i18n.t("all"));
        state.accounts = [];
        state.accounts.splice(0, 0, i18n.t("all"));
        state.groups = [];
        state.groups.splice(0, 0, i18n.t("all"));
      } else if (payload[1] == "Vehicles") {
        state.vehicles = [];
        state.toContinue = false;
      }
    }

    if (state.vehicles.length > 0 && state.clientSelected != i18n.t("all")) {
      if (
        router.app.$route.path == "/individualFuel" &&
        (state.vehicleSelectedAF == "" || state.vehicleSelectedAF == undefined)
      ) {
        state.disableFV = true;
      } else {
        state.disableFV = false;
        state.nextWizzard = false;
      }
    } else {
      state.disableFV = true;
      state.nextWizzard = true;
    }
  },
  setValuesReportsPage: (state) => {
    //NEW REPORT COMPONENT (STEPPER, REPORT DETAILS, FILTER VEHICLES, SUMMARY)
    state.progress = false;
    //Filter V
    state.headersFilterV = [
      { text: "ID", value: "MovilId" },
      { text: "NICK", value: "Nick" },
      {
        text: "",
        value: "act",
        sortable: false,
        align: "right",
      },
    ];

    //Filter V selector
    state.dealers = [i18n.t("all")];
    state.clients = [i18n.t("all")];
    state.accounts = [i18n.t("all")];
    state.groups = [i18n.t("all")];
    state.dealerSelected = state.dealers[0];
    state.clientSelected = state.clients[0];
    state.accountSelected = state.accounts[0];
    state.groupSelected = state.groups[0];

    //Report details View
    state.Columns = [
      {
        title: i18n.t("selectAll"),
        value: 18,
        active: true,
      },
      {
        title: i18n.t("distance"),
        value: 6,
        active: true,
      },
      {
        title: i18n.t("usedfuel"),
        value: 1,
        active: true,
      },
      {
        title: i18n.t("drivefuel"),
        value: 2,
        active: true,
      },
      {
        title: i18n.t("ralentifuel"),
        value: 3,
        active: true,
      },
      {
        title: i18n.t("rendbruto"),
        value: 16,
        active: true,
      },
      {
        title: i18n.t("consumeperhour"),
        value: 4,
        active: true,
      },
      {
        title: i18n.t("timedriving"),
        value: 12,
        active: true,
      },
      {
        title: i18n.t("timeralenti"),
        value: 13,
        active: true,
      },
      {
        title: i18n.t("finalfuel"),
        value: 0,
        active: true,
      },
    ];
    state.Columns2 = [
      {
        title: i18n.t("timepto"),
        value: 11,
        active: true,
      },
      {
        title: i18n.t("percentPto"),
        value: 17,
        active: true,
      },
      {
        title: i18n.t("fuelpto"),
        value: 5,
        active: true,
      },
      {
        title: i18n.t("speedpromedy"),
        value: 15,
        active: true,
      },
      {
        title: i18n.t("speedmax"),
        value: 14,
        active: true,
      },
      {
        title: i18n.t("rpmexcess"),
        value: 9,
        active: true,
      },
      {
        title: i18n.t("maxrpm"),
        value: 10,
        active: true,
      },
      {
        title: i18n.t("exceptions"),
        value: 8,
        active: true,
      },
      {
        title: i18n.t("finaldistance"),
        value: 7,
        active: true,
      },
    ];

    state.Minutes = [
      "00",
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
      "09",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "19",
      "20",
      "21",
      "22",
      "23",
      "24",
      "25",
      "26",
      "27",
      "28",
      "29",
      "30",
      "31",
      "32",
      "33",
      "34",
      "35",
      "36",
      "37",
      "38",
      "39",
      "40",
      "41",
      "42",
      "43",
      "44",
      "45",
      "46",
      "47",
      "48",
      "49",
      "50",
      "51",
      "52",
      "53",
      "54",
      "55",
      "56",
      "57",
      "58",
      "59",
    ];

    state.Hours = [
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
      "09",
      "10",
      "11",
      "12",
    ];

    state.startTime = {
      selectHour: state.Hours[11],
      selectMin: state.Minutes[0],
      selectMode: state.ampm[0],
    };

    state.endTime = {
      selectHour: state.Hours[11],
      selectMin: state.Minutes[0],
      selectMode: state.ampm[0],
    };

    state.startDateReport =
      moment()
        .subtract(1, "days")
        .format("DD/MM/YYYY") +
      " " +
      state.startTime.selectHour +
      ":" +
      state.startTime.selectMin +
      " " +
      state.startTime.selectMode;
    state.endDateReport =
      moment().format("DD/MM/YYYY") +
      " " +
      state.endTime.selectHour +
      ":" +
      state.endTime.selectMin +
      " " +
      state.endTime.selectMode;

    //STEPPER COMPONET
    state.hiddeFilterV = false;
    (state.hiddeDetails = true), (state.hiddeSummary = true);
    state.toContinue = false;
    state.colorStep2 = "#c6c6c6";
    state.colorStep3 = "#c6c6c6";
    state.valueDeterminate = 100;
    state.e1 = 0;
    state.finish = false;
    state.showMessage = false;
    //FILTER VEHICLES
    state.dealersDisabled = false;
    state.clientsDisabled = false;
    state.accountsDisabled = false;
    state.groupsDisabled = false;
    state.all = "";
    state.vehicles = [];
    state.noResults = "";
    //SUMMARY
    //REPORT DETAILS PAGE
    state.ItemsColums = [];
    state.NameOfReport = "";
    state.Emails = [localStorage.getItem("userName")];
    state.VehiclesCount = "";
    state.VehiclesList = [];
    state.PeriodOfReportTitle = "";
    state.startDate = moment()
      .subtract(1, "days")
      .format("YYYY-MM-DD");
    state.endDate = moment().format("YYYY-MM-DD");
    state.PeriodReport = [];
    state.TypeOfReport = "Reporte de desempeño";
    state.SelectedColumns = [];
    state.ampm = ["AM", "PM"];
    state.all = true;
  },

  setValuesLanguage: (state) => {
    var auth = JSON.parse(localStorage.getItem("auth")) || false;

    if (auth) {
      //se establece idioma
      i18n.locale = localStorage.language == undefined ? "es" : localStorage.language.trim();
      localStorage.setItem("language", i18n.locale);
      moment.locale(i18n.locale);

      //se establecen las fechas de inicio y fin
      var dateCalendar1 = localStorage.getItem("datesCalendar1");
      var dateCalendar2 = localStorage.getItem("datesCalendar2");
      state.start = localStorage.getItem("start");
      if (state.start == undefined) {
        state.start = false;
        localStorage.setItem("start", false);
      }

      if (router.app.$route.path == "/individualFuel") {
        dateCalendar1 = localStorage.getItem("startDateAF");
        dateCalendar2 = localStorage.getItem("endDateAF");
      }

      if (dateCalendar1 == undefined && dateCalendar2 == undefined) {
        //no hay fechas, por lo que se establece la fecha de hoy
        state.datesCalendar = [moment().format("YYYY-MM-DD")];
        localStorage.setItem("datesCalendar1", state.datesCalendar[0]);

      } else {
        //hay por lo menos 1 fecha
        if (dateCalendar2 == undefined) {
          //hay 1 fecha
          var today = moment().format("YYYY-MM-DD");
          if (dateCalendar1 == today) {
            //la fecha corresponde al día de hoy
            state.datesCalendar = [moment().format("YYYY-MM-DD")];
          } else {
            state.datesCalendar = [dateCalendar1];
          }
        } else {
          //hay 2 fechas
          state.datesCalendar = [dateCalendar1, dateCalendar2];
        }
      }

      var startClockTime = localStorage.getItem("startClock");
      var endClockTime = localStorage.getItem("endClock");

      if (startClockTime == undefined) {
        state.startClock = "00:00";
        state.endClock = "23:59";
        localStorage.setItem("startClock", state.startClock);
        localStorage.setItem("endClock", state.endClock);
      } else {
        state.startClock = startClockTime;
        state.endClock = endClockTime;
      }

      //Max date && min date for datepicker
      state.maxDate = moment().format("YYYY-MM-DD");
      state.minDate = moment()
        .subtract(60, "days")
        .format("YYYY-MM-DD");

      //dates
      state.startDate = moment()
        .subtract(1, "days")
        .format("YYYY-MM-DD");
      state.endDate = moment().format("YYYY-MM-DD");

      state.listVehiclesAF = [];

      state.listCallCommand = [
        { Id: 1, Name: i18n.t("callByDevice") },
        { Id: 0, Name: i18n.t("callByMe") },
      ];

      state.statusTraffic = [
        i18n.t("inTravel"),
        i18n.t("noTrip"),
        i18n.t("stopped"),
        i18n.t("outOfService"),
      ];
      var carrierId = JSON.parse(localStorage.getItem("CarrierId"));
      if (carrierId == null) {
        state.carrierId = carrierId;
      } else {
        state.carrierId = carrierId.Id;
      }

      state.SelectedAccess = JSON.parse(localStorage.getItem("SelectedAccess"));

      if (
        localStorage.getItem("userImage") != null ||
        localStorage.getItem("userImage") != undefined
      ) {
        state.userImage = localStorage.getItem("userImage");
      } else {
        state.userImage = avatar;
      }

      state.userData = JSON.parse(localStorage.getItem("userData"));

      if (
        localStorage.getItem("imageLogo") != null ||
        localStorage.getItem("imageLogo") != undefined
      ) {
        state.imageLogo = localStorage.getItem("imageLogo");
      } else {
        state.imageLogo = logoBoson;
      }
      if (
        localStorage.getItem("checkQuickList") != undefined ||
        localStorage.getItem("checkQuickList") != null
      ) {
        state.checkFastList = JSON.parse(
          localStorage.getItem("checkQuickList")
        );
      }
      if (
        localStorage.getItem("quickList") != undefined ||
        localStorage.getItem("quickList") != null
      ) {
        state.vehiclesAggregates = JSON.parse(
          localStorage.getItem("quickList")
        );
      }
    }

    //Validations
    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    state.tokenRules = [(v) => !!v || i18n.t("invalidPass")];
    state.emailRules = [
      (v) => !!v || i18n.t("invalidUs"),
      (v) => pattern.test(v) || i18n.t("invalidEmail"),
    ];
    //default text in Individual fuel
    state.movilIdFromVehSelectedAF = i18n.t("noVehicle");
    state.nickFromVehSelectedAF = "";
    // var vehicle = localStorage.getItem("vehicleAF");
    // if (vehicle != undefined && vehicle != null) {
    //   vehicle = JSON.parse(vehicle);
    //   state.movilIdFromVehSelectedAF = vehicle[0].MovilId;
    //   state.nickFromVehSelectedAF = vehicle[0].Nick;
    // } else {
    //   state.movilIdFromVehSelectedAF = i18n.t("noVehicle");
    // }

    //Data tables
    state.headers = [
      {
        text: i18n.t("level").toUpperCase(),
        align: "left",
        sortable: false,
        value: "Level",
      },
      { text: i18n.t("ref").toUpperCase(), value: "DealerName" },
      { text: i18n.t("status").toUpperCase(), value: "State" },
    ];

    state.headersReports = [
      { text: i18n.t("name").toUpperCase(), value: "name" },
      { text: i18n.t("date").toUpperCase(), value: "date" },
      { text: i18n.t("col").toUpperCase(), value: "columns" },
      { text: i18n.t("vehicles").toUpperCase(), value: "vehicles" },
      { text: i18n.t("type").toUpperCase(), value: "type" },
      { text: i18n.t("period").toUpperCase(), value: "period" },
      { text: i18n.t("CreatedBy").toUpperCase(), value: "createdBy" },
      {
        text: i18n.t("Status").toUpperCase(),
        value: "action",
        align: "center",
        sortable: false,
      },
    ];

    state.headersSecureU = [
      { text: i18n.t("dealer").toUpperCase(), value: "DealerId" },
      { text: i18n.t("name").toUpperCase(), value: "DealerName" },
      {
        text: i18n.t("Status").toUpperCase(),
        value: "Active",
        sortable: false,
      },
      {
        text: i18n.t("dateInitial").toUpperCase(),
        value: "JoinDate",
        sortable: false,
      },
      {
        text: i18n.t("actions").toUpperCase(),
        value: "act",
        sortable: false,
        align: "center",
      },
    ];

    state.headersDealers = [
      { text: i18n.t("dealer").toUpperCase(), value: "DealerId" },
      { text: i18n.t("name").toUpperCase(), value: "Name" },
      { text: i18n.t("Status").toUpperCase(), value: "State", sortable: false },
    ];

    state.headersOperatorsDetails = [
      { text: i18n.t("operator").toUpperCase(), value: "Operator" },
      { text: i18n.t("license").toUpperCase(), value: "License" },
      { text: i18n.t("type").toUpperCase(), value: "Type" },
      {
        text: i18n.t("licenseExpiration").toUpperCase(),
        value: "LicenseExpiration",
      },
      { text: i18n.t("address").toUpperCase(), value: "Address" },
      {
        text: i18n.t("registrationDate").toUpperCase(),
        value: "RegistrationDate",
      },
      { text: i18n.t("bonding").toUpperCase(), value: "Bonding" },
      {
        text: "",
        value: "act",
        sortable: false,
        align: "right",
      },
    ];

    state.headersOperators = [
      { text: i18n.t("operator").toUpperCase(), value: "Operator" },
      { text: i18n.t("license").toUpperCase(), value: "License" },
      {
        text: i18n.t("licenseExpiration").toUpperCase(),
        value: "LicenseExpiration",
      },
    ];

    state.headersMobilesDetails = [
      { text: i18n.t("number").toUpperCase(), value: "mobile" },
      { text: "IMEI", value: "IMEI" },
      { text: i18n.t("brand").toUpperCase(), value: "marca" },
      { text: i18n.t("model").toUpperCase(), value: "model" },
      { text: i18n.t("OS").toUpperCase(), value: "OS" },
      { text: i18n.t("bonding").toUpperCase(), value: "Bonding" },
      {
        text: "",
        value: "act",
        sortable: false,
        align: "right",
      },
    ];

    state.headersMovil = [
      { text: i18n.t("mobileEquipment").toUpperCase(), value: "mobile" },
      { text: "IMEI", value: "IMEI" },
      { text: i18n.t("model").toUpperCase(), value: "model" },
      { text: i18n.t("OS").toUpperCase(), value: "OS" },
    ];

    state.headersTraffic = [
      { text: i18n.t("vehicle").toUpperCase(), value: "vehicle" },
      { text: i18n.t("lastPosition").toUpperCase(), value: "address" },
      { text: i18n.t("dateT").toUpperCase(), value: "date" },
      { text: i18n.t("idleTime").toUpperCase(), value: "idletime" },
      { text: i18n.t("statusT").toUpperCase(), value: "status" },
      { text: "", value: "data-table-expand" },
    ];

    state.headersCarriers = [
      { text: i18n.t("name").toUpperCase(), value: "TradeName" },
      { text: i18n.t("businessName").toUpperCase(), value: "BusinessName" },
      { text: "DEALER ID", value: "DealerId" },
      { text: "CLIENT ID", value: "ClientId" },
      { text: "ACCOUNT ID", value: "AccountId" },
      { text: i18n.t("address").toUpperCase(), value: "Address" },
      { text: i18n.t("serviceType").toUpperCase(), value: "ServiceType" },
      { text: i18n.t("modality").toUpperCase(), value: "Modality" },
      {
        text: "",
        value: "act",
        sortable: false,
        align: "right",
      },
    ];
    state.headersMetrics = [
      {
        text: i18n.t("vehicle").toUpperCase(),
        value: "deviceId",
        align: "center",
      },
      {
        text: i18n.t("drivingConsume").toUpperCase(),
        value: "valuefuelDriving",
        align: "center",
        dataType: "number"
      },
      {
        text: i18n.t("consumptionIdle").toUpperCase(),
        value: "valueFuelRalenti",
        align: "center",
        dataType: "number"
      },
      {
        text: i18n.t("consumePTO").toUpperCase(),
        value: "valueFuelPto",
        align: "center",
        dataType: "number"
      },
      {
        text: i18n.t("drivingMotorUsage").toUpperCase() + " (HH:mm)",
        value: "valueEngineDriving",
        align: "center",
        dataType: "number"
      },
      {
        text: i18n.t("motorUsageIdle").toUpperCase() + " (HH:mm)",
        value: "valueEngineRalenti",
        align: "center",
        dataType: "number"
      },
      {
        text: i18n.t("motorUsage").toUpperCase() + " (HH:mm)",
        value: "valueEnginePto",
        align: "center",
        dataType: "number"
      },
      {
        text: i18n.t("rendi").toUpperCase(),
        value: "valuePerformance",
        align: "center",
        dataType: "number"
      },
      {
        text: i18n.t("distance").toUpperCase(),
        value: "valueDistance",
        align: "center",
        dataType: "number"
      },
      {
        text: i18n.t("exceptions").toUpperCase(),
        value: "valueIntransitIncidents",
        align: "center",
        dataType: "number"
      },
     {
        text: i18n.t("maxSpeed").toUpperCase(),
        value: "valueSpeedMax",
        align: "center",
        dataType: "number"
      },
      {
        text: i18n.t("actions").toUpperCase(),
        value: "act",
        align: "center",
        sortable: false,
      },
    ];

    state.headersMetricsNoAction = [
      { label: i18n.t("vehicle").toUpperCase(), field: "deviceId" },
      { label: i18n.t("drivingConsume").toUpperCase(), field: "fuelDriving" },
      {
        label: i18n.t("consumptionIdle").toUpperCase(),
        field: "fuelRalenti",
      },
      { label: i18n.t("consumePTO").toUpperCase(), field: "fuelPto" },
      {
        label: i18n.t("drivingMotorUsage").toUpperCase(),
        field: "engineDriving",
      },
      {
        label: i18n.t("motorUsageIdle").toUpperCase(),
        field: "engineRalenti",
      },
      { label: i18n.t("motorUsage").toUpperCase(), field: "enginePto" },
      { label: i18n.t("rendi").toUpperCase(), field: "performance" },
      { label: i18n.t("distance").toUpperCase(), field: "distance" },
      {
        label: i18n.t("exceptions").toUpperCase(),
        field: "intransitIncidents",
      },
    ];

    state.headersPerformance = [
      {text: i18n.t("vehicle").toUpperCase(), value: "Device", align: "center"},
      { text: i18n.t("dateT").toUpperCase(), value: "DateTimestamp", align: "center" },
      {text: i18n.t("location").toUpperCase(), value: "Reference", align: "center", width: 200},
      {text: i18n.t("event").toUpperCase(), value: "Description", align: "center"},
      {text: i18n.t("eventDetails").toUpperCase(), value: "Details", align: "center"},
    ];
    state.headersPerformanceExcel = [
      { label: i18n.t("vehicle").toUpperCase(), field: "DeviceId" },
      { label: i18n.t("dateT").toUpperCase(), field: "DateFormatted" },
      { label: i18n.t("location").toUpperCase(), field: "Reference" },
      { label: i18n.t("event").toUpperCase(), field: "Description" },
      { label: i18n.t("eventDetails").toUpperCase(), field: "Details" },
    ];
    state.headersTracking = [
      {
        text: i18n.t("vehicle").toUpperCase(),
        value: "DeviceIdAndNick",
        align: "center",
      },
      {
        text: i18n.t("lastTransmission").toUpperCase(),
        value: "DateServer",
        align: "center",
      },
      {
        text: i18n.t("timeWT").toUpperCase(),
        value: "IdleTime",
        align: "center",
      },
      { text: "", value: "data-table-expand" },
    ];
    state.headersTemplatesAT = [
      {
        text: i18n.t("templateName").toUpperCase(),
        value: "Name",
        align: "center",
      },
      {
        text: i18n.t("creationDate").toUpperCase(),
        value: "CreationDate",
        align: "center",
      },
      {
        text: i18n.t("editionDate").toUpperCase(),
        value: "EditionDate",
        align: "center",
      },
      {
        text: i18n.t("CreatedBy").toUpperCase(),
        value: "Email",
        align: "center",
      },
      {
        text: i18n.t("actions").toUpperCase(),
        value: "actions",
        sortable: false,
        align: "center",
      },
    ];

    state.headersConfigAT = [
      {
        text: i18n.t("movilId").toUpperCase(),
        value: "MovilId",
        align: "center",
      },
      {
        text: i18n.t("nick").toUpperCase(),
        value: "Nick",
        align: "center",
      },
      {
        text: i18n.t("statusT").toUpperCase(),
        value: "Status",
        align: "center",
      },
      {
        text: i18n.t("details").toUpperCase(),
        value: "Details",
      },
      {
        text: "",
        value: "icon",
        sortable: false,
      },
    ];

    state.headersAlertruckVehiclesInfo = [
      {
        text: i18n.t("vehicle").toUpperCase(),
        value: "DeviceId",
        align: "center",
      },
      {
        text: i18n.t("informationInThePeriod").toUpperCase(),
        value: "AlertruckDataOnThisPeriod",
        align: "center",
      }
    ];

    state.headersAlertruckVehiclesInfoExcel = [
      {
        label: i18n.t("vehicle").toUpperCase(),
        field: "DeviceId"
      },
      {
        label: i18n.t("informationInThePeriod").toUpperCase(),
        field: "AlertruckDataOnThisPeriod"
      }
    ];
    
    state.itemsTableInTransit = [
      {
        deviceId: "PHX1-00001 (NICK 001)",
        date: "20/09/2020 15:15",
        address: "Paseo de los Leones 1349",
        description: "Exceso de RPMs",
        eventDetails: "Umbral: 10, Valor: 20 RPMS",
      },
      {
        deviceId: "PHX1-00001 (NICK 001)",
        date: "20/09/2020 15:15",
        address: "Paseo de los Leones 1349",
        description: "Exceso de RPMs",
        eventDetails: "Umbral: 10, Valor: 20 RPMS",
      },
      {
        deviceId: "PHX1-00001 (NICK 001)",
        date: "20/09/2020 15:15",
        address: "Paseo de los Leones 1349",
        description: "Exceso de RPMs",
        eventDetails: "Umbral: 10, Valor: 20 RPMS",
      },
    ];

    state.itemsMenu = [
      {
        name: "Dashboard",
        title: i18n.t("dashboard"),
        icon: "assignment",
        path: "/dashboard",
      },
      {
        name: "Exceptions",
        title: i18n.t("titleExceptions"),
        icon: "directions_car",
        path: "/vehiclesExceptions",
      },
      {
        name: "AccountBalance",
        title: i18n.t("titleABalance"),
        icon: "account_balance",
        path: "/accountBalancePage",
      },
      {
        name: "RC",
        title: i18n.t("titleRep"),
        icon: "file_copy",
        path: "/reportsPage",
      },
      {
        name: "Commandos",
        title: i18n.t("commands"),
        icon: "settings_remote",
        path: "/commands",
      },
      {
        name: "Salir",
        title: i18n.t("exit").toUpperCase(),
        icon: "exit_to_app",
      },
    ];

    //appdrawer
    state.itemsMenu = [
      {
        name: "Tracts",
        title: i18n.t("tracts").toUpperCase(),
        avatar: "/assets/Tractos.jpeg",
        active: false,
      },
      {
        name: "Trafico",
        title: i18n.t("traffic").toUpperCase(),
        avatar: "/assets/Rutas-g2.png",
        active: false,
      },
    ];

    state.headersGlobalCalculations = [
      {
        text: i18n.t("trip").toUpperCase(),
        value: "trip",
        align: "center",
      },
      {
        text: i18n.t("rendi").toUpperCase(),
        value: "performance",
        align: "center",
      },
      {
        text: i18n.t("distancRoad").toUpperCase(),
        value: "distancRoad",
        align: "center",
      },
      {
        text: i18n.t("timeEngine").toUpperCase() + " (H)",
        value: "timeEngine",
        align: "center",
      },
      {
        text: i18n.t("breakTime").toUpperCase() + " (H)",
        value: "breakTime",
        align: "center",
      },
      {
        text: i18n.t("fuelConsumed").toUpperCase(),
        value: "fuelConsumed",
        align: "center",
      },
      {
        text: i18n.t("tripDuration").toUpperCase(),
        value: "tripDuration",
        align: "center",
      },
      {
        text: i18n.t("exceptions").toUpperCase(),
        value: "exceptions",
        align: "center",
      },
    ];

    state.headersTripsAnalysis = [
      {
        text: i18n.t("trip").toUpperCase(),
        value: "trip",
        align: "center",
      },
      {
        text: i18n.t("maxSpeed").toUpperCase(),
        value: "maxSpeed",
        align: "center",
      },
      {
        text: i18n.t("avgSpeed").toUpperCase(),
        value: "avgSpeed",
        align: "center",
      },
      {
        text: i18n.t("maxRpmm").toUpperCase() + " (Rpm)",
        value: "maxRpmm",
        align: "center",
      },
      {
        text: i18n.t("rpmAvg").toUpperCase() + " (Rpm)",
        value: "rpmAvg",
        align: "center",
      },
      {
        text: i18n.t("AvgMotorLoad").toUpperCase(),
        value: "AvgMotorLoad",
        align: "center",
      },
      {
        text: i18n.t("pedalProm").toUpperCase(),
        value: "pedalProm",
        align: "center",
      },
    ];

    state.headerFVTable = [
      { text: i18n.t("vehicle").toUpperCase(), value: "MovilIdAndNick" },
      { text: "", value: "actions" },
    ];

    if (state.production) {
      if (state.WebServerOwner == "TG") {
       state.itemsOptions = [
        {
          name: "Dashboard",
          title: i18n.t("dashboard"),
          icon: "mdi-clipboard-text",
          path: "/dashboard",
        }
      ];
      } else {
        state.itemsOptions = [
        {
          name: "Dashboard",
          title: i18n.t("dashboard"),
          icon: "mdi-clipboard-text",
          path: "/dashboard",
        },
        // {
        //   name: "RC",
        //   title: i18n.t("titleRep"),
        //   icon: "mdi-content-copy",
        //   path: "/reportsPage",
        // },
        // {
        //   name: "ParametersConfig",
        //   title: i18n.t("parametersConfig"),
        //   icon: "mdi-file-cog-outline",
        //   path: "/settingsAT",
        // },
      ];
      }

    } else {
      state.itemsOptions = [
        {
          name: "Dashboard",
          title: i18n.t("dashboard"),
          icon: "mdi-clipboard-text",
          path: "/dashboard",
        },
        {
          name: "ParametersConfig",
          title: i18n.t("parametersConfig"),
          icon: "mdi-file-cog-outline",
          path: "/settingsAT",
        },
        {
          name: "Exceptions",
          title: i18n.t("titleExceptions"),
          icon: "mdi-car",
          path: "/vehiclesExceptions",
        },
        {
          name: "AccountBalance",
          title: i18n.t("titleABalance"),
          icon: "mdi-bank",
          path: "/accountBalancePage",
        },
        {
          name: "RC",
          title: i18n.t("titleRep"),
          icon: "mdi-content-copy",
          path: "/reportsPage",
        },
        {
          name: "Commandos",
          title: i18n.t("commands"),
          icon: "mdi-remote",
          path: "/commands",
        },
      ];
    }

    //Lista de Administar
    state.itemsOptionsTraffic = [
      {
        name: "Trafico",
        title: i18n.t("monitoring"),
        icon: "mdi-road-variant",
        path: "/traffic",
      },
      {
        name: "Vinculaciones",
        title: i18n.t("entailment"),
        icon: "mdi-cellphone",
        path: "/operator",
      },
    ];

    if (state.SelectedAccess.Level == "Master") {
      //Lista de Administar
      state.itemsOptionsTraffic = [
        {
          name: "Trafico",
          title: i18n.t("monitoring"),
          icon: "mdi-road-variant",
          path: "/traffic",
        },
        {
          name: "Carriers",
          title: i18n.t("carrierManagement"),
          icon: "mdi-office-building",
          path: "/carriers",
        },
        {
          name: "Vinculaciones",
          title: i18n.t("entailment"),
          icon: "mdi-cellphone",
          path: "/operator",
        },
      ];
    }

    //Dashboard summary
    state.ItemsDashboard = [
      {
        title: i18n.t("vehiclesD"),
        value: 0,
      },
      {
        title: i18n.t("totalFuel"),
        value: 0,
      },
      {
        title: i18n.t("ralentifuel"),
        value: 0,
      },
      {
        title: i18n.t("exceptionsHome"),
        value: 0,
      },
      {
        title: i18n.t("totalDistance"),
        value: 0,
      },
      {
        title: i18n.t("totalPerformance"),
        value: 0,
      },
    ];
    //Tracking
    (state.refGeo = [
      {
        title: i18n.t("gps"),
        value: 0,
        icon: "mdi-satellite-uplink",
      },
      {
        title: i18n.t("server"),
        value: 0,
        icon: "mdi-server",
      },
      {
        title: i18n.t("position"),
        value: 0,
        icon: "mdi-map-marker",
      },
      {
        title: i18n.t("vel"),
        value: 0,
        icon: "mdi-speedometer",
      },
      {
        title: i18n.t("location"),
        value: 0,
        icon: "mdi-map-marker-radius",
      },
      {
        title: i18n.t("address"),
        value: 0,
        icon: "mdi-directions",
      },
      {
        title: i18n.t("odometer"),
        value: 0,
        icon: "mdi-counter",
      },
      {
        title: i18n.t("battery"),
        value: 0,
        icon: "mdi-battery-unknown",
      },
      {
        title: i18n.t("freeText"),
        value: 0,
        icon: "mdi-card-text",
      },
    ]),
      (state.vehicleData = [
        {
          title: i18n.t("plates"),
          value: 0,
          icon: "mdi-card-text-outline",
        },
        {
          title: i18n.t("year"),
          value: 0,
          icon: "mdi-checkbox-multiple-blank-circle",
        },
        {
          title: i18n.t("color"),
          value: 0,
          icon: "mdi-palette",
        },
        {
          title: i18n.t("brand"),
          value: 0,
          icon: "mdi-train-car",
        },
        {
          title: i18n.t("category"),
          value: 0,
          icon: "mdi-dock-window",
        },
        {
          title: i18n.t("comments"),
          value: 0,
          icon: "mdi-more",
        },
        {
          title: i18n.t("operatingState"),
          value: 0,
          icon: "mdi-cog",
        },
      ]),
      (state.topData = [
        {
          value: 0,
        },
        {
          value: i18n.t("addressNotAvailable"),
        },
        {
          value: i18n.t("timeWT") + " " + 0,
        },
        {
          value: "",
        },
      ]);
    (state.connectionVeh = [
      {
        title: i18n.t("gps"),
        value: false,
      },
      {
        title: i18n.t("autoReports"),
        value: false,
      },
      {
        title: i18n.t("gsm"),
        value: false,
      },
      {
        title: i18n.t("realPosition"),
        value: false,
      },
      {
        title: i18n.t("connectedToServer"),
        value: false,
      },
      // {
      //   title: "Botón de Pánico",
      //   value: false,
      // },
      // {
      //   title: "Botón de Soporte",
      //   value: false,
      // },
      // {
      //   title: "Botón de Ayuda",
      //   value: false,
      // },
      // {
      //   title: "Switch de Ignición",
      //   value: false,
      // },
      // {
      //   title: "Señal GPS",
      //   value: false,
      // },
      // {
      //   title: "Ahorro de Energia",
      //   value: false,
      // },
      // {
      //   title: "Salida 3 - Bloqueo de Ignición",
      //   value: false,
      // },
      // {
      //   title: "Salida 5 - Bloqueo de Motor",
      //   value: false,
      // },
      // {
      //   title: "Salida 1 - Control de Luces",
      //   value: false,
      // },
      // {
      //   title: "Salida 1 - Control de Sirenas",
      //   value: false,
      // },
      // {
      //   title: "Manos Libres - Altavoz",
      //   value: false,
      // },
      // {
      //   title: "Manos Libres - Microfono",
      //   value: false,
      // },
      // {
      //   title: "Registrado en Red GSM",
      //   value: false,
      // },
      // {
      //   title: "Modalidad SMS",
      //   value: false,
      // },
      // {
      //   title: "Conectado al Servidor (Bridge)",
      //   value: false,
      // },
      // {
      //   title: "Llave de pulso invalida",
      //   value: false,
      // },
      // {
      //   title: "Encendido sin llave de pulso valida",
      //   value: false,
      // },
      // {
      //   title: "Valet Parking",
      //   value: false,
      // },
      // {
      //   title: "Alarma habilitada",
      //   value: false,
      // },
      // {
      //   title: "Arrastrado sin llave de pulso valida",
      //   value: false,
      // },
      // {
      //   title: "Alarma Armada",
      //   value: false,
      // },
      // {
      //   title: "Modalidad de Auto-Reportes",
      //   value: false,
      // },
      // {
      //   title: "GPS Valido",
      //   value: false,
      // },
      // {
      //   title: "Salida 4 - Cerrar Seguros",
      //   value: false,
      // },
      // {
      //   title: "Salida 2 - Abrir Seguros",
      //   value: false,
      // },
      // {
      //   title: "Historial",
      //   value: false,
      // },
      // {
      //   title: "Reservado",
      //   value: false,
      // },
      // {
      //   title: "Reservado",
      //   value: false,
      // },
      // {
      //   title: "Reservado",
      //   value: false,
      // },
      // {
      //   title: "Reservado",
      //   value: false,
      // },
      // {
      //   title: "Reservado",
      //   value: false,
      // },
      // {
      //   title: "Bateria Principal",
      //   value: false,
      // },
    ]),
      (state.inAndOutVeh = [
        {
          title: i18n.t("switch"),
          value: false,
        },
        {
          title: i18n.t("ignitionLocked"),
          value: false,
        },
        {
          title: i18n.t("panicButton"),
          value: false,
        },
        {
          title: i18n.t("engineLocked"),
          value: false,
        },
        {
          title: i18n.t("supportButton"),
          value: false,
        },
        {
          title: i18n.t("lightSiren"),
          value: false,
        },
        {
          title: i18n.t("helpButton"),
          value: false,
        },
        {
          title: i18n.t("doorsLocked"),
          value: false,
        },
        {
          title: i18n.t("batteryConnected"),
          value: false,
        },
        {
          title: i18n.t("doorsUnlocked"),
          value: false,
        },
      ]),
      (state.responseActivity = [
        {
          value: "ND", //fecha timestamp
        },
        {
          value: "ND", //address
        },
        {
          value: "ND", //duration
        },
      ]);

    //commands list
    state.commandsList = [
      {
        command: i18n.t("altavozOn"),
        id: "2b0ede11-3f03-4fa5-a26a-c9050b3da3c6",
      },
      {
        command: i18n.t("altvozOff"),
        id: "7664a61c-4ea0-46b6-a528-a14cc50e221",
      },
      {
        command: i18n.t("callOn"), // tiene params
        id: "961c9566-6c9a-489c-94f7-96c2f5258e1f",
      },
      {
        command: i18n.t("ignitionLocked"),
        id: "3ef6dbf3-8dbd-4fba-ad38-17d1f0778918",
      },
      {
        command: i18n.t("ignitionunLocked"),
        id: "e59f6ba1-4087-4f9c-acb7-733bae628e73",
      },
      //{
      //  command: i18n.t("tmReportsOn"), //activar tiene params, desactivar no ?
      //  id: "dd014d97-84e0-4de2-b9c3-ecccd29e016f",
      //},
      //{
      //  command: i18n.t("tmReportsOff"),
      //  id: "dc4d1e78-387d-48b0-b7bb-7d90b1f87d56",
      //},
      // {
      //   command: i18n.t("reportVel"), // tiene params
      //   id: "e5360cf4-f4b2-4661-8986-d66fd2e2076e",
      // },
      // {
      //   command: i18n.t("reportIgnicion"), // tiene params
      //   id: "52154a24-9811-44c9-b431-564742803aa6",
      // },
      //  {
      //    command: i18n.t("repStartStop"), // tiene params
      //    id: "93a12bec-afb8-4a45-b5b6-88562da52e26",
      //  },
      //  {
      //    command: i18n.t("repGpsState"), //params
      //    id: "62eb39ce-5326-4fd1-a6e1-8ebd3d244c93",
      //  },
      {
        command: i18n.t("getImei"), // sin params, devuelve IMEI
        id: "63661284-60ac-44ae-8d8e-3095ef4f08b7",
      },
      {
        command: i18n.t("getSimData"), // sin params, devuelve datos del SIM Card
        id: "3c9d847b-8675-4280-900a-9b8313e58645",
      },
      {
        command: i18n.t("unlockEngine"),
        id: "568755bc-5005-4bf7-904e-3639a1e5e91c",
      },
      {
        command: i18n.t("lockEngine"),
        id: "26c803ee-b0c3-4535-b14f-02352b349cef",
      },
      {
        command: i18n.t("position"),
        id: "9dbb6596-b45a-4f08-a69f-9b028456391b",
      },
      {
        command: i18n.t("resetES"),
        id: "337d28c2-bb0b-4e00-9375-91f2bb6c8960",
      },
      {
        command: i18n.t("resetButtons"),
        id: "267446a7-042a-4188-b004-429b5789a3a4",
      },
      {
        command: i18n.t("activateSiren"),
        id: "ddbf3d87-8f54-49ca-87ba-398b76b575a5",
      },
      {
        command: i18n.t("desactivateSiren"),
        id: "ced3a4d5-f43a-4d8b-8c52-6fd00ace93c6",
      },
    ];

    //Account balance page
    state.ItemsAccountBalancePage = [
      {
        title: i18n.t("vehiclesD"),
        value: 0,
      },
      {
        title: i18n.t("totalFuel"),
        value: 0,
      },
      {
        title: i18n.t("ralentifuel"),
        value: 0,
      },
      {
        title: i18n.t("exceptionsHome"),
        value: 0,
      },
      {
        title: i18n.t("totalDistance"),
        value: 0,
      },
      {
        title: i18n.t("totalPerformance"),
        value: 0,
      },
    ];

    state.itemsDashboardCharts = [
      {
        title: "fuelUsed",
        value: 1,
      },
      {
        title: "RalentiFuel",
        value: 2,
      },
      {
        title: "FuelRange",
        value: 1,
      },
      {
        title: "FuelLowRange",
        value: 2,
      },
      {
        title: "EngineOn",
        value: 1,
      },
      {
        title: "MoreTimeEngineOn",
        value: 2,
      },
      {
        title: "Exceptions",
        value: 1,
      },
      {
        title: "MoreExceptions",
        value: 2,
      },
    ];

    //Individual performance
    state.ItemsPerformance = [
      {
        title: i18n.t("performancePerTime"), //renddimiento
        value: 0,
      },
      {
        title: i18n.t("totalDistance"), //distancia recorrida
        value: 0,
      },
      {
        title: i18n.t("totalFuel"), //combustible consumido
        value: 0,
      },
      // {
      //   title: i18n.t("odometer"), //odometro
      //   value: 0,
      // },
      {
        title: i18n.t("tripTime"), //nueva duracion viaje
        value: 0,
      },
      {
        title: i18n.t("exceptionsHome"), //deficiencias de manejo
        value: 0,
      },
      {
        title: i18n.t("maxSpeed"), //velocidad maxima
        value: 0,
      },
      {
        title: i18n.t("avgSpeed"), //vel prom
        value: 0,
      },
      {
        title: i18n.t("rpmMax"), //rpm maxima
        value: 0,
      },
      {
        title: i18n.t("rpmAvg"), // rpm promedio
        value: 0,
      },
      {
        title: i18n.t("maxMotorLoad"), // Carga de motor maxima
        value: 0,
      },
      {
        title: i18n.t("AvgMotorLoad"), //promedio de carga de motor
        value: 0,
      },
      {
        title: i18n.t("breakTime"), //tiempo descanso
        value: 0,
      },
      // {
      //   title: i18n.t("tripTime"), //duracion viaje
      //   value: 0,
      // },
    ];

    state.itemsBalanceCharts = [
      {
        title: "TotalFuel",
        value: 1,
      },
      {
        title: "FuelWeek",
        value: 2,
      },
      {
        title: "EngineOnTime",
        value: 1,
      },
      {
        title: "EngineOnWeek",
        value: 2,
      },
      {
        title: "Distance",
        value: 1,
      },
      {
        title: "DistanceWeek",
        value: 2,
      },
      {
        title: "Rendimiento",
        value: 1,
      },
      {
        title: "RendimientoSemanal",
        value: 2,
      },
    ];

    state.itemsExceptionsCharts = [
      {
        title: "speedExcess",
      },
      {
        title: "brusqueAccelerations",
      },
      {
        title: "brakedBrusque",
      },
      {
        title: "excessMotoLoad",
      },
      {
        title: "excessRPM",
      },
      {
        title: "clutchExcesses",
      },
      {
        title: "roundBrushes",
      },
      {
        title: "excessEngineHours",
      },
      {
        title: "motorVacuumExceeces",
      },
    ];
    state.itemsTravelEfficiencyCharts = [
      {
        title: "FuelConsumed",
      },
      {
        title: "EngineUsageTime",
      },
      {
        title: "BadHabits",
      },
      {
        title: "FuelControlCrucero",
      },
      {
        title: "TimeControlCrucero",
      },
      {
        title: "DistanceControlCrucero",
      },
    ];
    state.itemsSettings = [
      {
        title: i18n.t("periodTitle"),
        icon: "mdi-calendar",
      },
      {
        title: i18n.t("selectVehicle"),
        icon: "mdi-truck",
      },
    ];
  },
  setChartsValue: (state) => {
    var exporting = {
      buttons: {
        contextButton: {
          menuItems: [
            "printChart",
            "separator",
            "downloadPNG",
            "downloadJPEG",
            "downloadPDF",
            "downloadSVG",
          ],
        },
      },
    };

    var lang = {
      printChart: i18n.t("printChart"),
      downloadPNG: i18n.t("downloadPNG"),
      downloadJPEG: i18n.t("downloadJPEG"),
      downloadPDF: i18n.t("downloadPDF"),
      downloadSVG: i18n.t("downloadSVG"),
    };

    if (vuetify.framework.theme.isDark) {
      //dark mode
      Highcharts.createElement(
        "link",
        {
          href: "https://fonts.googleapis.com/css?family=Unica+One",
          rel: "stylesheet",
          type: "text/css",
        },
        null,
        document.getElementsByTagName("head")[0]
      );

      Highcharts.theme = {
        colors: [
          "#2b908f",
          "#90ee7e",
          "#f45b5b",
          "#7798BF",
          "#aaeeee",
          "#ff0066",
          "#eeaaee",
          "#55BF3B",
          "#DF5353",
          "#7798BF",
          "#aaeeee",
        ],
        chart: {
          backgroundColor: {
            linearGradient: { x1: 0, y1: 0, x2: 1, y2: 1 },
            stops: [[0, "#2a2a2b"], [1, "#3e3e40"]],
          },
          style: {
            fontFamily: "Arial",
          },
          plotBorderColor: "#606063",
        },
        title: {
          style: {
            fontSize: "0.9rem",
            color: "#E0E0E3"
          },
        },
        subtitle: {
          style: {
            fontSize: "0.7rem",
            color: "#E0E0E3"
          },
        },
        xAxis: {
          gridLineColor: "#707073",
          labels: {
            style: {
              fontSize: "0.7rem",
              color: "#E0E0E3"
            },
          },
          title: {
            style: {
              fontSize: "0.7rem",
              color: "#A0A0A3"
            },
          },
        },
        yAxis: {
          labels: {
            style: {
              fontSize: "0.7rem",
              color: "#E0E0E3"
            },
          },
          title: {
            style: {
              fontSize: "0.7rem",
              color: "#A0A0A3"
            },
          },
        },
        tooltip: {
          backgroundColor: "rgba(0, 0, 0, 0.85)",
          style: {
            fontSize: "0.7rem",
            color: "#F0F0F0"
          },
        },
        plotOptions: {
          series: {
            dataLabels: {
              color: "#F0F0F3",
              style: {
                fontSize: "0.7rem"
              },
            },
            marker: {
              lineColor: "#333",
            },
          },
          boxplot: {
            fillColor: "#505053",
          },
          candlestick: {
            lineColor: "white",
          },
          errorbar: {
            color: "white",
          },
        },
        legend: {
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          itemStyle: {
            color: "#E0E0E3",
          },
          itemHoverStyle: {
            color: "#FFF",
          },
          itemHiddenStyle: {
            color: "#606063",
          },
          title: {
            style: {
              color: "#C0C0C0",
            },
          },
        },
        credits: {
          enabled: false,
        },
        labels: {
          style: {
            color: "#707073",
          },
        },

        drilldown: {
          activeAxisLabelStyle: {
            color: "#F0F0F3",
          },
          activeDataLabelStyle: {
            color: "#F0F0F3",
          },
        },

        navigation: {
          buttonOptions: {
            symbolStroke: "#DDDDDD",
            theme: {
              fill: "#505053",
            },
          },
        },

        // scroll charts
        rangeSelector: {
          buttonTheme: {
            fill: "#505053",
            stroke: "#000000",
            style: {
              color: "#CCC",
            },
            states: {
              hover: {
                fill: "#707073",
                stroke: "#000000",
                style: {
                  color: "white",
                },
              },
              select: {
                fill: "#000003",
                stroke: "#000000",
                style: {
                  color: "white",
                },
              },
            },
          },
          inputBoxBorderColor: "#505053",
          inputStyle: {
            backgroundColor: "#333",
            color: "silver",
          },
          labelStyle: {
            color: "silver",
          },
        },
        lang: lang,
        navigator: {
          handles: {
            backgroundColor: "#666",
            borderColor: "#AAA",
          },
          outlineColor: "#CCC",
          maskFill: "rgba(255,255,255,0.1)",
          series: {
            color: "#7798BF",
          },
          xAxis: {
            gridLineColor: "#505053",
          },
        },

        scrollbar: {
          barBackgroundColor: "#808083",
          barBorderColor: "#808083",
          buttonArrowColor: "#CCC",
          buttonBackgroundColor: "#606063",
          buttonBorderColor: "#606063",
          rifleColor: "#FFF",
          trackBackgroundColor: "#404043",
          trackBorderColor: "#404043",
        },
      };

      // Apply the theme
      Highcharts.setOptions(Highcharts.theme);
    } else {
      //light mode
      Highcharts.createElement(
        "link",
        {
          href: "https://fonts.googleapis.com/css?family=Dosis:400,600",
          rel: "stylesheet",
          type: "text/css",
        },
        null,
        document.getElementsByTagName("head")[0]
      );

      Highcharts.theme = {
        colors: [
          "#7cb5ec",
          "#f7a35c",
          "#90ee7e",
          "#7798BF",
          "#aaeeee",
          "#ff0066",
          "#eeaaee",
          "#55BF3B",
          "#DF5353",
          "#7798BF",
          "#aaeeee",
        ],
        chart: {
          backgroundColor: "#f5f5f5",
          style: {
            fontFamily: "Arial",
            color: "#000",
          },
        },
        lang: lang,
        title: {
          style: {
            fontSize: "0.9rem",
            color: "#000",
          },
        },
        subtitle: {
          style: {
            fontSize: "0.7rem",
            color: "#000",
          },
        },
        tooltip: {
          borderWidth: 0,
          backgroundColor: "rgba(219,219,216,0.8)",
          shadow: false,
          style: {
            fontSize: "0.7rem",
            color: "#000"
          },
        },
        legend: {
          backgroundColor: "#F0F0EA",
          itemStyle: {
            fontSize: "0.7rem",
            color: "#000",
          },
          itemHoverStyle: {
            color: "#000",
          },
          itemHiddenStyle: {
            color: "#606063",
          },
          title: {
            style: {
              fontSize: "0.7rem",
              color: "#C0C0C0"
            },
          },
        },
        xAxis: {
          labels: {
            style: {
              fontSize: "0.7rem",
              color: "#000",
            },
          },
        },
        yAxis: {
          title: {
            style: {
              fontSize: "0.7rem",
              color: "#000"
            },
          },
          labels: {
            style: {
              fontSize: "0.7rem",
              color: "#000",
            },
          },
        },
        plotOptions: {
          series: {
            dataLabels: {
              color: "black",
              style: {
                fontSize: "0.7rem",
              },
            },
          },

          candlestick: {
            lineColor: "#404048",
          },
        },
      };

      // Apply the theme
      Highcharts.setOptions(Highcharts.theme);
    }

    state.PieChartOptions = {};
    state.ChartStackedOptiones = {};
    state.ChartVehiclesExceptions = {};

    state.PieChartOptions = {
      chart: {
        renderTo: "",
        style: {
          fontFamily: "Arial",
        },
      },
      lang: lang,
      responsive: {},
      tooltip: {},
      title: {
        text: "",
      },
      subtitle: {
        text: "Total: ",
      },
      colors: [
        "#084475",
        "#2f7573",
        "#2b59a2",
        "#75808c",
        "#4d4d4d",
        "#389fcf",
        "#2b648a",
      ],
      credits: {
        enabled: false,
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: "pointer",
          dataLabels: {
            enabled: false,
          },
          showInLegend: true,
        },
      },
      legend: {
        enabled: true,
        x: 0,
        align: "center",
        itemDistance: 20,
        itemStyle: {
          fontSize: "0.7rem",
        },
      },

      exporting: exporting,
      series: [
        {
          name: "Total",
          type: "pie",
          allowPointSelect: true,
          keys: ["name", "y", "selected", "sliced"],
          data: [],
        },
      ],
    };

    state.ChartStackedOptiones = {
      responsive: {},
      title: {
        text: "",
      },
      chart: {
        type: "column",
        renderTo: "",
        options3d: {
          enabled: true,
          alpha: 0,
          beta: 0,
          viewDistance: 30,
          depth: 40,
        },
        style: {
          fontFamily: "Arial",
        },
        scrollablePlotArea: {
          minWidth: 700,
          scrollPositionX: 0,
        },
      },
      credits: {
        enabled: false,
      },
      exporting: exporting,
      subtitle: {
        text: "",
      },
      colors: ["#2f7573", "#2b59a2"],
      xAxis: {
        categories: ["Apples", "Oranges"],
        labels: {
          skew3d: true,
          style: {
            fontSize: "0.7rem",
          },
        },
      },
      yAxis: {
        min: 0,
        title: {
          text: "",
          skew3d: true,
        },
      },
      legend: {
        enabled: false,
      },
      tooltip: {
        pointFormat:
          '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
        shared: true,
      },
      plotOptions: {
        column: {
          stacking: "percent",
          depth: 40,
        },
      },
      series: [
        {
          name: "Combustible en vacío",
          data: [],
        },
        {
          name: "Combustible en vacío",
          data: [],
        },
        {
          name: "Combustible en vacío",
          data: [],
        },
        {
          name: "Combustible en vacío",
          data: [],
        },
      ],
    };

    state.ChartTraffic = {
      responsive: {},
      title: {
        text: "Vehículos con mas combustible en vacío",
      },
      chart: {
        type: "bar",
        renderTo: "",
        height: 400,
        scrollablePlotArea: {
          minWidth: 700,
          scrollPositionX: 0,
        },
        style: {
          fontFamily: "Arial",
        },
      },
      credits: {
        enabled: false,
      },
      exporting: exporting,
      subtitle: {
        text: "Periodo: dd/mm/aaaa",
      },
      xAxis: {
        type: "category",
        labels: {
          style: {
            fontSize: "0.7rem",
            fontFamily: "Verdana, sans-serif",
          },
        },
      },
      yAxis: {
        min: 0,
        title: {
          text: "Total fruit consumption",
        },
      },
      legend: {
        enabled: true,
      },
      tooltip: {
        headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
        pointFormat:
          '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.2f}%</b> of total<br/>',
      },
      plotOptions: {
        bar: {
          color: "#699041",
          dataLabels: {
            enabled: true,
            format: "{y}°C",
          },
        },
      },
      series: [
        {
          // keys: ["name", "y", "dataLabels.style.visibility"],
          name: "Combustible en vacío",
          data: [],
          dataLabels: {
            enabled: true,
            //rotation: -90,
            //align: "right",
            //format: "{point.y}", // one decimal
            //y: 10, // 10 pixels down from the top
            style: {
              //visibility: "visible",
              fontSize: "0.7rem",
              fontFamily: "Verdana, sans-serif",
            },
          },
        },
      ],
    };

    state.ChartVehiclesExceptions = {
      responsive: {},
      title: {
        text: "Vehículos con mas combustible en vacío",
      },
      chart: {
        type: "column",
        renderTo: "",
        height: 400,
        scrollablePlotArea: {
          minWidth: 700,
          scrollPositionX: 0,
        },
        style: {
          fontFamily: "Arial",
        },
      },
      credits: {
        enabled: false,
      },
      exporting: exporting,
      subtitle: {
        text: "Periodo: dd/mm/aaaa",
      },
      xAxis: {
        type: "category",
        labels: {
          rotation: -45,
          style: {
            fontSize: "0.7rem",
            fontFamily: "Arial",
          },
        },
      },
      yAxis: {
        min: 0,
        title: {
          text: "Combustible (litros)",
        },
      },
      legend: {
        enabled: false,
      },
      tooltip: {
        pointFormat: "Combustible en vacío: <b>{point.y:.1f} litros</b>",
      },
      plotOptions: {
        column: {
          color: "#699041",
          dataLabels: {
            enabled: true,
            //format: "{y}°C",
          },
        },
      },
      series: [
        {
          // keys: ["name", "y", "dataLabels.style.visibility"],
          name: "Combustible en vacío",
          data: [],
          dataLabels: {
            enabled: true,
            //rotation: -90,
            //align: "right",
            //format: "{point.y}", // one decimal
            //y: 10, // 10 pixels down from the top
            style: {
              //visibility: "visible",
              fontSize: "0.7rem",
              fontFamily: "Verdana, sans-serif",
            },
          },
        },
      ],
    };
  },
  saveChartsFill: (state, payload) => {
    state.TotalFuel = payload[0];
    state.FuelWeek = payload[1];
    state.EngineOnTime = payload[2];
    state.EngineOnWeek = payload[3];
    state.Distance = payload[4];
    state.DistanceWeek = payload[5];
    state.Rendimiento = payload[6];
    state.RendimientoSemanal = payload[7];

    new Highcharts.Chart("TotalFuel", state.TotalFuel);
    new Highcharts.Chart("FuelWeek", state.FuelWeek);
    //new Highcharts.Chart("EngineOnTime", state.EngineOnTime);
    new Highcharts.Chart("EngineOnWeek", state.EngineOnWeek);
    new Highcharts.Chart("Distance", state.Distance);
    new Highcharts.Chart("DistanceWeek", state.DistanceWeek);
    new Highcharts.Chart("Rendimiento", state.Rendimiento);
    new Highcharts.Chart("RendimientoSemanal", state.RendimientoSemanal);
  },
  saveCharts: (state, payload) => {
    //guarda estos elementos en local storage
    //para llenar las graficas de la otra ventana
    state.fuelUsed = payload[0];

    state.RalentiFuel = payload[1];

    state.FuelRange = payload[2];

    state.FuelLowRange = payload[3];

    state.EngineOn = payload[4];

    state.MoreTimeEngineOn = payload[5];

    state.Exceptions = payload[6];

    state.MoreExceptions = payload[7];

    if (router.app.$route.path == "/dashboard") {
      new Highcharts.Chart("fuelUsed", state.fuelUsed);
      new Highcharts.Chart("RalentiFuel", state.RalentiFuel);
      new Highcharts.Chart("FuelRange", state.FuelRange);
      new Highcharts.Chart("FuelLowRange", state.FuelLowRange);
      new Highcharts.Chart("EngineOn", state.EngineOn);
      new Highcharts.Chart("MoreTimeEngineOn", state.MoreTimeEngineOn);
      new Highcharts.Chart("Exceptions", state.Exceptions);
      new Highcharts.Chart("MoreExceptions", state.MoreExceptions);
    } else {
      if (
        state.titleGraphic == "fuelUsed" ||
        state.titleGraphic == "RalentiFuel"
      ) {
        new Highcharts.Chart(state.titleGraphic, state.fuelUsed);
        new Highcharts.Chart(state.titleGraphic + "2", state.RalentiFuel);
      } else if (
        state.titleGraphic == "FuelRange" ||
        state.titleGraphic == "FuelLowRange"
      ) {
        new Highcharts.Chart(state.titleGraphic, state.FuelRange);
        new Highcharts.Chart(state.titleGraphic + "2", state.FuelLowRange);
      } else if (
        state.titleGraphic == "EngineOn" ||
        state.titleGraphic == "MoreTimeEngineOn"
      ) {
        new Highcharts.Chart(state.titleGraphic, state.EngineOn);
        new Highcharts.Chart(state.titleGraphic + "2", state.MoreTimeEngineOn);
      } else if (
        state.titleGraphic == "Exceptions" ||
        state.titleGraphic == "MoreExceptions"
      ) {
        new Highcharts.Chart(state.titleGraphic, state.Exceptions);
        new Highcharts.Chart(state.titleGraphic + "2", state.MoreExceptions);
      }
    }
  },
  saveChartsEx: (state, payload) => {
    state.speedExcess = payload[0];
    state.brusqueAccelerations = payload[1];
    state.brakedBrusque = payload[2];
    state.excessMotoLoad = payload[3];
    state.excessRPM = payload[4];
    state.clutchExcesses = payload[5];
    state.roundBrushes = payload[6];
    state.excessEngineHours = payload[7];
    state.motorVacuumExceeces = payload[8];

    new Highcharts.Chart("speedExcess", state.speedExcess);
    new Highcharts.Chart("brusqueAccelerations", state.brusqueAccelerations);
    new Highcharts.Chart("brakedBrusque", state.brakedBrusque);
    new Highcharts.Chart("excessMotoLoad", state.excessMotoLoad);
    new Highcharts.Chart("excessRPM", state.excessRPM);
    new Highcharts.Chart("clutchExcesses", state.clutchExcesses);
    new Highcharts.Chart("roundBrushes", state.roundBrushes);
    new Highcharts.Chart("excessEngineHours", state.excessEngineHours);
    new Highcharts.Chart("motorVacuumExceeces", state.motorVacuumExceeces);
  },

  saveChartsTraffic: (state, value) => {
    state.Trafficdetails = value;

    new Highcharts.Chart("traffic", state.Trafficdetails);
  },

  rememberMe: (state, value) => {
    state.remember = value;
  },

  invalidUser: (state, value) => {
    state.invalidUser = value;
  },

  secureUsers: (state, value) => {
    state.secureUsers = [];
    if (value.length > 0) {
      value.forEach((secureUsers, index) => {
        if (secureUsers.Active == true)
          var Active = i18n.t("active").toUpperCase();
        else var Active = i18n.t("inactive").toUpperCase();

        var period = moment(secureUsers.JoinDate).format("DD/MM/YYYY");

        if (i18n.locale == "en") {
          period = moment(secureUsers.JoinDate).format("MM/DD/YYYY");
        }

        var item = {
          Active: Active,
          DealerId: secureUsers.DealerId,
          DealerName: secureUsers.DealerName,
          Id: secureUsers.Id,
          JoinDate: period,
          SecretKey: secureUsers.SecretKey,
        };
        state.secureUsers.push(item);
      });
    }
  },
  dealersList: (state, value) => {
    state.dealersList = [];
    if (value.length > 0) {
      value.forEach((dealersList, index) => {
        if (dealersList.State == "active")
          var State = i18n.t("active").toUpperCase();
        else var State = i18n.t("inactive").toUpperCase();

        var item = {
          AnerpvId: dealersList.AnerpvId,
          DealerId: dealersList.DealerId,
          Id: dealersList.Id,
          NIP: dealersList.NIP,
          Name: dealersList.Name,
          State: State,
        };
        state.dealersList.push(item);
      });
    }
  },
  imageLogo: (state, value) => {
    state.imageLogo = value;
  },
  userImage: (state, value) => {
    state.userImage = value;
  },
  setColorSelected: (state, value) => {
    state.colorTheme = value;
  },
  progressColor: (state, value) => {
    if (value) state.progressColor = "#FFFFFF";
    else state.progressColor = "#424242";
  },
  settings: (state) => {
    state.settings = !state.settings;
  },
  swicth: (state, value) => {
    state.swicth = !state.swicth;
  },
  temp: (state, value) => {
    state.temp = !state.temp;
  },
  drawer: (state, value) => {
    state.drawer = value;
  },
  SelectedDistance: (state, value) => {
    state.SelectedDistance = value;
  },
  SelectedVolume: (state, value) => {
    state.SelectedVolume = value;
  },
  SelectedTemperature: (state, value) => {
    state.SelectedTemperature = value;
  },

  setItemsDashboard: (state, value) => {
    state.SelectedVolume =
      localStorage.getItem("Volume") == undefined
        ? "L"
        : localStorage.getItem("Volume");

    state.SelectedDistance =
      localStorage.getItem("Distance") == undefined
        ? "Km"
        : localStorage.getItem("Distance");

    var distances = state.SelectedDistance.toUpperCase();
    var volumes = state.SelectedVolume.toUpperCase();

    state.ItemsDashboard[0].value =
      localStorage.getItem("last_Request") == undefined
        ? state.vehicles.length
        : JSON.parse(localStorage.getItem("last_Request"))[0].Vehicles.length;
    var checkRendimientoTotal = value.Performance.Avg;
    if (state.SelectedVolume == "L") {
      state.ItemsDashboard[1].value = formatNumber.new(value.Fuel.Total, "L");

      state.ItemsDashboard[2].value = formatNumber.new(
        value.Fuel.Ralenti.Total,
        "L"
      );
    } else {
      var checkTotalFuel = value.Fuel.Total;
      if (checkTotalFuel == 0) {
        totalFuel = checkTotalFuel;
        state.ItemsDashboard[1].value = formatNumber.new(totalFuel, "gal");
      } else {
        var totalFuel = parseFloat(value.Fuel.Total / 3.78541).toFixed(1);
        state.ItemsDashboard[1].value = formatNumber.new(totalFuel, "gal");
      }

      var checkRalenti = value.Fuel.Ralenti.Total;
      if (checkRalenti == 0) {
        ralentifuel = checkRalenti;
        state.ItemsDashboard[2].value = formatNumber.new(ralentifuel, "gal");
      } else {
        var ralentifuel = parseFloat(
          value.Fuel.Ralenti.Total / 3.78541
        ).toFixed(1);
        state.ItemsDashboard[2].value = formatNumber.new(ralentifuel, "gal");
      }
    }
    state.ItemsDashboard[3].value = formatNumber.new(
      value.IntransitIncidents.Total,
      ""
    );

    if (distances == "KM") {
      state.ItemsDashboard[4].value = formatNumber.new(value.Distance, "Km");
    } else {
      var checkDistance = value.Distance;

      if (checkDistance == 0) {
        totalDistance = formatNumber.new(checkDistance, "mi");
        state.ItemsDashboard[4].value = totalDistance;
      } else {
        var totalDistance = parseFloat(value.Distance / 1.609).toFixed(3);
        state.ItemsDashboard[4].value = formatNumber.new(totalDistance, "mi");
      }
    }
    var rendimientoTotal = checkRendimientoTotal;
    if (volumes == "L" && distances == "KM") {
      state.ItemsDashboard[5].value = formatNumber.new(
        rendimientoTotal,
        "Km/L"
      );
    }

    if (volumes == "GAL" && distances == "MI") {
      if (checkRendimientoTotal == 0) {
        state.ItemsDashboard[5].value = formatNumber.new(
          rendimientoTotal,
          "mi/gal"
        );
      } else {
        rendimientoTotal = parseFloat(rendimientoTotal * 2.358).toFixed(2);
        state.ItemsDashboard[5].value = formatNumber.new(
          rendimientoTotal,
          "mi/gal"
        );
      }
    }

    if (volumes == "GAL" && distances == "KM") {
      if (checkRendimientoTotal == 0) {
        state.ItemsDashboard[5].value = formatNumber.new(
          rendimientoTotal,
          "Km/gal"
        );
      } else {
        rendimientoTotal = parseFloat(rendimientoTotal * 3.78).toFixed(2);
        state.ItemsDashboard[5].value = formatNumber.new(
          rendimientoTotal,
          "Km/gal"
        );
      }
    }

    if (volumes == "L" && distances == "MI") {
      if (checkRendimientoTotal == 0) {
        state.ItemsDashboard[5].value = formatNumber.new(
          rendimientoTotal,
          "mi/L"
        );
      } else {
        rendimientoTotal = parseFloat(rendimientoTotal * 0.62).toFixed(2);
        state.ItemsDashboard[5].value = formatNumber.new(
          rendimientoTotal,
          "mi/L"
        );
      }
    }
  },
  //Rastreo, para mostrar los datos en estatus
  setItemsTracking: (state, value) => {
    state.SelectedVolume =
      localStorage.getItem("Volume") == undefined
        ? "L"
        : localStorage.getItem("Volume");

    state.SelectedDistance =
      localStorage.getItem("Distance") == undefined
        ? "Km"
        : localStorage.getItem("Distance");

    if (value.Speed > 0) {
      if (state.SelectedDistance == "Km") {
        var distance = parseFloat(value.Speed)
          .toFixed(3)
          .replace(/\.000$/, "");
        state.refGeo[3].value = formatNumber.new(distance, "Km/h");
      } else {
        var distance = parseFloat(value.Speed / 1.609)
          .toFixed(3)
          .replace(/\.000$/, "");
        state.refGeo[3].value = formatNumber.new(distance, "mi/h");
      }
    } else if (value.Speed == 0) {
      if (state.SelectedDistance == "Km") {
        state.refGeo[3].value = "0 Km/h";
      } else {
        state.refGeo[3].value = "0 mi/h";
      }
    } else {
      state.refGeo[3].value = i18n.t("valueNotAvailable");
    }

    if (value.Odometer > 0) {
      if (state.SelectedDistance == "Km") {
        var distance = parseFloat(value.Odometer)
          .toFixed(3)
          .replace(/\.000$/, "");
        state.refGeo[6].value = formatNumber.new(distance, "Km");
      } else {
        var distance = parseFloat(value.Odometer / 1.609)
          .toFixed(3)
          .replace(/\.000$/, "");
        state.refGeo[6].value = formatNumber.new(distance, "mi");
      }
    } else if (value.Odometer == 0) {
      if (state.SelectedDistance == "Km") {
        state.refGeo[6].value = "0 Km";
      } else {
        state.refGeo[6].value = "0 mi";
      }
    } else {
      state.refGeo[6].value = i18n.t("valueNotAvailable");
    }

    state.topData[0].value = value.DeviceIdAndNick;
    state.topData[1].value = value.Address;
    state.topData[2].value = i18n.t("timeWT") + " " + value.IdleTime;
    state.topData[3].value =
      state.refGeo[3].value + " " + i18n.t("dateT") + ": " + value.DateGPS;

    state.vehicleData[0].value =
      value.Properties.Plates == "~" ? "N/A" : value.Properties.Plates;
    state.vehicleData[1].value =
      value.Properties.Year == 0 ? "N/A" : value.Properties.Year;
    state.vehicleData[2].value =
      value.Properties.Color == "~" ? "N/A" : value.Properties.Color;
    state.vehicleData[3].value =
      value.Properties.Brand == "~" ? "N/A" : value.Properties.Brand;
    state.vehicleData[4].value =
      value.Properties.Category == null ? "ND" : value.Properties.Category;
    state.vehicleData[5].value =
      value.Properties.Comments == "~" ? "N/A" : value.Properties.Comments;
    state.vehicleData[6].value =
      value.Properties.OperationState == "~"
        ? "N/A"
        : value.Properties.OperationState;

    state.refGeo[0].value = value.DateGPS;
    state.refGeo[1].value = value.DateServer;
    state.refGeo[2].value = value.Location.Lat + " " + value.Location.Lon;
    //state.refGeo[3].value = value.Speed + " " + state.SelectedDistance + " /h";
    state.refGeo[4].value =  value.Address;
    state.refGeo[5].value = value.Course + " Grd, " + value.Orientation;
    //state.refGeo[6].value = value.Odometer + " " + state.SelectedDistance;
    state.refGeo[7].value = value.Batery;
    state.refGeo[8].value = value.EventData;
    var hex = value.Status;
    var i,
      convert = "";
    var equalsTo = {
      "0": "0000",
      "1": "0001",
      "2": "0010",
      "3": "0011",
      "4": "0100",
      "5": "0101",
      "6": "0110",
      "7": "0111",
      "8": "1000",
      "9": "1001",
      a: "1010",
      b: "1011",
      c: "1100",
      d: "1101",
      e: "1110",
      f: "1111",
      A: "1010",
      B: "1011",
      C: "1100",
      D: "1101",
      E: "1110",
      F: "1111",
    };
    for (i = 0; i < hex.length; i += 1) {
      if (equalsTo.hasOwnProperty(hex[i])) convert += equalsTo[hex[i]];
    }
    var bit = convert;
    //console.log.log(bit);
    var bit31 = bit[31];
    var bit30 = bit[30];
    var bit29 = bit[29];
    var bit28 = bit[28];
    var bit27 = bit[27];
    var bit26 = bit[26];
    var bit25 = bit[25];
    var bit24 = bit[24];
    var bit23 = bit[23];
    var bit22 = bit[22];
    var bit21 = bit[21];
    var bit20 = bit[20];
    var bit19 = bit[19];
    var bit18 = bit[18];
    var bit17 = bit[17];
    var bit16 = bit[16];
    var bit15 = bit[15];
    var bit14 = bit[14];
    var bit13 = bit[13];
    var bit12 = bit[12];
    var bit11 = bit[11];
    var bit10 = bit[10];
    var bit9 = bit[9];
    var bit8 = bit[8];
    var bit7 = bit[7];
    var bit6 = bit[6];
    var bit5 = bit[5];
    var bit4 = bit[4];
    var bit3 = bit[3];
    var bit2 = bit[2];
    var bit1 = bit[1];
    var bit0 = bit[0];

    if (bit31 == 1) {
      //console.log.log("Botón de Pánico activado");
      state.inAndOutVeh[2].value = true;
    } else {
      //console.log.log("Botón de Pánico desactivado");
      state.inAndOutVeh[2].value = false;
    }

    if (bit30 == 1) {
      //console.log.log("Botón de Soporte activado");
      state.inAndOutVeh[4].value = true;
    } else {
      //console.log.log("Botón de Soporte desactivado");
      state.inAndOutVeh[4].value = false;
    }

    if (bit29 == 1) {
      //console.log.log("Botón de Ayuda activado");
      state.inAndOutVeh[6].value = true;
    } else {
      //console.log.log("Botón de Ayuda desactivado");
      state.inAndOutVeh[6].value = false;
    }

    if (bit28 == 1) {
      //console.log.log("Switch de Ignición activado");
      state.inAndOutVeh[0].value = true;
    } else {
      //console.log.log("Switch de Ignición desactivado");
      state.inAndOutVeh[0].value = false;
    }

    if (bit27 == 1) {
      //console.log.log("Señal GPS activado");
      state.connectionVeh[0].value = true;
    } else {
      //console.log.log("Señal GPS desactivado");
      state.connectionVeh[0].value = false;
    }

    if (bit26 == 1) {
      ////console.log.log('Ahorro de Energia activado');
      // state.inAndOutVeh[5].value = true;
    } else {
      // //console.log.log('Ahorro de Energia desactivado');
      // state.inAndOutVeh[5].value = false;
    }

    if (bit25 == 1) {
      //console.log.log("Salida 3 - Bloqueo de Ignición activado");
      state.inAndOutVeh[1].value = true;
    } else {
      //console.log.log("Salida 3 - Bloqueo de Ignición desactivado");
      state.inAndOutVeh[1].value = false;
    }

    if (bit24 == 1) {
      //console.log.log("Salida 5 - Bloqueo de Motor activado");
      state.inAndOutVeh[3].value = true;
    } else {
      //console.log.log("Salida 5 - Bloqueo de Motor desactivado");
      state.inAndOutVeh[3].value = false;
    }

    if (bit23 == 1) {
      //console.log.log("Salida 1 - Control de Luces activado");
      state.inAndOutVeh[5].value = true;
    } else {
      //console.log.log("Salida 1 - Control de Luces desactivado");
      state.inAndOutVeh[5].value = false;
    }

    if (bit22 == 1) {
      //console.log('Salida 1 - Control de Sirenas activado');
      // state.inAndOutVeh[9].value = true;
    } else {
      //console.log('Salida 1 - Control de Sirenas desactivado');
      // state.inAndOutVeh[9].value = false;
    }

    if (bit21 == 1) {
      //console.log('Manos Libres - Altavoz activado');
      // state.inAndOutVeh[10].value = true;
    } else {
      //console.log('Manos Libres - Altavoz desactivado');
      // state.inAndOutVeh[10].value = false;
    }

    if (bit20 == 1) {
      //console.log('Manos Libres - Microfono activado');
      // state.inAndOutVeh[11].value = true;
    } else {
      // console.log('Manos Libres - Microfono desactivado');
      // state.inAndOutVeh[11].value = false;
    }

    if (bit19 == 1) {
      //console.log.log("Registrado en Red GSM activado");
      state.connectionVeh[2].value = true;
    } else {
      //console.log.log("Registrado en Red GSM desactivado");
      state.connectionVeh[2].value = false;
    }

    if (bit18 == 1) {
      //console.log('Modalidad SMS activado');
      // state.inAndOutVeh[13].value = true;
    } else {
      //console.log('Modalidad SMS desactivado');
      // state.inAndOutVeh[13].value = false;
    }

    if (bit17 == 1) {
      //.log("Conectado al Servidor (Bridge) activado");
      state.connectionVeh[4].value = true;
    } else {
      //.log("Conectado al Servidor (Bridge) desactivado");
      state.connectionVeh[4].value = false;
    }

    if (bit16 == 1) {
      //console.log('Llave de pulso invalida activado');
      // state.inAndOutVeh[15].value = true;
    } else {
      //onsole.log('Llave de pulso invalida desactivado');
      // state.inAndOutVeh[15].value = false;
    }

    if (bit15 == 1) {
      //console.log('Encendido sin llave de pulso valida activado');
      // state.inAndOutVeh[16].value = true;
    } else {
      //console.log('Encendido sin llave de pulso valida desactivado');
      // state.inAndOutVeh[16].value = true;
    }

    if (bit14 == 1) {
      //console.log('Valet Parking activado');
      // state.inAndOutVeh[17].value = true;
    } else {
      //console.log('Valet Parking desactivado');
      // state.inAndOutVeh[17].value = false;
    }

    if (bit13 == 1) {
      //console.log('Alarma habilitada activado');
      // state.inAndOutVeh[18].value = true;
    } else {
      //console.log('Alarma habilitada desactivado');
      // state.inAndOutVeh[18].value = false;
    }

    if (bit12 == 1) {
      //console.log('Arrastrado sin llave de pulso valida activado');
      // state.inAndOutVeh[19].value = true;
    } else {
      //console.log('Arrastrado sin llave de pulso valida desactivado');
      // state.inAndOutVeh[19].value = false;
    }

    if (bit11 == 1) {
      //console.log('Alarma Armada activado');
      // state.inAndOutVeh[20].value = true;
    } else {
      //console.log('Alarma Armada desactivado');
      // state.inAndOutVeh[20].value = false;
    }

    if (bit10 == 1) {
      //.log("Modalidad de Auto-Reportes activado");
      state.connectionVeh[1].value = true;
    } else {
      //.log("Modalidad de Auto-Reportes desactivado");
      state.connectionVeh[1].value = false;
    }
    /////////
    if (bit9 == 1) {
      //.log("GPS Valido activado");
      state.connectionVeh[3].value = true;
    } else {
      //.log("GPS Valido desactivado");
      state.connectionVeh[3].value = false;
    }

    if (bit8 == 1) {
      //.log("Salida 4 - Cerrar Seguros activado");
      state.inAndOutVeh[7].value = true;
    } else {
      //.log("Salida 4 - Cerrar Seguros desactivado");
      state.inAndOutVeh[7].value = false;
    }

    if (bit7 == 1) {
      //.log("Salida 2 - Abrir Seguros activado");
      state.inAndOutVeh[9].value = true;
    } else {
      //.log("Salida 2 - Abrir Seguros desactivado");
      state.inAndOutVeh[9].value = false;
    }

    if (bit6 == 1) {
      //console.log('Historial activado');
      // state.inAndOutVeh[25].value = true;
    } else {
      // console.log('Historial desactivado');
      // state.inAndOutVeh[25].value = false;
    }

    if (bit5 == 1) {
      //console.log('Reservado activado');
      // state.inAndOutVeh[26].value = true;
    } else {
      //console.log('Reservado desactivado');
      // state.inAndOutVeh[26].value = false;
    }

    if (bit4 == 1) {
      //console.log('Reservado activado');
      // state.inAndOutVeh[27].value = true;
    } else {
      //console.log('Reservado desactivado');
      // state.inAndOutVeh[27].value = false;
    }

    if (bit3 == 1) {
      //console.log('Reservado activado');
      // state.inAndOutVeh[28].value = true;
    } else {
      //console.log('Reservado desactivado');
      // state.inAndOutVeh[28].value = false;
    }

    if (bit2 == 1) {
      //console.log('Reservado activado');
      // state.inAndOutVeh[29].value = true;
    } else {
      //console.log('Reservado desactivado');
      // state.inAndOutVeh[29].value = false;
    }

    if (bit1 == 1) {
      //console.log('Reservado activado');
      // state.inAndOutVeh[30].value = true;
    } else {
      //console.log('Reservado desactivado');
      // state.inAndOutVeh[30].value = false;
    }

    if (bit0 == 1) {
      //  console.log("Bateria Principal activado");
      state.inAndOutVeh[8].value = true;
    } else {
      // console.log("Bateria Principal desactivado");
      state.inAndOutVeh[8].value = false;
    }
    state.refGeo = state.refGeo;
  },
  UnitSystemValues: (state) => {
    state.SelectedDistance =
      localStorage.getItem("Distance") == undefined
        ? "Km"
        : localStorage.getItem("Distance");
    state.SelectedVolume =
      localStorage.getItem("Volume") == undefined
        ? "L"
        : localStorage.getItem("Volume");
    state.SelectedTemperature =
      localStorage.getItem("Temperature") == undefined
        ? "°C"
        : localStorage.getItem("Temperature");
  },
  ViewUnitSystem: (state) => {
    state.distance =
      localStorage.getItem("Distance") == undefined
        ? "Km"
        : localStorage.getItem("Distance");
    state.volume =
      localStorage.getItem("Volume") == undefined
        ? "L"
        : localStorage.getItem("Volume");
    state.temperature =
      localStorage.getItem("Temperature") == undefined
        ? "°C"
        : localStorage.getItem("Temperature");
  },
  converData: (state) => {
    var Items = JSON.parse(localStorage.getItem("ItemsDashboard"));
    if (Items != null || Items != undefined) {
      var totalFuel = Items.Fuel.Total;
      var ralentifuel = Items.Fuel.Ralenti.Total;
      var totalDistance = Items.Distance;
      var totalPerformance = Items.Performance.Avg;

      localStorage.setItem("Volume", state.SelectedVolume);
      localStorage.setItem("Distance", state.SelectedDistance);
      localStorage.setItem("Temperature", state.SelectedTemperature);

      state.volume = state.SelectedVolume;
      state.distance = state.SelectedDistance;
      state.temperature = state.SelectedTemperature;

      if (state.SelectedVolume == "L") {
        state.ItemsDashboard[1].value = formatNumber.new(totalFuel, "L");
        state.ItemsDashboard[2].value = formatNumber.new(ralentifuel, "L");
      } else {
        if (totalFuel == 0) {
          state.ItemsDashboard[1].value = formatNumber.new(totalFuel, "gal");
        } else {
          var totalFuelgal = parseFloat(totalFuel * 0.264172051).toFixed(1);
          state.ItemsDashboard[1].value = formatNumber.new(totalFuelgal, "gal");
        }
        if (ralentifuel == 0) {
          state.ItemsDashboard[2].value = formatNumber.new(ralentifuel, "gal");
        } else {
          var ralentifuelTotal = parseFloat(ralentifuel * 0.264172051).toFixed(
            1
          );
          state.ItemsDashboard[2].value = formatNumber.new(
            ralentifuelTotal,
            "gal"
          );
        }
      }

      if (state.SelectedDistance == "Km") {
        state.ItemsDashboard[4].value = formatNumber.new(totalDistance, "Km");
      } else {
        if (totalDistance == 0) {
          state.ItemsDashboard[4].value = formatNumber.new(totalDistance, "mi");
        } else {
          var Distancetotal = parseFloat(totalDistance * 0.621371192).toFixed(
            3
          );
          state.ItemsDashboard[4].value = formatNumber.new(Distancetotal, "mi");
        }
      }

      if (state.SelectedVolume == "L" && state.SelectedDistance == "Km") {
        state.ItemsDashboard[5].value = formatNumber.new(
          totalPerformance,
          "Km/L"
        );
      }

      if (state.SelectedVolume == "gal" && state.SelectedDistance == "mi") {
        if (totalPerformance == 0) {
          state.ItemsDashboard[5].value = formatNumber.new(
            totalPerformance,
            "mi/gal"
          );
        } else {
          totalPerformance = parseFloat(totalPerformance * 2.35).toFixed(2);
          state.ItemsDashboard[5].value = formatNumber.new(
            totalPerformance,
            "mi/gal"
          );
        }
      }

      if (state.SelectedVolume == "gal" && state.SelectedDistance == "Km") {
        if (totalPerformance == 0) {
          state.ItemsDashboard[5].value = formatNumber.new(
            totalPerformance,
            "Km/gal"
          );
        } else {
          totalPerformance = parseFloat(totalPerformance * 3.78).toFixed(2);
          state.ItemsDashboard[5].value = formatNumber.new(
            totalPerformance,
            "Km/gal"
          );
        }
      }

      if (state.SelectedVolume == "L" && state.SelectedDistance == "mi") {
        if (totalPerformance == 0) {
          state.ItemsDashboard[5].value = formatNumber.new(
            totalPerformance,
            "mi/L"
          );
        } else {
          totalPerformance = parseFloat(totalPerformance * 0.62).toFixed(2);
          state.ItemsDashboard[5].value = formatNumber.new(
            totalPerformance,
            "mi/L"
          );
        }
      }
    }
  },
  viewAwait: (state, payload) => {
    state.titleAwait = payload[1];
    state.itemsAwait = payload[0];
    if (state.skeleton == "outskeleton") {
      state.itemsAwait = false;
    }
  },
  viewSkeletons: (state, payload) => {
    state.viewSkeletons = payload;
    if (payload) {
      state.skeleton = "skeleton";
      state.skeletonTitle = "skeletonTitle";
      state.skeletonPie = "skeletonPie";
      state.skeletonFooter = "skeletonFooter";
      state.skeletonColumn = "skeletonColumn";
    }
  },
  skeleton: (state, payload) => {
    state.skeleton = payload;
  },
  skeletonTitle: (state, payload) => {
    state.skeletonTitle = payload;
  },
  skeletonPie: (state, payload) => {
    state.skeletonPie = payload;
  },
  skeletonFooter: (state, payload) => {
    state.skeletonFooter = payload;
  },
  skeletonColumn: (state, payload) => {
    state.skeletonColumn = payload;
  },
  //Skeleton para trafico
  viewSkeletonsT: (state, payload) => {
    state.viewSkeletonsT = payload;
    if (payload) {
      state.skeletonTitleT = "skeletonTitle";
      state.skeletonColumnT = "skeletonColumn";
    }
  },
  skeletonTitleT: (state, payload) => {
    state.skeletonTitleT = payload;
  },
  skeletonColumnT: (state, payload) => {
    state.skeletonColumnT = payload;
  },
  // Fin
  //Skeleton para performance
  viewSkeletonsP: (state, payload) => {
    state.viewSkeletonsP = payload;
    if (payload) {
      state.skeletonP = "skeleton";
      state.skeletonTitleP = "skeletonTitle";
      state.skeletonColumnP = "skeletonColumn";
      state.skeletonPieP = "skeletonPie";
      state.skeletonFooterP = "skeletonFooter";
    }
  },
  skeletonTitleP: (state, payload) => {
    state.skeletonTitleP = payload;
  },
  skeletonP: (state, payload) => {
    state.skeletonP = payload;
  },
  skeletonColumnP: (state, payload) => {
    state.skeletonColumnP = payload;
  },
  skeletonPieP: (state, payload) => {
    state.skeletonPieP = payload;
  },
  skeletonFooterP: (state, payload) => {
    state.skeletonFooterP = payload;
  },
  // Fin
  //Skeleton para comparative
  viewSkeletonsC: (state, payload) => {
    state.viewSkeletonsC = payload;
    if (payload) {
      state.skeletonC = "skeleton";
      state.skeletonTitleC = "skeletonTitle";
      state.skeletonColumnC = "skeletonColumn";
      state.skeletonPieC = "skeletonPie";
      state.skeletonFooterC = "skeletonFooter";
    }
  },
  skeletonTitleC: (state, payload) => {
    state.skeletonTitleC = payload;
  },
  skeletonC: (state, payload) => {
    state.skeletonC = payload;
  },
  skeletonColumnC: (state, payload) => {
    state.skeletonColumnC = payload;
  },
  skeletonPieC: (state, payload) => {
    state.skeletonPieC = payload;
  },
  skeletonFooterC: (state, payload) => {
    state.skeletonFooterC = payload;
  },
  // Fin
  //Skeleton para combustible individual FUEL_PERFORMANCE
  viewSkeletonsFP: (state, payload) => {
    state.viewSkeletonsFP = payload;
    if (payload) {
      state.skeletonColumnFP = "skeletonColumn";
    }
  },
  skeletonColumnFP: (state, payload) => {
    state.skeletonColumnFP = payload;
  },
  viewSkeletonsAR: (state, payload) => {
    state.viewSkeletonsAR = payload;
    if (payload) {
      state.skeletonLineAR = "skeleton";
    }
  },
  skeletonLineAR: (state, payload) => {
    state.skeletonLineAR = payload;
  },
  //Fin
  //Skeleton para combustible individual RETRIEVE_LEVEL
  viewSkeletonsRL: (state, payload) => {
    state.viewSkeletonsRL = payload;
    if (payload) {
      state.skeletonRL = "skeleton";
      state.skeletonColumnRL = "skeletonColumn";
    }
  },
  skeletonRL: (state, payload) => {
    state.skeletonRL = payload;
  },
  skeletonColumnRL: (state, payload) => {
    state.skeletonColumnRL = payload;
  },
  //Fin
  //Barra de progreso de comparative
  progressComparative: (state, payload) => {
    state.progressC = payload;
  },
  backgroundSkeleton: (state) => {
    if (vuetify.framework.theme.isDark) {
      state.backgroundSkeleton = "background: #828080;";
    } else {
      state.backgroundSkeleton = "background: #e0e0e0;";
    }
  },
  backgroundCard: (state) => {
    if (vuetify.framework.theme.isDark) {
      state.overlayCard = false;
    } else {
      state.overlayCard = true;
    }
  },
  initialSettings: (state, payload) => {
    state.initialSettings = payload;
  },
  Personalization: (state, payload) => {
    vuetify.framework.theme.isDark = payload.Theme.DarkMode;
    state.swicth = payload.Theme.DarkMode;
    localStorage.setItem("darkMode", payload.Theme.DarkMode);

    state.whitesmoke = state.swicth == true ? "" : "#f5f5f5";
    if (payload.Theme.PrimaryColor != "") {
      //check if contains # ?
      var color = payload.Theme.PrimaryColor.replace("#", "");
      state.colorTheme = color == "ND" ? "#8FAE2D" : "#" + color;
      localStorage.setItem("colorSelected", state.colorTheme);
      vuetify.framework.theme.themes.light.primary = state.colorTheme;
      vuetify.framework.theme.themes.dark.primary = state.colorTheme;
    }
    if (payload.SU.Distance != "ND") {
      var distanc = payload.SU.Distance == "KM" ? "Km" : "mi";
      localStorage.setItem("Distance", distanc);
      state.SelectedDistance = distanc;
    }
    if (payload.SU.Volume != "ND") {
      var vol =
        payload.SU.Volume.trim() == "L"
          ? payload.SU.Volume.trim()
          : payload.SU.Volume.trim().toLowerCase();
      localStorage.setItem("Volume", vol);
      state.SelectedVolume = vol;
    }
    if (payload.SU.Temperature != "ND") {
      localStorage.setItem("Temperature", "°" + payload.SU.Temperature);
      state.SelectedTemperature = "°" + payload.SU.Temperature;
    }
    //check level account
    if (payload.Account.DealerId != "ND") {
      state.dealerSelected = payload.Account.DealerId;
      localStorage.setItem("Dealer_Id", payload.Account.DealerId);
    } else {
      if (state.SelectedAccess.Level == "Dealer") {
        state.dealerSelected = state.SelectedAccess.DealerId;
        localStorage.setItem("Dealer_Id", state.SelectedAccess.DealerId);
      }
    }

    if (payload.Account.ClientId != "ND") {
      state.clientSelected = payload.Account.ClientId;
      localStorage.setItem("Client_Id", payload.Account.ClientId);
    } else {
      if (state.SelectedAccess.Level == "Client") {
        state.dealerSelected = state.SelectedAccess.DealerId;
        localStorage.setItem("Dealer_Id", state.SelectedAccess.DealerId);
        state.clientSelected = state.SelectedAccess.ClientId;
        localStorage.setItem("Client_Id", state.SelectedAccess.ClientId);
      }
    }

    if (
      payload.Account.AccountId != "ND" ||
      payload.Account.AccountId != "NA"
    ) {
      state.accountSelected = payload.Account.AccountId;
      localStorage.setItem("Account_Id", payload.Account.AccountId);
    } else {
      if (state.SelectedAccess.Level == "Account") {
        state.dealerSelected = state.SelectedAccess.DealerId;
        localStorage.setItem("Dealer_Id", state.SelectedAccess.DealerId);
        state.clientSelected = state.SelectedAccess.ClientId;
        localStorage.setItem("Client_Id", state.SelectedAccess.ClientId);
        state.accountSelected = state.SelectedAccess.AccountId;
        localStorage.setItem("Account_Id", state.SelectedAccess.AccountId);
      }
    }

    if (payload.Account.GroupId != "ND" || payload.Account.GroupId != "NA") {
      state.groupSelected = payload.Account.GroupId;
      localStorage.setItem("Group_Id", payload.Account.GroupId);
    }
  },
  PersonalizationChangeLanguage: (state, payload) => {
    var lang = payload != "" ? payload.split("-") : ["es"];
    i18n.locale = lang[0];
    localStorage.setItem("language", i18n.locale);
  },
  exceptionsCharts: (state, payload) => {
    if (!state.infoChartExceptions) {
      state.infoChartExceptions = true;
    }
  },
  setSettingsTitle: (state, value) => {
    state.settingsTitle = value;
  },
  setColor: (state, value) => {
    state.whitesmoke = value;
  },
  calendarTime: (state, value) => {
    state.calendarTime = value;
  },
  loginOffline: (state, value) => {
    state.loginOffline = value;
  },
  vehiclesAggregates: (state, value) => {
    state.vehicles.forEach((vehicle) => {
      if (vehicle.MovilId == value.MovilId) {
        vehicle.active = true;
      }
    });
    state.checkFastList = true;
    state.vehiclesAggregates.push(value);
    localStorage.setItem("v_list", JSON.stringify(state.vehicles));
  },
  deletVehicles: (state, value) => {
    state.vehicles.forEach((vehicle) => {
      if (vehicle.MovilId == value.MovilId) {
        vehicle.active = false;
      }
    });

    localStorage.setItem("v_list", JSON.stringify(state.vehicles));

    state.vehiclesAggregates = state.vehiclesAggregates.filter(function(obj) {
      return obj.MovilId !== value.MovilId;
    });
  },
  checkFastList: (state, value) => {
    state.checkFastList = value;
  },
  changeTable: (state, value) => {
    state.vistaRapida = value;
  },
  deletAllVehicles: (state, value) => {
    state.vehiclesAggregates = [];
    state.vehicles.forEach((vehicle) => {
      vehicle.active = false;
    });
    localStorage.setItem("v_list", JSON.stringify(state.vehicles));
    localStorage.setItem("quickList", JSON.stringify(state.vehiclesAggregates));
    localStorage.setItem("checkQuickList", false);
  },
  Allreports: (state, value) => {
    state.Allreports = value;
  },
  loading4: (state, value) => {
    var reportsend = value[0];
    var loading4 = value[1];
    state.Reports.forEach((report) => {
      if (reportsend.num == report.num) {
        report.loading4 = loading4;
        return;
      }
    });
  },
  disableButton: (state, value) => {
    state.disableButton = value;
  },
  filterVin: (state, value) => {
    state.filterVin = value;
  },
  progressOp: (state, value) => {
    state.progressOp = value;
  },
  listOperators: (state, payload) => {
    state.listOperators = [];
    state.listOperatorsWithoutP = [];
    if (payload.length > 0) {
      payload.forEach((operator, index) => {
        var licenseExpiration = moment(operator.LicenseExpiration).format(
          "DD/MM/YYYY"
        );

        var stillUtc = moment.utc(operator.JoinDate).toDate();
        var localDate = moment(stillUtc)
          .local()
          .format("DD/MM/YYYY HH:mm");

        if (i18n.locale == "en") {
          licenseExpiration = moment(operator.LicenseExpiration).format(
            "MM/DD/YYYY"
          );
          localDate = moment(stillUtc)
            .local()
            .format("MM/DD/YYYY HH:mm");
        }

        var LicenseType =
          operator.LicenseType == 0
            ? i18n.t("other")
            : operator.LicenseType == 1
            ? "A"
            : operator.LicenseType == 2
            ? "B"
            : operator.LicenseType == 3
            ? "C"
            : operator.LicenseType == 4
            ? "D"
            : operator.LicenseType == 5
            ? "E"
            : "F";

        var item = {
          id: operator.Id,
          Operator: operator.Name,
          License: operator.LicenseId,
          Type: LicenseType,
          LicenseExpiration: licenseExpiration,
          Address: operator.Address,
          RegistrationDate: localDate,
          Bonding: operator.MobileIMEI != "" ? operator.MobileIMEI : "N/A",
          Contacts: operator.Contacts,
        };
        if (router.app.$route.path == "/mobilePhone") {
          if (item.Bonding == "N/A") {
            var arr = item;
            arr.License = item.License + " " + i18n.t("type") + " " + item.Type;
            state.listOperatorsWithoutP.push(arr);
          }
        }
        if (router.app.$route.path == "/traffic/addTravel") {
          state.listOperators.push(item);
        } else {
          if (state.filterVin == i18n.t("all")) {
            state.listOperators.push(item);
          } else if (state.filterVin == i18n.t("entail")) {
            if (item.Bonding != "N/A") {
              state.listOperators.push(item);
            }
          } else {
            if (item.Bonding == "N/A") {
              state.listOperators.push(item);
            }
          }
        }
      });
      localStorage.setItem(
        "ListOpertator",
        JSON.stringify(state.listOperators)
      );
    }
  },
  progressMovil: (state, value) => {
    state.progressMovil = value;
  },
  listMovil: (state, payload) => {
    state.listMovil = [];
    if (payload.length > 0) {
      payload.forEach((mobile, index) => {
        var OS =
          mobile.SO == 1
            ? "ANDROID"
            : mobile.SO == 2
            ? "BLACKBERRY"
            : mobile.SO == 3
            ? "HUAWEI"
            : mobile.SO == 4
            ? "IOS"
            : mobile.SO == 5
            ? "NOKIA"
            : mobile.SO == 6
            ? "PLASMA"
            : mobile.SO == 7
            ? "POSTMARKET"
            : mobile.SO == 8
            ? "PURE"
            : mobile.SO == 9
            ? "SAILFISH"
            : mobile.SO == 10
            ? "TIZEN"
            : mobile.SO == 11
            ? "UBUNTU"
            : mobile.SO == 12
            ? "SAMSUNG"
            : mobile.SO == 13
            ? "WINDOWS"
            : i18n.t("other");

        var item = {
          mobile: mobile.PhoneNumber,
          IMEI: mobile.IMEI,
          model: mobile.Model,
          marca: mobile.BrandName,
          OS: OS,
          CallingCode: mobile.CallingCode,
          SerialNumber: mobile.SerialNumber,
          LastActivityDate: mobile.LastActivityDate,
          JoinDate: mobile.JoinDate,
          Bonding: mobile.Bonding,
        };
        if (router.app.$route.path == "/operator") {
          if (item.Bonding == "N/A") {
            state.listMovil.push(item);
          }
        } else {
          if (state.filterVin == i18n.t("all")) {
            state.listMovil.push(item);
          } else if (state.filterVin == i18n.t("entail")) {
            if (item.Bonding != "N/A") {
              state.listMovil.push(item);
            }
          } else {
            if (item.Bonding == "N/A") {
              state.listMovil.push(item);
            }
          }
        }
      });
      localStorage.setItem("ListMovil", JSON.stringify(state.listMovil));
    }
  },
  filterTraffic: (state, payload) => {
    state.filterTraffic = payload;
  },

  //Función para formatear lista de vehículos configurados para mostrarlos en tabla
  listVehiclesAT: (state, payload) => {
    //console.log(payload);
    state.vehiclesAT = [];
    let status = "";
    //state.optionsGroup = [{ text: i18n.t("allGroups"), value: null }];
    payload.forEach(vehicle => {
      let lastConfig = formatDate.dateCustom(vehicle.LastConfiguration);
      let lastConfigTimestamp = moment(vehicle.LastConfiguration, "YYYY-MM-DDTHH:mm").valueOf();

      let lastTransmission = formatDate.dateCustom(vehicle.LastTransmission);
      let lastTransmissionTimestamp = moment(vehicle.LastTransmission, "YYYY-MM-DDTHH:mm").valueOf();

      if (vehicle.Status == 0) {
        status = i18n.t("updated");
      } else if (vehicle.Status == 1) {
        status = i18n.t("configProcess");
      } else {
        status = i18n.t("failedToUpdate");
      }

      if (vehicle.Template == "Default") {
        if (i18n.locale == "es") {
          vehicle.Template = i18n.t("default");
        }
      }

      let idleTime = splitTimeInMutations.splitSeconds(vehicle.IdleTime);

      let item = {
        //Group: vehicle.Group,
        MovilId: vehicle.DeviceId,
        Nick: vehicle.Nick,
        Template: vehicle.Template,
        LastConfiguration: lastConfigTimestamp,
        LastConfigurationAsText: lastConfig,
        Status: status,
        LastTransmission: lastTransmissionTimestamp,
        LastTransmissionAsText: lastTransmission,
        IdleTime: vehicle.IdleTime,
        IdleTimeAsText: idleTime,
        Location: {
          Lat: vehicle.Location.Latitude,
          Lon: vehicle.Location.Longitude,
        },
        isSelectable: status == i18n.t("configProcess") ? false : true,
      };

      state.vehiclesAT.push(item);
      // var itemGroup = {};
      // itemGroup = {
      //   text: vehicle.Group,
      //   value: vehicle.Group,
      // };
      // state.optionsGroup.push(itemGroup);
    });
  },

  //Función para llentar tabla de plantillas
  listTemplatesAT: (state, payload) => {
    //console.log(payload);
    state.templatesAT = [];
    payload.forEach(template => {
      let creationDate = formatDate.dateCustom(template.CreationDate);
      let creationDateTimestamp = moment(template.CreationDate, "YYYY-MM-DDTHH:mm").valueOf();

      let editionDate = formatDate.dateCustom(template.EditionDate);
      let editionDateTimestamp = moment(template.EditionDate, "YYYY-MM-DDTHH:mm").valueOf();
      
      let item = {
        Id: template.Id,
        Name: template.TemplateName,
        Email: template.Email,
        CreationDate: creationDateTimestamp,
        CreationDateAsText: creationDate,
        EditionDate: editionDateTimestamp,
        EditionDateAsText: editionDate,
        UserLevel: template.UserLevel,
      };
      state.templatesAT.push(item);
    });
  },
  
  //Comparacion entre contenido de veh y plantilla, se determina si son distintos
  compareContent: (state, payload) => {
    var template = state.contentVehAT;
    state.comparedItems = [];
    //se hace foreach con el array del contenido del vehiculo
    payload.forEach((vehicle, index) => {
      //se le asigna el index del foreach al array del contenido de plantilla
      const contentTemplate = template[index];
      //si el objeto corresponde se lleva a cabo su proceso
      if (vehicle.PeriodicReports) {
        //se usa un for in para obtener datos de los objetos vehicle.PeriodicReports y contentTemplate.PeriodicReports
        for (var element in (vehicle.PeriodicReports,
        contentTemplate.PeriodicReports)) {
          var theName, isDistinct, isActive;
          //para determinar si es distinto se usa una var que checa si es un obj ya que es dif el proceso
          isDistinct =
            typeof vehicle.PeriodicReports[element] === "object" &&
            vehicle.PeriodicReports[element] !== null
              ? JSON.stringify(vehicle.PeriodicReports[element]) ===
                JSON.stringify(contentTemplate.PeriodicReports[element])
                ? false
                : true
              : vehicle.PeriodicReports[element] ==
                contentTemplate.PeriodicReports[element]
              ? false
              : true;
          vehicle.PeriodicReports[element] ==
          contentTemplate.PeriodicReports[element]
            ? false
            : true;
          //donde element es la key de cada uno y asi poder traducirlo junto con su unidad correspondiente
          switch (element) {
            case "OdometerReport":
              theName = i18n.t("odometerReport");
              vehicle.PeriodicReports[element] =
                vehicle.PeriodicReports[element] == true
                  ? i18n.t("activated")
                  : i18n.t("disabled");
              contentTemplate.PeriodicReports[element] =
                contentTemplate.PeriodicReports[element] == true
                  ? i18n.t("activated")
                  : i18n.t("disabled");
              break;
            case "FuelReport":
              theName = i18n.t("fuelReport");
              vehicle.PeriodicReports[element] =
                vehicle.PeriodicReports[element] == true
                  ? i18n.t("activated")
                  : i18n.t("disabled");
              contentTemplate.PeriodicReports[element] =
                contentTemplate.PeriodicReports[element] == true
                  ? i18n.t("activated")
                  : i18n.t("disabled");
              break;
            case "TimeReport":
              theName = i18n.t("timeReport") + " (s)";
              //se usa una var para saber si esta activado y para unir esa var con su valor y mostrarlo como string en la tabla ya que es un obj y se necesita string
              isActive =
                vehicle.PeriodicReports[element]["Active"] == true
                  ? i18n.t("activated")
                  : i18n.t("disabled");
              vehicle.PeriodicReports[element] =
                vehicle.PeriodicReports[element]["Value"] +
                " (" +
                isActive +
                ")";
              isActive =
                contentTemplate.PeriodicReports[element]["Active"] == true
                  ? i18n.t("activated")
                  : i18n.t("disabled");
              contentTemplate.PeriodicReports[element] =
                contentTemplate.PeriodicReports[element]["Value"] +
                " (" +
                isActive +
                ")";
              break;
            case "StoppedVehicleReport":
              theName = i18n.t("stoppedVehicleReport") + " (s)";
              isActive =
                vehicle.PeriodicReports[element]["Active"] == true
                  ? i18n.t("activated")
                  : i18n.t("disabled");
              vehicle.PeriodicReports[element] =
                vehicle.PeriodicReports[element]["Value"] +
                " (" +
                isActive +
                ")";
              isActive =
                contentTemplate.PeriodicReports[element]["Active"] == true
                  ? i18n.t("activated")
                  : i18n.t("disabled");
              contentTemplate.PeriodicReports[element] =
                contentTemplate.PeriodicReports[element]["Value"] +
                " (" +
                isActive +
                ")";
              break;
            case "VehicleRunningReport":
              theName = i18n.t("vehicleRunningReport") + " (s)";
              isActive =
                vehicle.PeriodicReports[element]["Active"] == true
                  ? i18n.t("activated")
                  : i18n.t("disabled");
              vehicle.PeriodicReports[element] =
                vehicle.PeriodicReports[element]["Value"] +
                " (" +
                isActive +
                ")";
              isActive =
                contentTemplate.PeriodicReports[element]["Active"] == true
                  ? i18n.t("activated")
                  : i18n.t("disabled");
              contentTemplate.PeriodicReports[element] =
                contentTemplate.PeriodicReports[element]["Value"] +
                " (" +
                isActive +
                ")";
              break;
          }
          //Se forma el nuevo objeto para mostrar los datos en la tabla
          var item = {
            name: theName,
            category: i18n.t("periodicReports"),
            contentTemp: contentTemplate.PeriodicReports[element],
            contentVeh: vehicle.PeriodicReports[element],
            distinct: isDistinct,
            mix: contentTemplate.PeriodicReports[element],
          };
          state.comparedItems.push(item);
        }
      }
      if (vehicle.Logistics) {
        for (var element in (vehicle.Logistics, contentTemplate.Logistics)) {
          var theName, isDistinct;
          isDistinct =
            vehicle.Logistics[element] == contentTemplate.Logistics[element]
              ? false
              : true;

          switch (element) {
            case "HighIdlePercentage":
              theName = i18n.t("highIdlePercentage") + " (%)";
              break;
            case "AlertExcessiveIdlingTime":
              theName = i18n.t("alertExcessiveIdlingTime") + " (s)";
              break;
            case "InsufficientRestTime":
              theName = i18n.t("ev456") + " (s)";
              break;
            case "RestDetected":
              theName = i18n.t("ev464") + " (s)";
              break;
          }

          var item = {
            name: theName,
            category: i18n.t("logistics"),
            contentTemp: contentTemplate.Logistics[element],
            contentVeh: vehicle.Logistics[element],
            distinct: isDistinct,
            mix: contentTemplate.Logistics[element],
          };
          state.comparedItems.push(item);
        }
      }
      if (vehicle.Operation) {
        for (var element in (vehicle.Operation, contentTemplate.Operation)) {
          var theName, isDistinct, isActive;
          isDistinct =
            typeof vehicle.Operation[element] === "object" &&
            vehicle.Operation[element] !== null
              ? JSON.stringify(vehicle.Operation[element]) ===
                JSON.stringify(contentTemplate.Operation[element])
                ? false
                : true
              : vehicle.Operation[element] == contentTemplate.Operation[element]
              ? false
              : true;
          vehicle.Operation[element] == contentTemplate.Operation[element]
            ? false
            : true;

          switch (element) {
            case "ExcessOfMotorLoad":
              theName = i18n.t("ev450") + " (%)";
              isActive =
                vehicle.Operation[element]["Active"] == true
                  ? i18n.t("activated")
                  : i18n.t("disabled");
              vehicle.Operation[element] =
                vehicle.Operation[element]["Value"] + " (" + isActive + ")";
              isActive =
                contentTemplate.Operation[element]["Active"] == true
                  ? i18n.t("activated")
                  : i18n.t("disabled");
              contentTemplate.Operation[element] =
                contentTemplate.Operation[element]["Value"] +
                " (" +
                isActive +
                ")";
              break;
            case "LowCruiseControlPercentage":
              theName = i18n.t("ev454") + " (%)";
              break;
            case "LowFuelEconomy":
              theName =
                i18n.t("ev459") +
                " (" +
                state.SelectedDistance +
                "/" +
                state.SelectedVolume +
                ")";
              if (
                state.SelectedVolume == "gal" &&
                state.SelectedDistance == "mi"
              ) {
                vehicle.Operation[element] =
                  vehicle.Operation[element] == 0
                    ? 0
                    : parseFloat(vehicle.Operation[element] * 2.35).toFixed(2);
                contentTemplate.Operation[element] =
                  contentTemplate.Operation[element] == 0
                    ? 0
                    : parseFloat(
                        contentTemplate.Operation[element] * 2.35
                      ).toFixed(2);
              }

              if (
                state.SelectedVolume == "gal" &&
                state.SelectedDistance == "Km"
              ) {
                vehicle.Operation[element] =
                  vehicle.Operation[element] == 0
                    ? 0
                    : parseFloat(vehicle.Operation[element] * 2.35).toFixed(2);
                contentTemplate.Operation[element] =
                  contentTemplate.Operation[element] == 0
                    ? 0
                    : parseFloat(
                        contentTemplate.Operation[element] * 3.78
                      ).toFixed(2);
              }

              if (
                state.SelectedVolume == "L" &&
                state.SelectedDistance == "mi"
              ) {
                vehicle.Operation[element] =
                  vehicle.Operation[element] == 0
                    ? 0
                    : parseFloat(vehicle.Operation[element] * 2.35).toFixed(2);
                contentTemplate.Operation[element] =
                  contentTemplate.Operation[element] == 0
                    ? 0
                    : parseFloat(
                        contentTemplate.Operation[element] * 0.62
                      ).toFixed(2);
              }
              break;
            case "PTOStopped":
              theName = i18n.t("ptoStopped") + " (%)";
              isActive =
                vehicle.Operation[element]["Active"] == true
                  ? i18n.t("activated")
                  : i18n.t("disabled");
              vehicle.Operation[element] =
                vehicle.Operation[element]["Value"] + " (" + isActive + ")";
              isActive =
                contentTemplate.Operation[element]["Active"] == true
                  ? i18n.t("activated")
                  : i18n.t("disabled");
              contentTemplate.Operation[element] =
                contentTemplate.Operation[element]["Value"] +
                " (" +
                isActive +
                ")";
              break;
            case "AverageMotorHighLoad":
              theName = i18n.t("ev466") + " (%)";
              break;
            case "StartOfPTO":
              theName = i18n.t("ev479") + " (s)";
              break;
            case "EndOfPTO":
              theName = i18n.t("ev480") + " (s)";
              break;
          }

          var item = {
            name: theName,
            category: i18n.t("vehicleOperation"),
            contentTemp: contentTemplate.Operation[element],
            contentVeh: vehicle.Operation[element],
            distinct: isDistinct,
            mix: contentTemplate.Operation[element],
          };
          state.comparedItems.push(item);
        }
      }
      if (vehicle.Driving) {
        for (var element in (vehicle.Driving, contentTemplate.Driving)) {
          var theName, isDistinct, isActive;
          isDistinct =
            typeof vehicle.Driving[element] === "object" &&
            vehicle.Driving[element] !== null
              ? JSON.stringify(vehicle.Driving[element]) ===
                JSON.stringify(contentTemplate.Driving[element])
                ? false
                : true
              : vehicle.Driving[element] == contentTemplate.Driving[element]
              ? false
              : true;

          switch (element) {
            case "RPMsInExcess":
              theName = i18n.t("ev445") + " (Rpms)";
              isActive =
                vehicle.Driving[element]["Active"] == true
                  ? i18n.t("activated")
                  : i18n.t("disabled");
              vehicle.Driving[element] =
                vehicle.Driving[element]["Value"] + " (" + isActive + ")";
              isActive =
                contentTemplate.Driving[element]["Active"] == true
                  ? i18n.t("activated")
                  : i18n.t("disabled");
              contentTemplate.Driving[element] =
                contentTemplate.Driving[element]["Value"] +
                " (" +
                isActive +
                ")";
              break;
            case "QuickPowerOff":
              theName = i18n.t("quickPowerOff") + " (s)";
              break;
            case "ExcessOfClutchTimeWhileMoving":
              theName = i18n.t("ev447") + " (s)";
              break;
            case "ExcessOfClutchTimeIdle":
              theName = i18n.t("ev448") + " (s)";
              break;
            case "ExcessOfBrakingTime":
              theName = i18n.t("ev449") + " (s)";
              break;
            case "SuddenAcceleration":
              theName =
                i18n.t("ev452") + " (" + state.SelectedDistance + "/h-s)";
              if (state.SelectedDistance != "Km") {
                vehicle.Driving[element] =
                  vehicle.Driving[element] == 0
                    ? 0
                    : parseFloat(vehicle.Driving[element] * 0.62137).toFixed(3);
                contentTemplate.Driving[element] =
                  contentTemplate.Driving[element] == 0
                    ? 0
                    : parseFloat(
                        contentTemplate.Driving[element] * 0.62137
                      ).toFixed(3);
              }
              break;
            case "SuddenBraking":
              theName =
                i18n.t("ev453") + " (" + state.SelectedDistance + "/h-s)";
              if (state.SelectedDistance != "Km") {
                vehicle.Driving[element] =
                  vehicle.Driving[element] == 0
                    ? 0
                    : parseFloat(vehicle.Driving[element] * 0.62137).toFixed(3);
                contentTemplate.Driving[element] =
                  contentTemplate.Driving[element] == 0
                    ? 0
                    : parseFloat(
                        contentTemplate.Driving[element] * 0.62137
                      ).toFixed(3);
              }
              break;
            case "MediumSpeeding":
              theName = i18n.t("ev457") + " (" + state.SelectedDistance + "/h)";
              if (state.SelectedDistance != "Km") {
                vehicle.Driving[element] =
                  vehicle.Driving[element] == 0
                    ? 0
                    : parseFloat(vehicle.Driving[element] / 1.60934).toFixed(3);
                contentTemplate.Driving[element] =
                  contentTemplate.Driving[element] == 0
                    ? 0
                    : parseFloat(
                        contentTemplate.Driving[element] * 0.62137
                      ).toFixed(3);
              }
              break;
            case "SevereSpeeding":
              theName = i18n.t("ev458") + " (" + state.SelectedDistance + "/h)";
              if (state.SelectedDistance != "Km") {
                vehicle.Driving[element] =
                  vehicle.Driving[element] == 0
                    ? 0
                    : parseFloat(vehicle.Driving[element] / 1.60934).toFixed(3);
                contentTemplate.Driving[element] =
                  contentTemplate.Driving[element] == 0
                    ? 0
                    : parseFloat(
                        contentTemplate.Driving[element] * 0.62137
                      ).toFixed(3);
              }
              break;
            case "CurveAtHighSpeed":
              theName = i18n.t("ev481") + " (" + state.SelectedDistance + "/h)";
              if (state.SelectedDistance != "Km") {
                vehicle.Driving[element] =
                  vehicle.Driving[element] == 0
                    ? 0
                    : parseFloat(vehicle.Driving[element] / 1.60934).toFixed(3);
                contentTemplate.Driving[element] =
                  contentTemplate.Driving[element] == 0
                    ? 0
                    : parseFloat(
                        contentTemplate.Driving[element] * 0.62137
                      ).toFixed(3);
              }
              break;
          }

          var item = {
            name: theName,
            category: i18n.t("driving"),
            contentTemp: contentTemplate.Driving[element],
            contentVeh: vehicle.Driving[element],
            distinct: isDistinct,
            mix: contentTemplate.Driving[element],
          };
          state.comparedItems.push(item);
        }
      }
    });
    state.loadingComparativeTable = false;
  },
  contentForConfigP: (state, payload) => { 
    state.contentConfig = [];
    var theStatus;
    payload.forEach((vehicle, index) => {
      if (vehicle.Status == 0) {
        theStatus = i18n.t("configured");
      } else if (vehicle.Status == 1) {
        theStatus = i18n.t("notConfigured");
      } else {
        theStatus = i18n.t("configuring");
      }

      var item = {};
      item = {
        MovilId: vehicle.MovilId,
        Nick: vehicle.Nick,
        Status: theStatus,
        Details: vehicle.Details,
      };
      state.contentConfig.push(item);
    });

  },

  theTrackingList: (state, payload) => {
    //plasmar lista de vehiculos en mapa y tabla
    state.trackingList = [];
    var daysToMilli = payload.days;
    var DeviceIdAndNick, dateS, dateG, idleTime;
    var mili = moment().valueOf();
    //console.log("Current Milliseconds Time:", mili);
    payload.vehicles.forEach((list, index) => {
      if (list.Location.Lat != "0.0" && list.Location.Lon != "0.0") {
        idleTime = mili - list.TimeStamp;
        if (idleTime <= daysToMilli || daysToMilli == i18n.t("all")) {
          var t = idleTime;
          var d = Math.floor(t / (1000 * 60 * 60 * 24));
          var h = Math.floor((t % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          var m = Math.floor((t % (1000 * 60 * 60)) / (1000 * 60));
          var s = Math.floor((t % (1000 * 60)) / 1000);
          if (d < 10) {
            d = "0" + d;
          }
          if (h < 10) {
            h = "0" + h;
          }
          if (m < 10) {
            m = "0" + m;
          }
          // if (s < 10) {
          //   s = "0" + s;
          // }
          idleTime = d + "D, " + h + ":" + m;

          var dateSer = new Date(list.TimeStamp);
          var daySer = dateSer.getDate();
          var monthSer = dateSer.getMonth() + 1;
          var yearSer = dateSer.getFullYear();
          var hoursSer = dateSer.getHours();
          var minutesSer = dateSer.getMinutes();
          if (daySer < 10) {
            daySer = "0" + daySer;
          }
          if (monthSer < 10) {
            monthSer = "0" + monthSer;
          }
          if (hoursSer < 10) {
            hoursSer = "0" + hoursSer;
          }
          if (minutesSer < 10) {
            minutesSer = "0" + minutesSer;
          }

          let dateServerMonthName = moment(monthSer, 'MM').format('MMM');

          if (i18n.locale == "en") {
            dateS =
            dateServerMonthName +
              "/" +
              daySer +
              "/" +
              yearSer +
              " " +
              hoursSer +
              ":" +
              minutesSer;

          } else {
            dateServerMonthName = dateServerMonthName.replace(".", "");
            dateS =
              daySer +
              "/" +
              dateServerMonthName +
              "/" +
              yearSer +
              " " +
              hoursSer +
              ":" +
              minutesSer;
          }

          var date = new Date(list.TimeStampGps);
          var day = date.getDate();
          var month = date.getMonth() + 1;
          var year = date.getFullYear();
          var hours = date.getHours();
          var minutes = date.getMinutes();
          if (day < 10) {
            day = "0" + day;
          }
          if (month < 10) {
            month = "0" + month;
          }
          if (hours < 10) {
            hours = "0" + hours;
          }
          if (minutes < 10) {
            minutes = "0" + minutes;
          }

          let dateGPSMonthName = moment(month, 'MM').format('MMM');

          if (i18n.locale == "en") {
            dateG =
            dateGPSMonthName + "/" + day + "/" + year + " " + hours + ":" + minutes;

          } else {
            dateGPSMonthName = dateGPSMonthName.replace(".", "");
            dateG =
              day + "/" + dateGPSMonthName + "/" + year + " " + hours + ":" + minutes;
          }

          DeviceIdAndNick = list.Nick + " (" + list.MovilId + ")";
          var item = {};
          item = {
            MovilId: list.MovilId,
            Nick: list.Nick,
            DeviceIdAndNick: DeviceIdAndNick,
            TimeStampGps: list.TimeStampGps,
            TimeStamp: list.TimeStamp,
            Location: {
              Lat: list.Location.Lat,
              Lon: list.Location.Lon,
            },
            Address: list.Address,
            Speed: list.Speed,
            Course: list.Course,
            Orientation: list.Orientation,
            Odometer: list.Odometer,
            Status: list.Status,
            Batery: list.Batery,
            IsGpsValid: list.IsGpsValid,
            Event: list.Event,
            EventData: list.EventData,
            Properties: {
              Plates: list.Properties.Plates,
              Year: list.Properties.Year,
              Color: list.Properties.Color,
              Brand: list.Properties.Brand,
              Category: list.Properties.Category,
              Comments: list.Properties.Comments,
              OperationState: list.Properties.OperationState,
            },
            OnLine: list.OnLine,
            IdleTime: idleTime, //tiempo sin transmitir:  fecha de hoy - TimeStamp, en formato dd,hh:mm
            DateGPS: dateG,
            DateServer: dateS, //ultima transmision: TimeStamp se pasa a DD/MM/YYYY
          };
          state.trackingList.push(item);
        }
      }
    });
  },
  statusViewVisible: (state, payload) => {
    state.statusViewVisible = payload;
  },
  reportViewVisible: (state, payload) => {
    state.reportViewVisible = payload;
  },
  forActivity: (state, payloadd) => {
    state.dataActivitySave = JSON.stringify(payloadd);
    state.noActivity = false;
    const reponse = payloadd;
    const payload = [...reponse];
    state.activityList = [];
    var setOfRoutes = [];
    state.SelectedVolume =
      localStorage.getItem("Volume") == undefined
        ? "L"
        : localStorage.getItem("Volume");

    state.SelectedDistance =
      localStorage.getItem("Distance") == undefined
        ? "Km"
        : localStorage.getItem("Distance");
    var vehState, latlng, geoAddress, shortState;

    for (var i = payload.length - 1; i >= 0; i--) {
      if (payload[i].Duration > 0) {
        var t = payload[i].Duration * 1000; //Duration se pasa de seg a milisegundos
        var d = Math.floor(t / (1000 * 60 * 60 * 24));
        var h = Math.floor((t % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var m = Math.floor((t % (1000 * 60 * 60)) / (1000 * 60));
        var s = Math.floor((t % (1000 * 60)) / 1000);
        if (d < 10) {
          d = "0" + d;
        }
        if (h < 10) {
          h = "0" + h;
        }
        if (m < 10) {
          m = "0" + m;
        }
        // if (s < 10) {
        //   s = "0" + s;
        // }
        payload[i].Duration = d + "D, " + h + ":" + m;
      } else {
        payload[i].Duration = i18n.t("durationNotAvailable");
      }

      if (payload[i].Distance > 0) {
        if (state.SelectedDistance == "Km") {
          //de metros a km
          var distance = parseFloat(payload[i].Distance / 1000)
            .toFixed(3)
            .replace(/\.000$/, "");
          payload[i].Distance = formatNumber.new(distance, "Km");
        } else {
          //de metros a mi
          var distance = parseFloat(payload[i].Distance / 1609)
            .toFixed(3)
            .replace(/\.000$/, "");
          payload[i].Distance = formatNumber.new(distance, "mi");
          parseFloat(payload[i].Distance);
        }
      } else if (payload[i].Distance == 0) {
        if (state.SelectedDistance == "Km") {
          payload[i].Distance = "0 Km";
        } else {
          payload[i].Distance = "0 mi";
        }
      } else {
        payload[i].Distance = i18n.t("distanceNotAvailable");
      }

      if (payload[i].FuelConsumption > 0) {
        if (state.SelectedDistance == "L") {
          payload[i].FuelConsumption = formatNumber.new(
            payload[i].FuelConsumption,
            "L"
          );
        } else {
          payload[i].FuelConsumption =
            parseFloat(payload[i].FuelConsumption / 3.78541)
              .toFixed(1)
              .replace(/\.0$/, "") + " gal";
        }
      } else if (payload[i].FuelConsumption == 0) {
        if (state.SelectedVolume == "L") {
          payload[i].FuelConsumption = "0 L";
        } else {
          payload[i].FuelConsumption = "0 gal";
        }
      } else {
        payload[i].FuelConsumption = i18n.t("fuelNotAvailable");
      }

      var date = new Date(payload[i].Timestap);
      var day = date.getDate();
      var month = date.getMonth() + 1;
      var year = date.getFullYear();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      if (day < 10) {
        day = "0" + day;
      }
      if (month < 10) {
        month = "0" + month;
      }
      if (hours < 10) {
        hours = "0" + hours;
      }
      if (minutes < 10) {
        minutes = "0" + minutes;
      }

      if (i18n.locale == "en") {
        payload[i].FormattedDate =
          month + "/" + day + "/" + year + " " + hours + ":" + minutes;
      } else {
        payload[i].FormattedDate =
          day + "/" + month + "/" + year + " " + hours + ":" + minutes;
      }

      if (i < payload.length - 1) {
        var chainedDate =
          payload[i].FormattedDate +
          " " +
          i18n.t("to") +
          " " +
          payload[i + 1].FormattedDate;
      }

      if (payload[i].State == 1) {
        vehState = i18n.t("stopped");
        shortState = "Stop";
      } else if (payload[i].State == 2) {
        vehState = i18n.t("onGoing");
        shortState = "Move";
      } else {
        vehState = i18n.t("other");
        shortState = i18n.t("other");
      }

      let validateReference = validate.isValidReferenceValue(payload[i].Address);
      if (validateReference == false) payload[i].Address = i18n.t("showReference");

      var item = {};
      item = {
        FormattedDate:
          i == payload.length - 1
            ? i18n.t("since") + ": " + payload[i].FormattedDate
            : chainedDate,
        Timestap: payload[i].Timestap,
        State: payload[i].State,
        VehicleState: vehState,
        ShortState: shortState,
        Duration: payload[i].Duration,
        Distance: payload[i].Distance,
        FuelConsumption: payload[i].FuelConsumption,
        Location: {
          Lat: payload[i].Location.Lat,
          Lon: payload[i].Location.Lon,
        },
        Address: payload[i].Address,
      };
      var theRoutes = {};
      theRoutes = {
        lat: payload[i].Location.Lat,
        lng: payload[i].Location.Lon,
        date: payload[i].FormattedDate,
        state: payload[i].State,
        VehicleState: vehState,
        ShortState: shortState,
      };
      state.activityList.push(item);
      setOfRoutes.push(theRoutes);
    }

    var mapT = state.insideTrackingMap;
    //se crea polyline
    var boundsForPolyline = new google.maps.LatLngBounds();
    var route = new google.maps.Polyline({
      path: setOfRoutes,
      geodesic: true,
      strokeColor: "#39FF14",
      strokeOpacity: 0.6,
      strokeWeight: 6,
    });
    route.setMap(mapT);
    state.savePolyline = route;
    var markerP, i;
    var gmarkersP = state.listOfMarkersPolyline;
    var startEndMarkerP = state.startEndMarkerP;
    var startMarker, endMarker;
    var origin = window.location.origin + "/img/images/";
    //para el startmarker es el ultimo porque es un for backwards y el endmarker es el primero
    startMarker = new google.maps.Marker({
      position: new google.maps.LatLng(
        setOfRoutes[setOfRoutes.length - 1].lat,
        setOfRoutes[setOfRoutes.length - 1].lng
      ),
      map: mapT,
      icon: {
        labelOrigin: new google.maps.Point(45, 54),
        url: origin + "start-marker.png",
      },
      label: {
        text:
          setOfRoutes[setOfRoutes.length - 1].ShortState +
          " " +
          setOfRoutes[setOfRoutes.length - 1].date,
        className: "labelPolyline",
        fontSize: "0.7rem",
        fontWeight: "bold",
      },
    });
    startEndMarkerP.push(startMarker);
    endMarker = new google.maps.Marker({
      position: new google.maps.LatLng(setOfRoutes[0].lat, setOfRoutes[0].lng),
      map: mapT,
      icon: {
        labelOrigin: new google.maps.Point(45, 54),
        url: origin + "end-marker.png",
      },
      label: {
        text: setOfRoutes[0].ShortState + " " + setOfRoutes[0].date,
        className: "labelPolyline",
        fontSize: "0.7rem",
        fontWeight: "bold",
      },
    });
    startEndMarkerP.push(endMarker);
    for (i = 1; i < setOfRoutes.length - 1; i++) {
      markerP = new google.maps.Marker({
        position: new google.maps.LatLng(
          setOfRoutes[i].lat,
          setOfRoutes[i].lng
        ),
        map: mapT,
        icon: {
          labelOrigin: new google.maps.Point(35, 31),
          url: origin + "icon-for-polyline.png",
        },
        label: {
          text: setOfRoutes[i].ShortState + " " + setOfRoutes[i].date,
          className: "labelPolyline",
          fontSize: "0.7rem",
          fontWeight: "bold",
        },
      });
      gmarkersP.push(markerP);
    }
    var clustererOptions = {
      maxZoom: 15,
      styles: [
        {
          //a blue circle indicates less than 10 markers
          url: origin + "polylineClusters/m1.png",
          height: 32,
          width: 32,
          anchorText: [10, 16], //[y,x]
        },
        {
          //a yellow circle indicates 10 to 99 markers
          url: origin + "polylineClusters/m2.png",
          height: 34,
          width: 34,
          anchorText: [10, 17],
        },
        {
          //a red circle indicates 100 to 999 markers
          url: origin + "polylineClusters/m3.png",
          height: 36,
          width: 36,
          anchorText: [12, 18],
        },
        {
          //a pink circle indicates 1000 to 9999 markers
          url: origin + "polylineClusters/m4.png",
          height: 38,
          width: 38,
          anchorText: [13, 19],
        },
        {
          //a violet circle indicates 10000 markers or more
          url: origin + "polylineClusters/m5.png",
          height: 40,
          width: 40,
          anchorText: [14, 20],
        },
      ],
    };

    state.clusterforPolyline = new MarkerClusterer(
      mapT,
      gmarkersP,
      clustererOptions
    );
    for (var i = payload.length - 1; i >= 0; i--) {
      boundsForPolyline.extend(
        new google.maps.LatLng(payload[i].Location.Lat, payload[i].Location.Lon)
      );
    }
    mapT.fitBounds(boundsForPolyline);
    mapT.setZoom(mapT.getZoom() - 1.8);
    mapT.panBy(0, 130);
    setTimeout(() => {
      state.indeterminateReport = false;
    }, 1000);
  },
  test: (state, payload) => {
    if (payload.length > 0) {
      state.noActivity = false;
      state.activityList = payload;
    } else {
      state.noActivity = true;
    }

    //console.log(state.activityList);
  },
  //Metodo para la tabla de trafico
  trafficList: (state, payload) => {
    state.trafficList = [];
    var ListLatLng = [];
    if (payload.length > 0) {
      payload.forEach((traffic, index) => {
        var itemlatlng = {
          vehicleId: traffic.DeviceId,
          lat: traffic.Location.Lat,
          lng: traffic.Location.Lon,
          ubicacion: "",
        };
        ListLatLng.push(itemlatlng);

        var Date = moment(traffic.Date)
          .local()
          .format("DD/MM/YYYY HH:mm");

        if (i18n.locale == "en") {
          Date = moment(traffic.Date)
            .local()
            .format("MM/DD/YYYY HH:mm");
        }
        var itemInfo = "";
        var statusOptions =
          traffic.OperationState == 1
            ? i18n.t("inTravel")
            : traffic.OperationState == 2
            ? i18n.t("noTrip")
            : traffic.OperationState == 3
            ? i18n.t("stopped")
            : traffic.OperationState == 4
            ? i18n.t("outOfService")
            : i18n.t("other");

        if (traffic.Trip != null) {
          var creationDate = moment(traffic.Trip.CreatedDate)
            .local()
            .format("DD/MM/YYYY HH:mm");
          var start = moment(traffic.Trip.StartDate)
            .local()
            .format("DD/MM/YYYY HH:mm");
          if (i18n.locale == "en") {
            creationDate = moment(traffic.Trip.CreatedDate)
              .local()
              .format("MM/DD/YYYY HH:mm");
            start = moment(traffic.Trip.StartDate)
              .local()
              .format("MM/DD/YYYY HH:mm");
          }
          itemInfo = {
            TripId: traffic.Trip.TripId,
            CarrierId: traffic.Trip.CarrierId,
            CarrierName: traffic.Trip.CarrierName,
            CarrierServiceType: traffic.Trip.CarrierServiceType,
            CarrierModality: traffic.Trip.CarrierModality,
            travelName: traffic.Trip.TripName,
            pathName: traffic.Trip.RouteName,
            vehicle: traffic.DeviceId,
            DriverId: traffic.Trip.DriverId,
            operator: traffic.Trip.DriverName,
            DriverLicenseId: traffic.Trip.DriverLicenseId,
            DriverLicenseType: traffic.Trip.DriverLicenseType,
            number: traffic.Trip.DriverMobile,
            origin: traffic.Trip.Origin,
            destination: traffic.Trip.Destination,
            start: start,
            creator: traffic.Trip.OwnerName,
            creationDate: creationDate,
          };
        }
        var decimalTime = Math.abs(traffic.IdleTime);
        var decimals = decimalTime - Math.floor(decimalTime);
        var days = Math.floor(decimalTime / 24);
        var remainder = decimalTime % 24;
        remainder = Math.floor(remainder);
        decimalTime = remainder + decimals;
        decimalTime = decimalTime * 60 * 60;
        var hours = Math.floor(decimalTime / (60 * 60));
        decimalTime = decimalTime - hours * 60 * 60;
        var minutes = Math.floor(decimalTime / 60);
        decimalTime = decimalTime - minutes * 60;
        var seconds = Math.round(decimalTime);
        if (days < 10) {
          days = "0" + days;
        }
        if (hours < 10) {
          hours = "0" + hours;
        }
        if (minutes < 10) {
          minutes = "0" + minutes;
        }
        // if (seconds < 10) {
        //   seconds = "0" + seconds;
        // }
        traffic.IdleTime = days + "D, " + hours + ":" + minutes;
        var item = {};
        item = {
          MovilId: traffic.DeviceId,
          vehicle: traffic.DeviceId,
          address: i18n.t("unknown"),
          lat: traffic.Location.Lat,
          lng: traffic.Location.Lon,
          date: Date,
          idletime: traffic.IdleTime,
          statusId: traffic.OperationState,
          status: statusOptions,
          info: itemInfo,
        };
        if (statusOptions == state.filterTraffic) {
          state.trafficList.push(item);
        } else if (state.filterTraffic == i18n.t("allStates")) {
          state.trafficList.push(item);
          localStorage.setItem(
            "TrafficList",
            JSON.stringify(state.trafficList)
          );
        }
      });
      //Metodo para agrupar Coordenadas
      async function agroupList() {
        var List = ListLatLng;
        var arrFinal = [];
        List.forEach(async (vehicle1, index) => {
          var arrTemp = [];
          ListLatLng.forEach(async (vehicle, index) => {
            if (vehicle1.vehicleId != vehicle.vehicleId) {
              var lat1 = vehicle1.lat;
              var lng1 = vehicle1.lng;
              var lat2 = vehicle.lat;
              var lng2 = vehicle.lng;
              var LatLng1 = new google.maps.LatLng(lat1, lng1);
              var LatLng2 = new google.maps.LatLng(lat2, lng2);
              var distance = google.maps.geometry.spherical.computeDistanceBetween(
                LatLng1,
                LatLng2
              );
              if (distance <= 10 && distance > 0) {
                arrTemp.push(vehicle.vehicleId);
                await deleteElement(vehicle.vehicleId);
              }
            }
          });
          if (arrTemp.length != 0) {
            arrTemp.push(vehicle1.vehicleId);
            var item = {
              vehicleId: arrTemp,
              lat: vehicle1.lat,
              lng: vehicle1.lng,
              ubicacion: i18n.t("unknown"),
            };
            arrFinal.push(item);
            await deleteElement(vehicle1.vehicleId);
          }
        });
        arrFinal.forEach((vehicles, index) => {
          ListLatLng.push(vehicles);
        });
        demo(ListLatLng).catch((error) => {
          console.log(error);
        });
      }

      function deleteElement(vehicle) {
        for (var i = 0; i < ListLatLng.length; i++) {
          if (ListLatLng[i].vehicleId === vehicle) {
            ListLatLng.splice(i, 1);
          }
        }
      }
      setTimeout(() => agroupList(), 2000);
      //Metodo para geocodificacion
      async function demo(arrFinal) {
        // //var googleSt = google.maps.GeocoderStatus;
        // for (let i = 0; i < arrFinal.length; i++) {
        //   if (state.errorMaps == false) {
        //     var lat = arrFinal[i].lat;
        //     var lng = arrFinal[i].lng;
        //     //  let response = await axios.get(
        //     // "https://maps.googleapis.com/maps/api?client=gme-autotransportesde?latlng=" +
        //     //   lat +
        //     //   "," +
        //     //   lng +
        //     //   "&result_type=route");
        //     let response = await axios.get(
        //       "https://maps.googleapis.com/maps/api/geocode/json?latlng=" +
        //         lat +
        //         "," +
        //         lng +
        //         "&result_type=route&key=AIzaSyC2W6PjlZXKB8XWzLVh4Ap54rHTgi0qqWs"
        //     );

        //     if (response.data.status == googleSt.OK) {
        //       if (response.data.results[0]) {
        //         if (typeof arrFinal[i].vehicleId === "string") {
        //           await addAddress(
        //             arrFinal[i].vehicleId,
        //             response.data.results[0].formatted_address
        //           );
        //         } else {
        //           for (let j = 0; j < arrFinal[i].vehicleId.length; j++) {
        //             await addAddress(
        //               arrFinal[i].vehicleId[j],
        //               response.data.results[0].formatted_address
        //             );
        //           }
        //         }
        //         arrFinal[i].ubicacion =
        //           response.data.results[0].formatted_address;
        //       }
        //     } else if (
        //       response.data.status == googleSt.OVER_QUERY_LIMIT ||
        //       response.data.status == googleSt.UNKNOWN_ERROR ||
        //       response.data.status == googleSt.ERROR
        //     ) {
        //       await sleep(2000);
        //       i--;
        //     }
        //   }
        // }
      }

      async function sleep(ms) {
        return await new Promise((resolve) => setTimeout(resolve, ms));
      }

      function addAddress(vehicleId, address) {
        state.trafficList.forEach((vehicle, index) => {
          if (vehicle.MovilId == vehicleId) {
            vehicle.address = address;
            localStorage.setItem(
              "TrafficList",
              JSON.stringify(state.trafficList)
            );
            return;
          }
        });
      }
    }
  },

  setValuesTravel: (state) => {
    state.Minutes = [
      "00",
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
      "09",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "19",
      "20",
      "21",
      "22",
      "23",
      "24",
      "25",
      "26",
      "27",
      "28",
      "29",
      "30",
      "31",
      "32",
      "33",
      "34",
      "35",
      "36",
      "37",
      "38",
      "39",
      "40",
      "41",
      "42",
      "43",
      "44",
      "45",
      "46",
      "47",
      "48",
      "49",
      "50",
      "51",
      "52",
      "53",
      "54",
      "55",
      "56",
      "57",
      "58",
      "59",
    ];

    state.Hours = [
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
      "09",
      "10",
      "11",
      "12",
    ];

    state.startTime2 = {
      selectHour: state.Hours[11],
      selectMin: state.Minutes[0],
      selectMode: state.ampm[0],
    };

    state.endTime2 = {
      selectHour: state.Hours[11],
      selectMin: state.Minutes[0],
      selectMode: state.ampm[0],
    };

    state.startDateTravel =
      moment()
        .subtract(1, "days")
        .format("DD/MM/YYYY") +
      " " +
      state.startTime2.selectHour +
      ":" +
      state.startTime2.selectMin +
      " " +
      state.startTime2.selectMode;
    state.endDateTravel =
      moment().format("DD/MM/YYYY") +
      " " +
      state.endTime2.selectHour +
      ":" +
      state.endTime2.selectMin +
      " " +
      state.endTime2.selectMode;

    state.startDate2 = moment()
      .subtract()
      .format("YYYY-MM-DD");
    state.endDate2 = moment()
      .subtract()
      .format("YYYY-MM-DD");
    state.ampm = ["AM", "PM"];
  },
  startDateTravel: (state, payload) => {
    if (payload[0] == "start") {
      state.startDate2 = payload[1];
      state.startTimeH2 =
        state.startTime2.selectHour +
        ":" +
        state.startTime2.selectMin +
        " " +
        state.startTime2.selectMode;
      state.startDateTravel =
        moment(payload[1]).format("DD/MM/YYYY") + " " + state.startTimeH2;
    } else {
      state.endDate2 = payload[1];
      state.endTimeH2 =
        state.endTime2.selectHour +
        ":" +
        state.endTime2.selectMin +
        " " +
        state.endTime2.selectMode;
      state.endDateTravel =
        moment(payload[1]).format("DD/MM/YYYY") + " " + state.endTimeH2;
    }
  },
  selectedTime2: (state, payload) => {
    if (payload[0] == "start") {
      state.startTime2 = payload[1];
      state.startTimeH2 =
        state.startTime2.selectHour +
        ":" +
        state.startTime2.selectMin +
        " " +
        state.startTime2.selectMode;
      state.startDateTravel =
        moment(state.startDate2).format("DD/MM/YYYY") + " " + state.startTimeH2;
    } else {
      state.endTime2 = payload[1];
      state.endTimeH2 =
        state.endTime2.selectHour +
        ":" +
        state.endTime2.selectMin +
        " " +
        state.endTime2.selectMode;
      state.endDateTravel =
        moment(state.endDate2).format("DD/MM/YYYY") + " " + state.endTimeH2;
    }
  },
  editTravel: (state, payload) => {
    state.editTravel = payload;
  },
  googleErrors: (state, payload) => {
    state.errorMaps = payload;
  },
  vehiclesCarrier: (state, payload) => {
    state.vehiclesCarrier = payload;
  },
  enaEndDateT: (state, payload) => {
    state.enaEndDateT = payload;
  },
  allCarriers: (state, payload) => {
    state.allCarriers = payload;
  },
  progressCarrier: (state, payload) => {
    state.progressCa = payload;
  },
  progressDetails: (state, payload) => {
    state.progressDetails = payload;
  },
  listCarrier: (state, payload) => {
    state.listCarriers = [];
    payload.forEach((carrier, index) => {
      var ServiceType =
        carrier.ServiceType == 0
          ? i18n.t("unknown")
          : carrier.ServiceType == 1
          ? i18n.t("cargoGeneral")
          : carrier.ServiceType == 2
          ? i18n.t("hazardousMaterials")
          : i18n.t("alimentaryGrade");
      var Modality =
        carrier.Modality == 0
          ? i18n.t("unknown")
          : carrier.Modality == 1
          ? i18n.t("consolidated")
          : i18n.t("fullCar");
      var item = {
        Id: carrier.Id,
        DealerId: carrier.DealerId,
        ClientId: carrier.ClientId,
        AccountId: carrier.AccountId,
        TradeName: carrier.TradeName,
        BusinessName: carrier.BusinessName,
        Address: carrier.Address,
        ServiceTypeId: carrier.ServiceType,
        ServiceType: ServiceType,
        ModalityId: carrier.Modality,
        Modality: Modality,
        Contacts: carrier.Contacts,
        Active: carrier.Active,
      };
      state.listCarriers.push(item);
    });
  },
  editCarrier: (state, payload) => {
    state.editCarrier = {};
    state.dealerSelected = payload.DealerId;
    state.clientSelected = payload.ClientId;
    state.accountSelected = payload.AccountId;
    state.editCarrier = payload;
  },
  asigTrip: (state, payload) => {
    state.addTrip = payload.vehicle;
  },
  //Metodo de actualizacion de trafico
  UpdatePosition: (state, payload) => {
    state.UpdatePosition = payload;
  },
  //Barra de progreso de trafico
  progressOverTraffic: (state, payload) => {
    state.progressOver = payload;
  },
  titleOfGraphic: (state, value) => {
    localStorage.setItem("mytitle", JSON.stringify(value));
    state.titleGraphic = value;
    // state.PageHeaderGraphTitle = "yopli".toUpperCase();
    if (value == "fuelUsed" || value == "RalentiFuel") {
      state.PageHeaderGraphTitle = i18n.t("totalFuel").toUpperCase();
      state.shortByTable = "fuelRalenti";
    } else if (value == "FuelRange" || value == "FuelLowRange") {
      state.PageHeaderGraphTitle = i18n.t("rangeFuel").toUpperCase();
      state.shortByTable = "performance";
    } else if (value == "EngineOn" || value == "MoreTimeEngineOn") {
      state.PageHeaderGraphTitle = i18n.t("engineTime").toUpperCase();
      state.shortByTable = "engineRalenti";
    } else if (value == "Exceptions" || value == "MoreExceptions") {
      state.PageHeaderGraphTitle = i18n.t("exceptionsHome").toUpperCase();
      state.shortByTable = "intransitIncidents";
    }
  },
  fillPerformanceFleet: (state, val) => {
    state.PerformanceFleet = [];
    //console.log.log(val);
    state.PerformanceFleet = val;
  },
  changeChartSize: (state, val) => {
    if (val == "container1") {
      state.sizeChart1 = "width: 100%;height:420px;";
    } else {
      state.sizeChart2 = "width: 100%;height:420px;";
    }
  },
  start: (state, val) => {
    state.start = val;
    localStorage.setItem("start", true);
  },
  setItemsPerformance: (state, val) => {
    state.ItemsPerformance = [
      {
        title: i18n.t("performancePerTime"), //renddimiento
        value: val[0],
      },
      {
        title: i18n.t("totalDistance"), //distancia recorrida
        value: val[1],
      },
      {
        title: i18n.t("totalFuel"), //combustible consumido
        value: val[2],
      },
      {
        title: i18n.t("tripTime"), //nueva duracion viaje
        value: val[4],
      },
      // {
      //   title: i18n.t("timepto"), //tiempo pto
      //   value: val[5],
      // },
      {
        title: i18n.t("exceptionsHome"), //deficiencias de manejo
        value: val[6],
      },
      {
        title: i18n.t("maxSpeed"), //velocidad maxima
        value: val[7],
      },
      {
        title: i18n.t("avgSpeed"), //vel prom
        value: val[8],
      },
      {
        title: i18n.t("rpmMax"), //rpm maxima
        value: val[9],
      },
      {
        title: i18n.t("rpmAvg"), //rpm promedio
        value: val[10],
      },
      {
        title: i18n.t("maxMotorLoad"), // Carga de motor maxima
        value: val[11],
      },
      {
        title: i18n.t("AvgMotorLoad"), //promedio de carga de motor
        value: val[12],
      },
      {
        title: i18n.t("breakTime"), //tiempo descanso
        value: val[13],
      },
      // {
      //   title: i18n.t("tripTime"), //duracion viaje
      //   value: val[14],
      // },
    ];
  },

  //Función para llenar la tabla REPORTE DE INCIDENTES EN TRÁNSITO en performance/individual
  setItemsTableIncidents: (state, val) => {
    state.SelectedVolume =
      localStorage.getItem("Volume") == undefined
        ? "L"
        : localStorage.getItem("Volume");

    state.SelectedDistance =
      localStorage.getItem("Distance") == undefined
        ? "Km"
        : localStorage.getItem("Distance");
    var vehicle = localStorage.getItem("performanceVehicle");
    var arr2 = [];
    var arr3 = [];
    vehicle = vehicle.split("@");
    var nickId = vehicle[0];
    var vehicleId = vehicle[1];
    var colors = [
      "red",
      "yellow",
      "blue",
      "ltblue",
      "orange",
      "pink",
      "purple",
    ];
    var pinColor;
    var indexx = 0;
    var address = "";
    var tripColor = [];
    if (state.listOfTrips.length > 0) {
      state.listOfTrips.forEach((elementTrip) => {
        indexx = indexx > colors.length ? 0 : indexx;
        pinColor = colors[indexx];
        indexx++;
        var tripColor1 = {
          color: pinColor,
          tripId: elementTrip.id,
        };
        tripColor.push(tripColor1);
      });
    }

    val.forEach((element) => {
      if (element.Id === null) return;

      if (element.Id === "481") return;

      var colorFinal = "red";
      tripColor.forEach((elementColor) => {
        if (element.TripId.includes(elementColor.tripId)) {
          colorFinal = elementColor.color;
        }
      });

      element.Description = i18n.t("ev" + element.Id);
      if (element.Description == "evnull") element.Description = `[${element.Id}]`;
      let dateTimestamp = moment(element.Date, "YYYY-MM-DDTHH:mm").valueOf();

      var myArray = {
        IdReporte: "NA",
        DeviceId: vehicleId,
        Device: `${nickId} (${vehicleId})`,
        DateFormatted: element.DateFormatted,
        DateTimestamp: dateTimestamp,
        Reference: i18n.t("showReference"),
        Description: element.Description,
        Details: element.Details,
        Lat: element.Lat,
        Lon: element.Lon,
        newColor: colorFinal,
        tripName: element.TripName,
        tripId: element.TripId,
        EventId: element.Id
      };

      arr2.push(myArray);

      //se separa cada elemento de element.Details
      var detailsEvent = "";
      var details = element.Details;
      if (details != "ND" && details != null) {
        details = details.split(" ");
        for (var i = 0; i < details.length; i++) {
          details[i] = parseFloat(details[i]);
        }
      }

      if (details == "ND" || details == null) {
        detailsEvent = i18n.t("notAvailable");
      } else {
        if (element.Id == "445") {
          //Exceso de RPM
          //Detalles: Umbral (RPM) Distancia (Km) Tiempo (s) Valor max (RPM)
          if (state.SelectedDistance != "Km") {
            details[1] =
              details[1] == 0 ? 0 : parseFloat(details[1] / 1.60934).toFixed(3);
          }

          details[0] = formatNumber.new(details[0], "Rpms");
          details[1] = formatNumber.new(details[1], state.SelectedDistance);
          details[3] = formatNumber.new(details[3], "Rpms");

          detailsEvent =
            `${i18n.t("threshold")}: ${details[0]} | ` +
            `${i18n.t("distanceTraveled")}: ${details[1]} | ` +
            `${i18n.t("timeElapsed")}: ${splitTimeInMutations.splitSeconds(details[2])} | ` +
            `${i18n.t("maxVal")}: ${details[3]}`;

        } else if (element.Id == "446") {
          //Apagado en menos de X segundos
          //Detalles: Tiempo mínimo de apagado (s) Tiempo de apagado detectado (s)
          detailsEvent =
            `${i18n.t("minTime")}: ${splitTimeInMutations.splitSeconds(details[0])} | ` +
            `${i18n.t("detectedShutdown")}: ${splitTimeInMutations.splitSeconds(details[1])}`;

        } else if (element.Id == "447") {
          //Exceso de tiempo de embrague, en movimiento
          //Detalles: Tiempo umbral (s) Tiempo detectado (s)
          detailsEvent =
            `${i18n.t("thresholdTime")}: ${splitTimeInMutations.splitSeconds(details[0])} | ` +
            `${i18n.t("timeDetected")}: ${splitTimeInMutations.splitSeconds(details[1])}`;

        } else if (element.Id == "448") {
          //Exceso de tiempo de embrague, detenido
          //Detalle: Tiempo umbral (s) Tiempo detectado (s)
          detailsEvent =
            `${i18n.t("thresholdTime")}: ${splitTimeInMutations.splitSeconds(details[0])} | ` +
            `${i18n.t("timeDetected")}: ${splitTimeInMutations.splitSeconds(details[1])}`;

        } else if (element.Id == "449") {
          //Exceso de tiempo de freno
          //Detalles: Velocidad umbral (Km/h) Tiempo umbral (s) Tiempo detectado (s) Velocidad al inicio del evento (Km/h) Velocidad al final del evento (Km/h) Distancia (Km)
          if (state.SelectedDistance != "Km") {
            details[0] =
              details[0] == 0 ? 0 : parseFloat(details[0] / 1.60934).toFixed(3);
            details[3] =
              details[3] == 0 ? 0 : parseFloat(details[3] / 1.60934).toFixed(3);
            details[4] =
              details[4] == 0 ? 0 : parseFloat(details[4] / 1.60934).toFixed(3);
            details[5] =
              details[5] == 0 ? 0 : parseFloat(details[5] / 1.60934).toFixed(3);
          }
          details[0] = formatNumber.new(details[0], `${state.SelectedDistance}/h`);
          details[3] = formatNumber.new(details[3], `${state.SelectedDistance}/h`);
          details[4] = formatNumber.new(details[4], `${state.SelectedDistance}/h`);
          details[5] = formatNumber.new(details[5], state.SelectedDistance);
          detailsEvent =
            `${i18n.t("thresholdSpeed")}: ${details[0]} | ` +
            `${i18n.t("thresholdTime")}: ${splitTimeInMutations.splitSeconds(details[1])} | ` +
            `${i18n.t("timeDetected")}: ${splitTimeInMutations.splitSeconds(details[2])} | ` +
            `${i18n.t("speedAtTheStart")}: ${details[3]} | ` +
            `${i18n.t("speedAtTheEnd")}: ${details[4]} | ` +
            `${i18n.t("distanceTraveled")}: ${details[5]}`;

        } else if (element.Id == "450") {
          //Exceso de carga del motor
          //Detalles: Porcentaje de carga umbral (%) Distancia (Km) Tiempo (s) Porcentaje de carga máxima detectada (%)
          if (state.SelectedDistance != "Km") {
            details[1] =
              details[1] == 0 ? 0 : parseFloat(details[1] / 1.60934).toFixed(3);
          }
          details[1] = formatNumber.new(details[1], state.SelectedDistance);
          detailsEvent =
            `${i18n.t("thresholdLoadP")}: ${details[0]} % | ` +
            `${i18n.t("distanceTraveled")}: ${details[1]} | ` +
            `${i18n.t("timeElapsed")}: ${splitTimeInMutations.splitSeconds(details[2])} | ` +
            `${i18n.t("percentageOfMaxLoad")}: ${details[3]} %`;

        } else if (element.Id == "451") {
          //Alto porcentaje de tiempo ralentí
          //Detalles: Porcentaje umbral (%) Tiempo umbral (H) Tiempo ralentí transcurrido desde el inicio del viaje (H) Combustible consumido en ralentí desde la marca (lt)
          if (state.SelectedVolume != "L") {
            details[3] =
              details[3] == 0 ? 0 : parseFloat(details[3] / 3.78541).toFixed(1);
          }
          details[3] = formatNumber.new(details[3], state.SelectedVolume);
          detailsEvent =
            `${i18n.t("umbralPercentage")}: ${details[0]} % | ` +
            `${i18n.t("tripThresholdTime")}: ${splitTimeInMutations.splitSeconds(details[1] * 3600)}` +
            `${i18n.t("idleTimeElapsed")}: ${splitTimeInMutations.splitSeconds(details[2] * 3600)}` +
            `${i18n.t("fuelConsumedIdleMark")}: ${details[3]}`;

        } else if (element.Id == "452") {
          //Aceleración brusca
          //Detalles: Aceleración umbral (Km/h-s) Aceleración máxima detectada (Km/h-s) Velocidad al inicio del evento (Km/h) Velocidad al final del evento (Km/h) 
          if (state.SelectedDistance != "Km") {
            details[0] =
              details[0] == 0 ? 0 : parseFloat(details[0] * 0.62137).toFixed(3);
            details[1] =
              details[1] == 0 ? 0 : parseFloat(details[1] * 0.62137).toFixed(3);
            details[2] =
              details[2] == 0 ? 0 : parseFloat(details[2] / 1.60934).toFixed(3);
            details[3] =
              details[3] == 0 ? 0 : parseFloat(details[3] / 1.60934).toFixed(3);
          }
          details[0] = formatNumber.new(details[0], `${state.SelectedDistance}/h-s`);
          details[1] = formatNumber.new(details[1], `${state.SelectedDistance}/h-s`);
          details[2] = formatNumber.new(details[2], `${state.SelectedDistance}/h`);
          details[3] = formatNumber.new(details[3], `${state.SelectedDistance}/h`);

          detailsEvent =
            `${i18n.t("thresholdAcceleration")}: ${details[0]} | ` +
            `${i18n.t("accelerationMax")}: ${details[1]} | ` +
            `${i18n.t("speedAtTheStart")}: ${details[2]} | ` +
            `${i18n.t("speedAtTheEnd")}: ${details[3]}`;

        } else if (element.Id == "453") {
          //Frenado brusco
          //Detalles: Frenado umbral (Km/h-s) Frenado máximo detectado (Km/h-s) Velocidad al inico del evento (Km/h) Velocidad al final del evento (Km/h) 
          if (state.SelectedDistance != "Km") {
            details[0] =
              details[0] == 0 ? 0 : parseFloat(details[0] * 0.62137).toFixed(3);
            details[1] =
              details[1] == 0 ? 0 : parseFloat(details[1] * 0.62137).toFixed(3);
            details[2] =
              details[2] == 0 ? 0 : parseFloat(details[2] / 1.60934).toFixed(3);
            details[3] =
              details[3] == 0 ? 0 : parseFloat(details[3] / 1.60934).toFixed(3);
          }
          details[0] = formatNumber.new(details[0], `${state.SelectedDistance}/h-s`);
          details[1] = formatNumber.new(details[1], `${state.SelectedDistance}/h-s`);
          details[2] = formatNumber.new(details[2], `${state.SelectedDistance}/h`);
          details[3] = formatNumber.new(details[3], `${state.SelectedDistance}/h`);
          detailsEvent =
            `${i18n.t("thresholdBraking")}: ${details[0]} | ` +
            `${i18n.t("maxBrakingD")}: ${details[1]} | ` +
            `${i18n.t("speedAtTheStart")}: ${details[2]} | ` +
            `${i18n.t("speedAtTheEnd")}: ${details[3]}`;

        } else if (element.Id == "454") {
          //Bajo porcentaje de control crucero
          //Detalles: Porcentaje umbral (%) Porcentaje detectado (%)
          detailsEvent =
            `${i18n.t("umbralPercentage")}: ${details[0]} % | ` +
            `${i18n.t("percentageDetected")}: ${details[1]} %`;

        } else if (element.Id == "455") {
          //Alerta de tiempo en ralentí
          //Detalles: Tiempo umbral (s)
          detailsEvent = `${i18n.t("thresholdTime")}: ${splitTimeInMutations.splitSeconds(details[0])}`;

        } else if (element.Id == "456") {
          //Tiempo de descanso insuficiente
          //Detalles: Tiempo umbral de manejo (s) Tiempo transcurrido de manejo (s)
          detailsEvent =
            `${i18n.t("drivingThresholdTime")}: ${splitTimeInMutations.splitSeconds(details[0])} | ` +
            `${i18n.t("drivingTimeElapsed")}: ${splitTimeInMutations.splitSeconds(details[1])}`;

        } else if (element.Id == "457") {
          //Exceso de velocidad medio
          //Detalles: Umbral (Km/h) Distancia (Km) Tiempo (s) Valor máximo detectado (Km/h)
          if (state.SelectedDistance != "Km") {
            details[0] =
              details[0] == 0 ? 0 : parseFloat(details[0] / 1.60934).toFixed(3);
            details[1] =
              details[1] == 0 ? 0 : parseFloat(details[1] / 1.60934).toFixed(3);
            details[3] =
              details[3] == 0 ? 0 : parseFloat(details[3] / 1.60934).toFixed(3);
          }
          details[0] = formatNumber.new(details[0], `${state.SelectedDistance}/h`);
          details[1] = formatNumber.new(details[1], state.SelectedDistance);
          details[3] = formatNumber.new(details[3], `${state.SelectedDistance}/h`);
          detailsEvent =
            `${i18n.t("threshold")}: ${details[0]} | ` +
            `${i18n.t("distanceTraveled")}: ${details[1]} | ` +
            `${i18n.t("timeElapsed")}: ${splitTimeInMutations.splitSeconds(details[2])} | ` +
            `${i18n.t("maxVal")}: ${details[3]}`;

        } else if (element.Id == "458") {
          //Exceso de velocidad severo
          //Detalles: Umbral (Km/h) Distancia (Km) Tiempo (s) Valor máximo detectado (Km/h)
          if (state.SelectedDistance != "Km") {
            details[0] =
              details[0] == 0 ? 0 : parseFloat(details[0] / 1.60934).toFixed(3);
            details[1] =
              details[1] == 0 ? 0 : parseFloat(details[1] / 1.60934).toFixed(3);
            details[3] =
              details[3] == 0 ? 0 : parseFloat(details[3] / 1.60934).toFixed(3);
          }
          details[0] = formatNumber.new(details[0], `${state.SelectedDistance}/h`);
          details[1] = formatNumber.new(details[1], state.SelectedDistance);
          details[3] = formatNumber.new(details[3], `${state.SelectedDistance}/h`);
          detailsEvent =
            `${i18n.t("threshold")}: ${details[0]} | ` +
            `${i18n.t("distanceTraveled")}: ${details[1]} | ` +
            `${i18n.t("timeElapsed")}: ${splitTimeInMutations.splitSeconds(details[2])} |` +
            `${i18n.t("maxVal")}: ${details[3]}`;

        } else if (element.Id == "459") {
          //Baja economía de combustible
          //Detalles: Rendimiento mínimo (Km/lt) Rendimiento detectado (Km/lt) Odómetro (Km)
          if (state.SelectedDistance != "Km") {
            details[2] =
              details[2] == 0 ? 0 : parseFloat(details[2] / 1.60934).toFixed(3);
          }

          if (state.SelectedVolume == "gal" && state.SelectedDistance == "mi") {
            details[0] =
              details[0] == 0 ? 0 : parseFloat(details[0] * 2.35).toFixed(2);
            details[1] =
              details[1] == 0 ? 0 : parseFloat(details[1] * 2.35).toFixed(2);
          }

          if (state.SelectedVolume == "gal" && state.SelectedDistance == "Km") {
            details[0] =
              details[0] == 0 ? 0 : parseFloat(details[0] * 2.35).toFixed(2);
            details[1] =
              details[1] == 0 ? 0 : parseFloat(details[1] * 3.78).toFixed(2);
          }

          if (state.SelectedVolume == "L" && state.SelectedDistance == "mi") {
            details[0] =
              details[0] == 0 ? 0 : parseFloat(details[0] * 2.35).toFixed(2);
            details[1] =
              details[1] == 0 ? 0 : parseFloat(details[1] * 0.62).toFixed(2);
          }
          details[0] = formatNumber.new(details[0], `${state.SelectedDistance}/${state.SelectedVolume}`);
          details[1] = formatNumber.new(details[1], `${state.SelectedDistance}/${state.SelectedVolume}`);
          details[2] = formatNumber.new(details[2], state.SelectedDistance);

          detailsEvent =
            `${i18n.t("minPerformance")}: ${details[0]} | ` +
            `${i18n.t("performanceDetected")}: ${details[1]} | ` +
            `${i18n.t("odometer")}: ${details[2]}`;

        } else if (element.Id == "463") {
          //PTO detenido
          //Detalles: Consumo de combustible total (lt) Consumo de combustible ralentí (lt) Tiempo PTO (s)
          if (state.SelectedVolume != "L") {
            details[0] =
              details[0] == 0 ? 0 : parseFloat(details[0] / 3.78541).toFixed(1);
            details[1] =
              details[1] == 0 ? 0 : parseFloat(details[1] / 3.78541).toFixed(1);
          }
          details[0] = formatNumber.new(details[0], state.SelectedVolume);
          details[1] = formatNumber.new(details[1], state.SelectedVolume);
          detailsEvent =
            `${i18n.t("totalFuelConsumption")}: ${details[0]} | ` +
            `${i18n.t("fuelConsumptionIdle")}: ${details[1]} | ` +
            `${i18n.t("timepto")}: ${splitTimeInMutations.splitSeconds(details[2])}`;

        } else if (element.Id == "464") {
          //Descanso detectado
          //Detalles: Tiempo umbral (s) Tiempo de manejo (s)
          detailsEvent =
            `${i18n.t("thresholdTime")}: ${splitTimeInMutations.splitSeconds(details[0])} | ` +
            `${i18n.t("timedriving")}: ${splitTimeInMutations.splitSeconds(details[1])}`;

        } else if (element.Id == "466") {
          //Promedio alto de carga del motor
          //Detalles: Tiempo umbral (H) Carga promedio umbral (%) Porcentaje promedio de carga detectado (%)
          detailsEvent =
            `${i18n.t("thresholdTime")}: ${splitTimeInMutations.splitSeconds(details[0] * 3600)} | ` +
            `${i18n.t("thresholdAvgLoad")}: ${details[1]} % | ` +
            `${i18n.t("avgLoadPercentage")}: ${details[2]} %`;

        } else if (element.Id == "467") {
          //Detección de codigos de error
          //Detalles: ID 'SPN/PID' FMI Ocurrencia
          detailsEvent =
            `Id: ${details[0]} | ` +
            `SPN/PID: ${ details[1]} | ` +
            `FMI: ${details[2]} | ` +
            `${i18n.t("frequency")}: ${details[3]}`;

        } else if (element.Id == "472") {
          //Data bus incorrecto seleccionado
          //Detalles: 'ID del bus real detectado' 'ID del bus seleccionado al configurar'
          detailsEvent =
            `${i18n.t("busReal")}: ${details[0]} | ` +
            `${i18n.t("selectedBus")}: ${details[1]}`;

        } else if (element.Id == "479") {
          //Inicio de PTO en movimiento //duda
          //Detalles: Tiempo PTO (s) Consumo de combustible total (lt) Consumo de combustible ralentí (lt) word
          //Detalles: Consumo de combustible total (lt) Consumo de combustible ralentí (lt) Tiempo PTO (s) pdf
          if (state.SelectedVolume != "L") {
            details[0] =
              details[0] == 0 ? 0 : parseFloat(details[0] / 3.78541).toFixed(1);
            details[1] =
              details[1] == 0 ? 0 : parseFloat(details[1] / 3.78541).toFixed(1);
          }
          details[0] = formatNumber.new(details[0], state.SelectedVolume);
          details[1] = formatNumber.new(details[1], state.SelectedVolume);
          detailsEvent =
            `${i18n.t("totalFuelConsumption")}: ${details[0]} | ` +
            `${i18n.t("fuelConsumptionIdle")}: ${details[1]} | ` +
            `${i18n.t("timepto")}: ${splitTimeInMutations.splitSeconds(details[2])}`;

        } else if (element.Id == "480") {
          //Fin de PTO en movimiento //duda
          //Detalles: Tiempo PTO (s) Consumo de combustible total (lt) Consumo combustible ralentí (lt) word
          //Detalles: Consumo de combustible total (lt) Consumo combustible ralentí (lt) Tiempo PTO (s) pdf
          if (state.SelectedVolume != "L") {
            details[0] =
              details[0] == 0 ? 0 : parseFloat(details[0] / 3.78541).toFixed(1);
            details[1] =
              details[1] == 0 ? 0 : parseFloat(details[1] / 3.78541).toFixed(1);
          }
          details[0] = formatNumber.new(details[0], state.SelectedVolume);
          details[1] = formatNumber.new(details[1], state.SelectedVolume);
          detailsEvent =
            `${i18n.t("totalFuelConsumption")}: ${details[0]} | ` +
            `${i18n.t("fuelConsumptionIdle")}: ${details[1]} | ` +
            `${i18n.t("timepto")}: ${splitTimeInMutations.splitSeconds(details[2])}`;

        } else if (element.Id == "482") {
          //Resumen de alerta de tiempo en ralentí
          //Detalles: Consumo de combustible ralentí (lt) Tiempo transcurrido en ralentí (H)
          if (state.SelectedVolume != "L") {
            details[0] =
              details[0] == 0 ? 0 : parseFloat(details[0] / 3.78541).toFixed(1);
          }
          details[0] = formatNumber.new(details[0], state.SelectedVolume);

          detailsEvent =
            `${i18n.t("ralentiFuelConsumed")}: ${details[0]} | ` +
            `${i18n.t("ralentiTimeConsumed")}: ${splitTimeInMutations.splitSeconds(details[1] * 3600)}`;

        } else if (element.Id == "483") {
          //Activación de control crucero
          //Detalles: Odómetro total (Km) Combustible total (lt) Tiempo total (H)
          if (state.SelectedDistance != "Km") {
            details[0] =
              details[0] == 0 ? 0 : parseFloat(details[0] / 1.60934).toFixed(3);
          }
          if (state.SelectedVolume != "L") {
            details[1] =
              details[1] == 0 ? 0 : parseFloat(details[1] / 3.78541).toFixed(1);
          }
          details[0] = formatNumber.new(details[0], state.SelectedDistance);
          details[1] = formatNumber.new(details[1], state.SelectedVolume);
          detailsEvent =
            `${i18n.t("totalOdometer")}: ${details[0]} | ` +
            `${i18n.t("theTotalFuel")}: ${details[1]} | ` +
            `${i18n.t("totalTime")}: ${splitTimeInMutations.splitSeconds(details[2] * 3600)}`;

        } else if (element.Id == "484") {
          //Desactivación de control crucero
          //Detalles: Odómetro total (Km) Combustible total (lt) Tiempo total (H) Velocidad crucero promedio (Km/h)
          if (state.SelectedDistance != "Km") {
            details[0] =
              details[0] == 0 ? 0 : parseFloat(details[0] / 1.60934).toFixed(3);
            details[3] =
              details[3] == 0 ? 0 : parseFloat(details[3] / 1.60934).toFixed(3);
          }
          if (state.SelectedVolume != "L") {
            details[1] =
              details[1] == 0 ? 0 : parseFloat(details[1] / 3.78541).toFixed(1);
          }
          details[0] = formatNumber.new(details[0], state.SelectedDistance);
          details[1] = formatNumber.new(details[1], state.SelectedVolume);
          details[3] = formatNumber.new(details[3], `${state.SelectedDistance}/h`);

          detailsEvent =
            `${i18n.t("totalOdometer")}: ${details[0]} | ` +
            `${i18n.t("theTotalFuel")}: ${details[1]} | ` +
            `${i18n.t("totalTime")}: ${details[2] * 3600} | ` +
            `${i18n.t("avgCruisingSpeed")}: ${details[3] }`;

        } else {
          console.log(element.Id);
          //470 471 y otros se mostrará element.Details crudo
          detailsEvent = element.Details;
        }
      }
      var myArr2 = {
        IdReporte: "NA",
        DeviceId: vehicleId,
        Device: `${nickId} (${vehicleId})`,
        DateFormatted: element.DateFormatted,
        DateTimestamp: dateTimestamp,
        Reference: i18n.t("showReference"),
        Description: element.Description,
        Details: detailsEvent,
        Lat: element.Lat,
        Lon: element.Lon,
        newColor: colorFinal,
        tripName: element.TripName,
        tripId: element.TripId,
        EventId: element.Id
      };
      arr3.push(myArr2);
    });

    state.coor = arr2;
    state.itemsTableInTransit2 = arr3;
  },

  setitemsPerformanceData: (state, val) => {
    state.itemsPerformanceInfo = val;
  },
  setDataPerformance: (state, { data, trips }) => {
    state.listOfTrips = trips;
    state.dataPerformance = data;
    state.numberOfTrips = trips.length == 0 ? 0 : trips.length - 1;
  },
  btnDisabled: (state, val) => {
    var style = "'.disable-events {pointer - events: none};'";
    state.btnDisableds = val ? style : "";
    state.btnDisabled = val;
  },
  setGlobalCalculations: (state, data) => {
    state.itemsGlobalCalc = data;
  },
  setEfficiencyByAnalisis: (state, data) => {
    state.itemsTripsAnalysis = data;
  },
  changeHeadersMetrics: (state, val) => {
    var dist = state.SelectedDistance;
    var vol = state.SelectedVolume;

    state.headersMetrics.forEach((element) => {
      if (element.value == "fuelDriving") {
        element.text =
          i18n.t("drivingConsume").toUpperCase() + " (" + vol + ")";
      } else if (element.value == "fuelRalenti") {
        element.text =
          i18n.t("consumptionIdle").toUpperCase() + " (" + vol + ")";
      } else if (element.value == "fuelPto") {
        element.text = i18n.t("consumePTO").toUpperCase() + " (" + vol + ")";
      } else if (element.value == "performance") {
        element.text =
          i18n.t("rendi").toUpperCase() + " (" + dist + "/" + vol + ")";
      } else if (element.value == "distance") {
        element.text = i18n.t("distance").toUpperCase() + " (" + dist + ")";
      } else if (element.value == "speedMax") {
        element.text = i18n.t("maxSpeed").toUpperCase() + " (" + dist + "/h)";
      }
    });
  },
  changeHeadersCompare: (state, val) => {
    var dist = state.SelectedDistance;
    var vol = state.SelectedVolume;
    state.headersGlobalCalculations.forEach((element) => {
      if (element.value == "fuelConsumed") {
        element.text = i18n.t("fuelConsumed").toUpperCase() + " (" + vol + ")";
      } else if (element.value == "performance") {
        element.text =
          i18n.t("rendi").toUpperCase() + " (" + dist + "/" + vol + ")";
      } else if (element.value == "distancRoad") {
        element.text = i18n.t("distancRoad").toUpperCase() + " (" + dist + ")";
      }
    });

    state.headersTripsAnalysis.forEach((element) => {
      if (element.value == "maxSpeed") {
        element.text = i18n.t("maxSpeed").toUpperCase() + " (" + dist + "/h)";
      } else if (element.value == "avgSpeed") {
        element.text = i18n.t("avgSpeed").toUpperCase() + " (" + dist + "/h)";
      }
    });
  },

  setGeneralData: (state, val) => {
    state.SelectedVolume =
      localStorage.getItem("Volume") == undefined
        ? "L"
        : localStorage.getItem("Volume");

    state.SelectedDistance =
      localStorage.getItem("Distance") == undefined
        ? "Km"
        : localStorage.getItem("Distance");

    state.finalOdometer = val[0] > 0 ? val[0] : 0;
    state.finalFuel = val[1] > 0 ? val[1] : 0;
    //state.finalOdometer = parseFloat(state.finalOdometer).toFixed(3);
    state.finalOdometer =
      state.finalOdometer % 1 !== 0
        ? parseFloat(state.finalOdometer).toFixed(3)
        : state.finalOdometer;
    //state.finalFuel = parseFloat(state.finalFuel).toFixed(1);
    state.finalOdometer = formatNumber.new(
      state.finalOdometer,
      state.SelectedDistance
    );
    if (state.SelectedVolume == "L") {
      state.finalFuel = state.finalFuel.toFixed();
    } else {
      state.finalFuel =
        state.finalFuel % 1 !== 0
          ? parseFloat(state.finalFuel).toFixed(1)
          : state.finalFuel;
    }
    state.finalFuel = formatNumber.new(state.finalFuel, state.SelectedVolume);

    let dateFormat = i18n.locale == "en" ? "MMM/DD/YYYY HH:mm" : "DD/MMM/YYYY HH:mm";

    if (val[2] != i18n.t("notAvailable") && val[3] != i18n.t("notAvailable")) {
        state.intervalStart = moment(val[2], "YYYY-MM-DDTHH:mm:ss").format(dateFormat);
        if (i18n.locale != "en") state.intervalStart = state.intervalStart.replace(".", "");

        state.intervalEnd = moment(val[3], "YYYY-MM-DDTHH:mm:ss").format(dateFormat);
        if (i18n.locale != "en") state.intervalEnd = state.intervalEnd.replace(".", "");

    } else if (
      val[2] == i18n.t("notAvailable") &&
      val[3] != i18n.t("notAvailable")
    ) {
      state.intervalStart = i18n.t("notAvailable");
      state.intervalEnd = moment(val[3], "YYYY-MM-DDTHH:mm:ss").format(dateFormat);
      if (i18n.locale != "en") state.intervalEnd = state.intervalEnd.replace(".", "");

    } else if (
      val[2] != i18n.t("notAvailable") &&
      val[3] == i18n.t("notAvailable")
    ) {
      state.intervalStart = moment(val[2], "YYYY-MM-DDTHH:mm:ss").format(dateFormat);
      if (i18n.locale != "en") state.intervalStart = state.intervalStart.replace(".", "");
      state.intervalEnd = i18n.t("notAvailable");

    } else {
      state.intervalStart = i18n.t("notAvailable");
      state.intervalEnd = i18n.t("notAvailable");
    }
  },

  mapDataInfo: (state, val) => {
    state.mapDataInfo = val;
  },
  setCarrierId: (state, val) => {
    state.carrierId = val;
  },
  setVehiclesAF: (state, val) => {
    state.listVehiclesAF = val;
  },
  setitemsRetrieveLevel: (state, val) => {
    //console.log(val);
    state.itemsRetrieveLevel = val;
    state.SelectedVolume =
      localStorage.getItem("Volume") == undefined
        ? "L"
        : localStorage.getItem("Volume");
    var data = state.itemsRetrieveLevel;
    state.dateLastLevel = data.DateGPS;
    data.VolumenGlobal = parseFloat(data.VolumenGlobal);
    if (state.SelectedVolume == "L") {
      data.VolumenGlobal = data.VolumenGlobal.toFixed();
      state.lastLevel = data.VolumenGlobal + " " + state.SelectedVolume;
    } else {
      state.lastLevel =
        data.VolumenGlobal.toFixed(1).replace(/\.0$/, "") +
        " " +
        state.SelectedVolume;
    }

    state.lastLevel = data.VolumenGlobal + " " + state.SelectedVolume;
    state.lat1 = data.Lat;
    state.lon1 = data.Lon;
    state.addressLastLevel = data.Location;

    setTimeout(() => {
      state.viewSkeletonsRL = false;
    }, 2000);
  },
  setitemsPerformanceAF: (state, val) => {
    state.itemsPerformanceAF = val;

    var performanceTrips = state.itemsPerformanceAF.PERFORMANCE;
    state.dataFuel = state.itemsPerformanceAF.ALERTFUEL_RECENT_ACTIVTY;

    //Solo se realiza procedimiento para actividad reciente si tenemos al menos una actividad
    if (state.dataFuel.length > 0) {
      state.viewSkeletonsAR = false;
    } else {
      state.viewSkeletonsAR = true;
      state.skeletonLineAR = "outskeleton";
    }

    let selectedDistance = localStorage.getItem("Distance") == undefined
      ? "Km"
      : localStorage.getItem("Distance");
    
      let selectedVolume = localStorage.getItem("Volume") == undefined
        ? "L"
        : localStorage.getItem("Volume");

    //Solo se realiza procedimiento para performance si tenemos al menos un viaje
    if (performanceTrips.length > 0) {
      var perf = 0;
      performanceTrips.forEach((element) => {
        perf += parseFloat(element.Performance.Performance);
      });

      if (performanceTrips.length == 1) {
        state.date2WS = formatDate.dateCustom(performanceTrips[0].Period.End);
        state.date1WS = formatDate.dateCustom(performanceTrips[0].Period.Start);
      } else {
        state.date2WS = formatDate.dateCustom(performanceTrips[0].Period.End);
        state.date1WS = formatDate.dateCustom(performanceTrips[performanceTrips.length - 1].Period.Start);
      }

      perf = (perf / performanceTrips.length).toFixed(2);
      state.performanceAF = `${perf} ${selectedDistance}/${selectedVolume}`;

      state.viewSkeletonsFP = false;

    } else {
      state.viewSkeletonsFP = true;
      state.skeletonColumnFP = "outskeletonColumn";
    }
  },

  setLocationRG: (state, val) => {
    state.locationRG = val;

    localStorage.setItem("setLocationRG", state.locationRG);
  },
  cancelLoader: (state, val) => {
    state.loaderFuel = val;
  },
  cancelLoaderSeeMore: (state, val) => {
    state.loaderSeeMore = val;
  },
  updateBtn: (state, payload) => {
    state.updateBtn = payload;
  },
  progressTracking: (state, payload) => {
    state.loadingTableInTracking = payload;
  },
  showMsgT: (state, { val, title, failed }) => {
    state.titleCommand = title;
    state.showMsgT = val;
    state.failedCommand = failed;
  },
  setDatesInfoTracking: (state, { sdt, start, edt, end }) => {
    if (i18n.locale == "en") {
      var startDateTracking = moment(sdt).format("MM/DD/YYYY");
      var endDateTracking = moment(edt).format("MM/DD/YYYY");
    } else {
      var startDateTracking = moment(sdt).format("DD/MM/YYYY");
      var endDateTracking = moment(edt).format("DD/MM/YYYY");
    }
    //console.log("startDateTracking: " + startDateTracking);
    state.periodTracking =
      startDateTracking + " " + start + " - " + endDateTracking + " " + end;
  },
  setResponse: (state, { command, text }) => {
    //console.log(text);
    state.responseTexto = true;
    state.responseText = text;
  },
  indeterminateReport: (state, payload) => {
    state.indeterminateReport = payload;
  },
  selectionNames: (state) => {
    var dealerInfo = JSON.parse(localStorage.getItem("DealerSelectedId"));
    var clientInfo = JSON.parse(localStorage.getItem("ClientSelectedId"));
    var userInfo = JSON.parse(localStorage.getItem("SelectedAccess"));

    if (dealerInfo != undefined && clientInfo != undefined) {
      if (clientInfo.Name == undefined || clientInfo.Name == null) {
        state.clientName = userInfo.ClientName;
      } else {
        state.clientName = clientInfo.Name;
      }
      if (dealerInfo.Name == undefined || dealerInfo.Name == null) {
        state.dealerName = userInfo.DealerName;
      } else {
        state.dealerName = dealerInfo.Name;
      }
    }
  },
  initialReport: (state, payload) => {
    state.initialReport = payload;
  },
  cleanClustersAndMarkersPolyline: (state, payload) => {
    if (state.listOfMarkersPolyline.length > 0) {
      for (var i = 0; i < state.listOfMarkersPolyline.length; i++) {
        state.listOfMarkersPolyline[i].setMap(null);
      }
      state.listOfMarkersPolyline = [];
    }
    if (state.savePolyline != "") {
      state.savePolyline.setMap(null);
    }
    if (state.startEndMarkerP.length > 0) {
      for (var i = 0; i < state.startEndMarkerP.length; i++) {
        state.startEndMarkerP[i].setMap(null);
      }
      state.startEndMarkerP = [];
      state.clusterforPolyline.clearMarkers();
    }
  },
  showMoreVehicles: (state, payload) => {
    // console.log(state.vehiclesListItems);
    state.vehiclesListItems = _.orderBy(state.vehiclesListItems, "MovilId");
    var vehicles = _.orderBy(state.vehicles, "MovilId");

    var vehiclesSelecteds = vehicles.slice(
      state.vehiclesListItems.length,
      state.vehiclesListItems.length + 10
    );

    vehiclesSelecteds.forEach((element) => {
      state.vehiclesListItems.push(element);
    });
  },
  clearVehiclesList: (state, payload) => {
    state.vehiclesListItems = payload;
  },
  trackingChange: (state, payload) => {
    state.trackingChange = payload;
  },
  // disableBtnAFSM: (state, value) => {
  //   state.disableBtnAFSM = value;
  // },
  progressVehAT: (state, payload) => {
    state.loadingTableInVehAT = payload;
  },
  showVehiclesAT: (state, payload) => {
    state.showVehiclesAT = payload;
  },
  progressTemplatesAT: (state, payload) => {
    state.loadingTableInTemplatesAT = payload;
  },
  fullVersion: (state, payload) => {
    state.fullVersion = payload;
  },
  showTemplates: (state, payload) => {
    state.showTemplates = payload;
  },

  //Función para llevar la plantilla dados sus datos recuperados del ws
  fillTemplate: (state, payload) => {
    state.Template.Name = payload.TemplateName;

    if (payload.PeriodicReports != null) {
      state.Template.PeriodicReports.OdometerReport = payload.PeriodicReports.OdometerReport;
      state.Template.PeriodicReports.FuelReport = payload.PeriodicReports.FuelReport;

      if (payload.PeriodicReports.VehicleStoppedReport != null) {
        state.Template.PeriodicReports.VehicleStoppedReport.Active = payload.PeriodicReports.VehicleStoppedReport.Active;
        state.Template.PeriodicReports.VehicleStoppedReport.Threshold = payload.PeriodicReports.VehicleStoppedReport.Threshold;
      }

      if (payload.PeriodicReports.VehicleInMotionReport != null) {
        state.Template.PeriodicReports.VehicleInMotionReport.Active = payload.PeriodicReports.VehicleInMotionReport.Active;
        state.Template.PeriodicReports.VehicleInMotionReport.Threshold = payload.PeriodicReports.VehicleInMotionReport.Threshold;
      }

      if (payload.PeriodicReports.TimeReport != null) {
        state.Template.PeriodicReports.TimeReport.Active = payload.PeriodicReports.TimeReport.Active;
        state.Template.PeriodicReports.TimeReport.Threshold = payload.PeriodicReports.TimeReport.Threshold;
      }
    }

    if (payload.Logistics != null) {
      state.Template.Logistics.HighIdlePercentage = payload.Logistics.HighIdlePercentage;
      state.Template.Logistics.ExcessIdleTime = payload.Logistics.ExcessIdleTime;
      state.Template.Logistics.InsufficientRestTime = payload.Logistics.InsufficientRestTime;
      state.Template.Logistics.RestDetected = payload.Logistics.RestDetected;
    }

    if (payload.Driving != null) {
      if (payload.Driving.RPMExcess != null) {
        state.Template.Driving.RPMExcess.Active = payload.Driving.RPMExcess.Active;
        state.Template.Driving.RPMExcess.Threshold = payload.Driving.RPMExcess.Threshold;
      }

      state.Template.Driving.QuickShutdown = payload.Driving.QuickShutdown;
      state.Template.Driving.ClutchTimeExcessWhileDriving = payload.Driving.ClutchTimeExcessWhileDriving;
      state.Template.Driving.ClutchTimeExcessStopped = payload.Driving.ClutchTimeExcessStopped;
      state.Template.Driving.ExcessBrakeTime = payload.Driving.ExcessBrakeTime;
      state.Template.Driving.SuddenAcceleration = payload.Driving.SuddenAcceleration;
      state.Template.Driving.SuddenBraking = payload.Driving.SuddenBraking;
      state.Template.Driving.MediumSpeeding = payload.Driving.MediumSpeeding;
      state.Template.Driving.SevereSpeeding = payload.Driving.SevereSpeeding;
    }

    if (payload.Operation != null) {
      if (payload.Operation.MotorLoadExcess != null) {
        state.Template.Operation.MotorLoadExcess.Active = payload.Operation.MotorLoadExcess.Active;
        state.Template.Operation.MotorLoadExcess.Threshold = payload.Operation.MotorLoadExcess.Threshold;
      }

      state.Template.Operation.LowCruiseControlPercentage = payload.Operation.LowCruiseControlPercentage;
      state.Template.Operation.LowFuelEconomy = payload.Operation.LowFuelEconomy;
      
      if (payload.Operation.PTOStopped != null) {
        state.Template.Operation.PTOStopped.Active = payload.Operation.PTOStopped.Active;
        state.Template.Operation.PTOStopped.Threshold = payload.Operation.PTOStopped.Threshold;
      }

      state.Template.Operation.HighAverageMotorLoad = payload.Operation.HighAverageMotorLoad;
      state.Template.Operation.StartOfPTOInMotion = payload.Operation.StartOfPTOInMotion;
      state.Template.Operation.EndOfPTOInMotion = payload.Operation.EndOfPTOInMotion;
    }
  },

  //Se limpia cada parametro de plantilla
  clearTemplate: (state) => {
    state.Template.Name = "";
    state.Template.Operation.EndOfPTOInMotion = "";
    state.Template.PeriodicReports.VehicleStoppedReport.Threshold = "";
    state.Template.PeriodicReports.VehicleInMotionReport.Threshold = "";
    state.Template.PeriodicReports.TimeReport.Threshold = "";
    state.Template.Logistics.HighIdlePercentage = "";
    state.Template.Logistics.ExcessIdleTime = "";
    state.Template.Logistics.InsufficientRestTime = "";
    state.Template.Logistics.RestDetected = "";
    state.Template.Driving.RPMExcess.Threshold = "";
    state.Template.Driving.ClutchTimeExcessWhileDriving = "";
    state.Template.Driving.ClutchTimeExcessStopped = "";
    state.Template.Driving.ExcessBrakeTime = "";
    state.Template.Driving.SuddenAcceleration = "";
    state.Template.Driving.SuddenBraking = "";
    state.Template.Driving.MediumSpeeding = "";
    state.Template.Driving.SevereSpeeding = "";
    state.Template.Operation.MotorLoadExcess.Threshold = "";
    state.Template.Operation.LowCruiseControlPercentage = "";
    state.Template.Operation.LowFuelEconomy = "";
    state.Template.Operation.PTOStopped.Threshold = "";
    state.Template.Operation.HighAverageMotorLoad = "";
    state.Template.Operation.StartOfPTOInMotion = "";
    state.Template.PeriodicReports.OdometerReport = false;
    state.Template.PeriodicReports.FuelReport = false;
    state.Template.PeriodicReports.VehicleStoppedReport.Active = false;
    state.Template.PeriodicReports.TimeReport.Active = false;
    state.Template.PeriodicReports.VehicleInMotionReport.Active = false;
    state.Template.Driving.RPMExcess.Active = false;
    state.Template.Driving.QuickShutdown = "";
    state.Template.Operation.MotorLoadExcess.Active = false;
  },
  
  contentVehAT: (state, payload) => {
    state.contentVehAT = payload;
  },
  loadingComparativeTable: (state, payload) => {
    state.loadingComparativeTable = payload;
  },
  selectedVehAT: (state, payload) => {
    state.selectedVehAT = payload;
  },
  progressForConfigP: (state, payload) => {
    state.loadingTableInConfigProgress = payload;
  },

  setTableContentAlertruckVehiclesInfo: (state, payload) => {
    state.itemsAlertruckVehiclesInfo = [];
    let dataFormatted = [];

    payload.forEach(vehicle => {
      dataFormatted.push({
        DeviceId: vehicle.DeviceId,
        AlertruckDataOnThisPeriod: vehicle.AlertruckDataOnThisPeriod == true ? i18n.t("yes") : "No"
      });
    });

    state.itemsAlertruckVehiclesInfo = dataFormatted;
    state.progressAlertruckVehiclesInfo = false;
  },
};